import React from "react";
import numeral from "numeral";
import moment from "moment";

import { toast } from "react-toastify";

import Select from "react-select";

import { Modal, Popover, OverlayTrigger } from "react-bootstrap";
import {
  Accordion,
  SenseAccordion,
  getPrettyNumber,
  Icon,
  ButtonGroup,
  Button,
  TileTitle,
  TileSubtitle,
  Tile,
  TileBody,
  TileItem
} from "aible";

import { PieChart, Pie, Cell } from "recharts";
import { AutoSizer } from "react-virtualized";

import JSONInput from "react-json-editor-ajrm";
import locale from "react-json-editor-ajrm/locale/en";

import { isEnabled } from "utils/featureFlags";
import { LineInput } from "components/Inputs/LineInput";
import Tooltip from "components/Inputs/Tooltip";

import { DATA_SOURCES, DATASET_REFRESH_RATE_OPTIONS } from "containers/SchemaMonitor/reducer";

import { AI_READINESS_BREAKPOINT, AI_READINESS_PREDICTOR_WARNING } from "containers/Setup/reducer";

import { WIDE_DATASET_COLUMN_COUNT } from "containers/Home/reducer";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBullseye,
  faTrash,
  faSyncAlt,
  faCheckCircle,
  faCircle,
  faChevronDown,
  faUser,
  faLink,
  faBell,
  faInfoCircle,
  faInfo,
  faCompressArrowsAlt,
  faExpandArrowsAlt,
  faExclamationTriangle,
  faCog,
  faPlus,
  faSave
} from "@fortawesome/free-solid-svg-icons";

import TriangleRed from "images/Sense-Icons/triangle_red.svg";
import TriangleGreen from "images/Sense-Icons/triangle_green.svg";

import NumberIcon from "images/EDG/123.svg";
import CategoryIcon from "images/EDG/abc.svg";
import DateIcon from "images/EDG/DateIcon.svg";
import NumberIconWhite from "images/EDG/123White.svg";
import CategoryIconWhite from "images/EDG/abcWhite.svg";
import DateIconWhite from "images/EDG/DateIconWhite.svg";

import FullPin from "images/Next-Icons/FullPinWhite.svg";
import EmptyPin from "images/Next-Icons/EmptyPinWhite.svg";
import InteractIcon from "images/InteractIcon.svg";

import JoinIcon from "images/Sense-Icons/JoinIcon.svg";
import AppendIcon from "images/Sense-Icons/AppendIcon.svg";
import DerivedIcon from "images/Sense-Icons/DerivedIcon.svg";
import FilterIcon from "images/Sense-Icons/FilterIcon.svg";
import CustomIcon from "images/Sense-Icons/CustomIcon.svg";
import IfElseIcon from "images/Sense-Icons/IfElse.svg";
import CodeIcon from "images/Sense-Icons/CodeIcon.svg";
import Code from "images/Sense-Icons/Code.svg";
import Paste from "images/Sense-Icons/Paste.svg";
import Sliders from "images/Sense-Icons/Sliders.svg";
import Sparkles from "images/Sense-Icons/Sparkles.svg";
import BanIcon from "images/Sense-Icons/ban-light.svg";
import PivotIcon from "images/Sense-Icons/angle-90-light.svg";
import DomoIcon from "images/domo-logo.svg";
import DataBricksIcon from "images/EDG/DB/databricks.png";

import datasetIcon from "images/tileIcons/dataset.svg";

import FullOuterIcon from "images/Sense-Icons/full-outer.svg";
import InnerJoinIcon from "images/Sense-Icons/inner-join.svg";
import LeftJoinIcon from "images/Sense-Icons/left-join.svg";
import LookupIcon from "images/Sense-Icons/lookup.svg";
import RightJoinIcon from "images/Sense-Icons/right-join.svg";

import LeftJoinIconGray from "images/left-join.svg";

import ClipboardIcon from "images/SenseIcons/clipboard.svg";
import GearsIcon from "images/SenseIcons/gears.svg";
import QuestionMarkIcon from "images/SenseIcons/question-mark.svg";

import ProblematicPredictors from "components/CreateWizard/Academic/ProblematicPredictors";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { TRANSFORM_TYPE_MAP } from "components/Dataset/Transform";
import { ReviewDatasetItem } from "components/CreateWizard/Academic/AcademicReviewDataset";
import { copyAndChangeDatasetSuccess, DATA_CHECKS } from "containers/Home/reducer";

import LeakageChartContainer from "containers/Next/Charts/LeakageChart";

import { LineageItem } from "components/Gallery/Lineage";
import SensePieChart from "components/Tiles/Sense/SensePieChart";
import SmallBarChart from "components/Tiles/Sense/SmallBarChart";
import { SmallDateChartOld as SmallDateChart } from "components/Tiles/Sense/SmallDateChart";
import SenseFooter from "components/Tiles/Sense/Footer/SenseFooter";
import ConditionListInput from "components/UnifiedProject/SelectData/ConditionListInput";

import Transform from "containers/Dataset/Transform";

import LineageContainer from "containers/Gallery/Lineage";

import HadoopIcon from "images/EDG/DB/HadoopIcon.svg";
import OracleIcon from "images/EDG/DB/oracle.svg";
import MySQLIcon from "images/EDG/DB/MYSQL.svg";
import PostgreSQLIcon from "images/EDG/DB/POSTGRES.svg";
import AWSIcon from "images/EDG/DB/AWS.svg";
import AzureIcon from "images/EDG/DB/AZURE.svg";
import SnowflakeIcon from "images/EDG/DB/snowflake.svg";
import TerradataIcon from "images/teradata 1.svg";
import MarketoIcon from "images/G/Marketo.svg";
import WhatIcon from "images/G/What.svg";

import BoomiIcon from "images/nConnectors/boomi.svg";

import SalesforceIcon from "images/G/Salesforce.svg";
import SapIcon from "images/G/Sap.svg";
import BellIcon from "images/bell-on-light.svg";

import SecureIcon from "images/SecureIcon.svg";
import SimpleIcon from "images/SimpleIcon.svg";
import EfficientIcon from "images/EfficientIcon.svg";
import GuidanceIcon from "images/GuidanceIcon.svg";

import CSVIcon from "images/csv_white.svg";
import CSVIconGray from "images/csv_light_grey.svg";
import CSVIconPurple from "images/csv.svg";

import PinnedIcon from "images/Sense-Icons/pinned-white.svg";
// import UnpinnedIcon from "images/Sense-Icons/unpinned-white.svg";
import UnpinnedIcon from "images/SenseIcons/thumbtack-regular.svg";
import PinnedHoverIcon from "images/Sense-Icons/unpin-white.svg";

import TargetIcon from "images/SenseIcons/bullseye-light 1.svg";
import CompassIcon from "images/SenseIcons/compass-light 1.svg";
import HeartIcon from "images/SenseIcons/heart-pulse-light 2.svg";
import RadarIcon from "images/SenseIcons/radar-light 1.svg";
import ToolsIcon from "images/SenseIcons/tools-light 2.svg";
import GearIcon from "images/SenseIcons/cog-light 2.svg";
import ClockIcon from "images/SenseIcons/clock-rotate-left-light 1.svg";
import TrashIcon from "images/SenseIcons/trash-regular.svg";
import ExpandIcon from "images/SenseIcons/arrows-maximize-regular.svg";

import NextClose from "images/Next-Icons/NextClose.svg";

import styles from "./style-sense.module.css";
import { RelationBuilder } from "utils/relation";
import * as Expressions from "types/expression";
import { ConditionUtils } from "types/condition";
import DatasetOptions from "components/UnifiedProject/SelectData/DatasetOptions";

function handlePlurals(count, value = "", noPlural = false) {
  return value + (noPlural || count === 1 ? "" : "s");
}

const VALIDATION_MESSAGES = [
  {
    message: ["too many values", "It would be discarded."],
    type: "high cardinality field",
    action: "would be ignored"
  },
  {
    message: ["It would be discarded."],
    type: "column",
    action: "would be ignored"
  },
  {
    message: ["missing values", "(", ")"],
    type: "column",
    count: 0,
    action: "with missing values would be updated"
  },
  {
    message: ["too many values", "most informative values", "flagged and included in the modeling step"],
    type: "high cardinality field",
    action: "would be updated"
  }
];

function checkMessage(message, checkArr) {
  for (let i = 0; i < checkArr.length; i++) {
    if (!message.toLowerCase().includes(checkArr[i].toLowerCase())) {
      return false;
    }
  }
  return true;
}

function parseValidation(updatedColumns) {
  const retValidation = VALIDATION_MESSAGES.map((validation) => ({
    ...validation,
    value: []
  }));
  const extra = {
    type: "column",
    action: "would be updated for other reasons",
    value: []
  };
  updatedColumns.forEach((col) => {
    let found = false;
    const message = col.metadata && col.metadata.message ? col.metadata.message : col.message;

    for (let i = 0; i < retValidation.length; i++) {
      if (!found && checkMessage(message, retValidation[i].message)) {
        retValidation[i].value.push(message);
        found = true;
        if (retValidation) break;
      }
    }
    if (!found) {
      extra.value.push(message);
    }
  });
  if (retValidation.length < 1) {
    extra.action = "would be updated";
  }
  retValidation.push(extra);
  return retValidation.filter((elem) => elem.value.length);
}

function outcomeOptionFormatter(option, meta) {
  const isSelected =
    meta?.selectValue?.length > 0 && meta.selectValue.find((selectedOption) => selectedOption.value === option.value);
  const ICONS = {
    date: isSelected ? DateIconWhite : DateIcon,
    categorical: isSelected ? CategoryIconWhite : CategoryIcon,
    number: isSelected ? NumberIconWhite : NumberIcon
  };
  const isMenu = meta?.context === "menu";
  const optionIcon = ICONS[option?.type];
  return (
    <div className={styles.outcomeSelectOption}>
      <div>{option?.label}</div>
      {optionIcon && isMenu ? (
        <img src={optionIcon} style={{ marginLeft: "auto", width: "20px" }} title={option?.type} />
      ) : (
        <React.Fragment />
      )}
    </div>
  );
}

const INSIGHT_THRESHOLD = 0;

export default class Sense extends React.PureComponent {
  constructor(props) {
    super(props);

    const isHideOverview = localStorage ? localStorage.getItem("isHideOverview") : false;

    let pinnedDatasets = {};
    if (localStorage) {
      const storedPinnedDatasets = localStorage.getItem("sensePinnedDatasets");

      if (storedPinnedDatasets !== undefined) {
        pinnedDatasets = JSON.parse(storedPinnedDatasets);
      }
    }

    this.state = {
      datasetOutcomes: {},
      viewAllPredictors: {},
      exploredDatasets: {},
      selectedDateFields: {},
      selectedDateValues: {},
      selectedDateFilterValues: {},
      renameDatasets: {},
      isLoadingRename: {},
      isLoadingExplore: {},
      isLoadingCreateAI: {},
      isLoadingRetarget: {},
      outcomeSuccess: {},
      isOpenTile: {},
      isTileOpacity: {},
      joinData: {},
      customTransforms: {},
      filterData: {},
      transformDataName: {},
      replayTransform: {},
      ignoredActions: {},
      modifyFields: {},
      isShowDerived: {},
      autoTransformLabels: {},
      expandedDataset: undefined,
      pinnedDatasets: pinnedDatasets,
      showTerminalModal: false,
      isIdColumns: false,
      isHideOverview: isHideOverview
    };
  }

  updateIsHideOverview(isHideOverview) {
    if (localStorage) {
      localStorage.setItem("isHideOverview", isHideOverview);
    }

    return this.setState({ isHideOverview: isHideOverview });
  }

  render() {
    const {
      data,
      isDataUploading,
      updateIsLinkMode,
      updateIsSchemaLinkMode,
      updateIsBoomiLinkMode,
      handleTableauUpload,
      isTableauMode,
      isTabUploading,
      uploadCSV
    } = this.props;

    const { pinnedDatasets, expandedDataset, prepExpandedDataset, isOpenTransform } = this.state;

    const iconHeight = "100px";
    const iconMaxWidth = "75px";

    const retData = data;

    // We can actually set this by the width of the screen!
    // Maybe we use the autosizer to get the width?
    const NUM_COLUMNS = isTableauMode ? 1 : 3;

    const dataByColumn = [];
    for (let i = 0; i < NUM_COLUMNS; i++) {
      dataByColumn[i] = [];
    }

    retData.forEach((d, i) => {
      let columnIndex = i % NUM_COLUMNS;
      dataByColumn[columnIndex].push(d);
    });

    const transformDataset = isOpenTransform === undefined ? undefined : this.getDatasetFromId(isOpenTransform);
    const historyUpdates =
      isOpenTransform === undefined
        ? []
        : this.getReplayUpdates(transformDataset, transformDataset?.transformations?.query);
    const pendingUpdates =
      isOpenTransform === undefined
        ? []
        : this.getReplayUpdates(transformDataset, this.getTransformQuery(transformDataset)?.query);

    let preHistoryActions = [
      {
        label: "Dataset Created From AWS Upload",
        subItem: transformDataset?.label,
        icon: datasetIcon,
        badDate: transformDataset?.created
      }
    ];

    if (transformDataset?.outcome !== undefined) {
      preHistoryActions.push({
        label: "Latest Exploratory Analysis Conducted",
        subItem: "Exploring: " + transformDataset?.outcome,
        icon: TargetIcon,
        badDate: transformDataset?.updated_date
      });
    }

    return (
      <div className={styles.sense}>
        <div className={styles.senseTilesHolder}>
          {retData.map((dataset, i) => this.renderSenseTile(dataset?.id, dataset))}
        </div>
      </div>
    );
  }

  renderShowMore() {
    const { fetchNextDatasets, isDatasetsLoading } = this.props;

    return (
      <div className={styles.showMore}>
        {!isDatasetsLoading && fetchNextDatasets && (
          <div className={styles.showHolder}>
            <a className={styles.showMoreLink} onClick={() => fetchNextDatasets()}>
              {"Show More"}
            </a>
          </div>
        )}
        {isDatasetsLoading && (
          <div className={styles.lHolder}>
            <LoadingIndicator style={{ margin: "0px" }} />
          </div>
        )}
      </div>
    );
  }

  getAiReadinessMessage(dataset) {
    const outcome = dataset?.outcome ?? "the outcome's";
    const predictors = dataset?.aiReadyMetrics?.aiReady;
    const aiStatus = dataset?.aiReadyMetrics?.aiReadinessStatus;

    const isLowPredictors =
      (dataset?.aiReadyMetrics?.aiReady?.length || 0) + (dataset?.aiReadyMetrics?.secondOrder?.length || 0) <=
      AI_READINESS_PREDICTOR_WARNING.count;
    switch (aiStatus) {
      case "NO_SIGNAL":
        return "Please Collect More Data";
      case "LOW_SIGNAL":
        if (predictors?.length >= AI_READINESS_PREDICTOR_WARNING.count) {
          let lowPredictorsCount = 0;
          predictors?.forEach((p) => {
            if (p.value < AI_READINESS_PREDICTOR_WARNING.value) {
              lowPredictorsCount++;
            }
          });
          if (lowPredictorsCount >= AI_READINESS_PREDICTOR_WARNING.count) {
            return "Data Readiness Low, but still better than guessing. Proceed with caution. Many weak predictors found. More data may help.";
          }
        }

        return "Data Readiness Low, but still better than guessing. Proceed with caution. More data may help.";
      case "HIGH_SIGNAL":
        if (isLowPredictors) {
          return `Data Readiness Passed, but adding more variables will be helpful.`;
        }
        return "Data Readiness Passed";
      case "SUSPECT_SIGNAL":
        return `Data Readiness may be too high. Remove fields that are known only after ${outcome} status has been decided.`;
      default:
        return "No Data Readiness Metrics Found";
    }
  }

  renderAIReadinessTooltip(dataset, isOnlyInfoCircle = false) {
    const aiStatus = dataset?.aiReadyMetrics?.aiReadinessStatus;
    const isWarning = aiStatus !== "LOW_SIGNAL" && aiStatus !== "HIGH_SIGNAL";
    const outcome = dataset?.outcome;
    return (
      <div className={isOnlyInfoCircle === false ? styles.aireadinessTitle : ""}>
        {isOnlyInfoCircle !== true && <div>{"Data Readiness"}</div>}
        <div onClick={(e) => e.stopPropagation()}>
          <OverlayTrigger
            placement="top"
            trigger={["hover"]}
            rootClose
            overlay={
              <Popover
                id="popover-positioned-top"
                title={<strong style={{ fontSize: "13px" }}>{"What Does Data Readiness Mean?"}</strong>}
              >
                <div className={styles.aiReadinessOverlay}>
                  <div className={styles.aiReadinessBody}>
                    <strong>{"If you are analyzing data, "}</strong>
                    <span>{`the data readiness indicates whether charts that you draw are likely to be statistically sound. For example, a chart may look visually very interesting because the average ${
                      outcome ?? "outcome"
                    } is significantly different, but if the standard deviation is significantly greater than the difference in averages, the chart might mislead you.`}</span>
                  </div>
                  <div className={styles.aiReadinessBody}>
                    <strong>{"If you are creating a predictive model, "}</strong>
                    <span>
                      {`data readiness > 0 means the model is better than random chance. The readiness is adjusted for skewed data. Any score above ${
                        AI_READINESS_BREAKPOINT.NO_SIGNAL * 10
                      } is potentially useful, above ${
                        AI_READINESS_BREAKPOINT.LOW_SIGNAL * 10
                      } is likely useful and above ${
                        AI_READINESS_BREAKPOINT.HIGH_SIGNAL * 10
                      } may be too good to be true.`}
                    </span>
                  </div>
                  <div className={styles.aiReadinessBody}>{"The readiness is adjusted for skewed data."}</div>
                </div>
              </Popover>
            }
          >
            <div className={styles.aireadinessIcon + " " + styles.isInfo}>
              <FontAwesomeIcon icon={faInfo} />
            </div>
          </OverlayTrigger>
        </div>
      </div>
    );
  }

  handleReindex(dataset) {
    const { reindexDataset } = this.props;

    if (!dataset.stack_id) {
      return reindexDataset(dataset?.id);
    } else {
      toast("There is currently an operation in progress on this dataset. Please try again in 5 minutes.", {
        type: toast.TYPE.ERROR,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 7500
      });
    }
  }

  renderShell(dataset) {
    const isShell = dataset.status_name == "NOT_STARTED" && dataset.labels.length == 0 && dataset.stack_id == null;
    const noFileError =
      dataset &&
      dataset.errors &&
      dataset.errors.find((record) => record.message === "Didn't detect properly as a CSV!");

    const inProgress = Boolean(dataset.stack_id);

    const splitUrl = dataset.source.url.split("/");

    const uploadId = splitUrl[splitUrl.length - 2];
    const uploadUrl = `${window.location.origin}/upload/${uploadId}`;

    return (
      <div className={styles.senseAll}>
        <div className={styles.openOverview} style={{ zIndex: 10 }}>
          <div className={styles.shellTitle}>
            <div className={styles.sIcon}>
              <FontAwesomeIcon icon={faBell} style={{ color: "rgb(200, 202, 212)" }} />
            </div>
            <div style={{ fontWeight: "bold" }}>
              {noFileError
                ? "No file has been uploaded. Please upload a file and try refreshing the tile"
                : "This is a placeholder dataset. Please upload your data and refresh"}
            </div>
          </div>

          <div className={styles.shellUrlWrapper}>
            <div className={styles.shellUrlTitle}>{"Dataset Upload URL:"}</div>
            <a href={uploadUrl} target="_blank" rel="noreferrer">
              {uploadUrl}
            </a>
          </div>

          <div style={{ marginTop: "20px" }}>
            <Button onClick={() => this.handleReindex(dataset)} disabled={inProgress}>
              {"Refresh Data"}
            </Button>
          </div>

          {/* {dataset?.errors?.length ? (
        <div className={styles.shellUrlErrors}>
          {dataset.errors?.find(e => e.message !== "Didn't detect properly as a CSV!") ? (
            <React.Fragment>
              <div className={styles.shellUrlErrorsTitle}>
                {"Errors"}
              </div>
              <ul>
              {dataset.errors &&
                dataset.errors?.filter(e => e.message !== "Didn't detect properly as a CSV!").map((error, i) => {
                  const errorMessage = error.message
                    ? error.message === "Didn't detect properly as a CSV!"
                      ? "No file has been uploaded. Please upload a file and try refreshing the tile"
                      : error.message
                    : error;
                  return (
                    <li
                      className={styles.oField}
                      key={error && error.message + " " + i}
                    >
                      {errorMessage}
                    </li>
                  );
                })}
              </ul>
            </React.Fragment>
            ) : <React.Fragment />}
          <div className={styles.oField}>
            <div className={styles.oSubfield}>
              {"Dataset ID: " + (dataset && dataset.id)}
            </div>
            {dataset && dataset.source ? (
              <div className={styles.oSubfield}>
                {"Source URL: " + dataset.source.url}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : <React.Fragment />} */}
        </div>
      </div>
    );
  }

  renderTabUploadSenseTile() {
    const tileHeaderBackground = "#C8CAD4";
    const isBoomi = false;
    const isPinned = false;

    return (
      <div className={styles.senseTile} id={"dataset_tableau"}>
        <div className={styles.tileHeader} style={{ background: tileHeaderBackground, color: "#4B495B" }}>
          <div className={styles.tFlex}>
            <img
              src={CSVIconGray}
              style={{
                height: "30px",
                width: "30px",
                marginRight: "5px",
                background: "transparent"
              }}
            />
            <div style={{ width: "100%" }}>
              <div>
                <span>{"TABLEAU"}</span>
                <span style={{ marginLeft: "5px" }} title={moment.utc().local().format("MMMM Do YYYY, h:mm:ss a")}>
                  {moment.utc().local().fromNow()}
                </span>
              </div>
              <div className={styles.tileHeaderLarge} style={isPinned ? { maxWidth: "90%" } : {}}>
                {"Importing Data..."}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.tileBody}>
          <div className={styles.senseAll}>
            <div className={styles.openOverview} style={{ zIndex: 10, width: "100%" }}>
              <LoadingIndicator />
              <div className={styles.senseTitle} style={{ justifyContent: "center" }}>
                {"Importing Data from Tableau Workbook"}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderSenseTile(key, dataset, isFullScreen = false) {
    const { history, handleDelete, updateIsBoomiLinkMode, isTableauMode, handleClick } = this.props;
    const { expandedDataset, oldScrollLeft, oldScrollTop } = this.state;

    const activeTab = this.state[key] || "ALL";

    const bStyle = { fontSize: "11px", padding: "4px" };

    const aiScore = (dataset?.aiReadyMetrics?.aiReadinessScore ?? 0) * 10;
    const aiStatus = dataset?.aiReadyMetrics?.aiReadinessStatus;

    const isError = dataset?.dataset_status === "ERROR";
    const isWideDatasetWarning = dataset?.wideDatasetWarning;
    const isReady = dataset?.rowCount !== -1 && aiStatus !== "NO_SIGNAL";
    const dCount = dataset?.suggested_features_count ?? 0;
    const isProcessing = dataset?.status_name !== "DONE";

    const isShell = dataset.status_name == "NOT_STARTED" && dataset.labels.length == 0 && dataset.stack_id == null;
    const noFileError =
      isError &&
      dataset &&
      dataset.errors &&
      dataset.errors.find((record) => record.message === "Didn't detect properly as a CSV!");

    const isBoomi = dataset?.source?.content?.provider === "BOOMI";

    const retLabel =
      isBoomi !== true || dataset?.label === undefined ? dataset?.label : dataset?.label.replace(".csv", "");

    const isButtonsDisabled = isProcessing && isReady !== true;

    const predictors = dataset?.aiReadyMetrics?.aiReady;

    const isGray = aiScore < AI_READINESS_BREAKPOINT.NO_SIGNAL * 10 || isWideDatasetWarning;

    const isPinned = this.state?.pinnedDatasets?.[dataset?.id] !== undefined;

    const csvDataSource = DATA_SOURCES.find((source) => source?.value === "CSV");
    let datasetIconWhite = csvDataSource?.iconWhite ?? CSVIcon;
    let datasetIconGray = csvDataSource?.iconGray ?? CSVIconGray;
    let datasetTypeLabel = csvDataSource?.shortLabel ?? csvDataSource?.label;
    if (dataset?.source?.content?.type === "CONNECTION_METADATA") {
      const datasetSource = DATA_SOURCES.find((source) => source?.value === dataset?.source?.content?.provider);
      datasetIconWhite = datasetSource?.iconWhite ?? datasetSource?.image ?? datasetIconWhite;
      datasetIconGray = datasetSource?.iconGray ?? datasetSource?.image ?? datasetIconGray;
      datasetTypeLabel = datasetSource?.shortLabel ?? datasetSource?.label ?? datasetTypeLabel;
    }

    const tileHeaderBackground = isGray ? "#C8CAD4" : isError ? "#C03E5A" : isReady ? "#34d399" : "#C8CAD4";

    return (
      <div className={isFullScreen ? styles.senseTileFullScreen : styles.senseTile} id={"dataset_" + dataset?.id}>
        <div className={styles.tileBody}>
          {isShell || noFileError ? (
            this.renderShell(dataset)
          ) : (
            <React.Fragment>
              <div className={styles.senseSection}>{this.renderAll(key, dataset)}</div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }

  renderRename(dataset) {
    const { changeDatasetName } = this.props;
    const { renameDatasets, isLoadingRename } = this.state;

    const dataRename = renameDatasets?.[dataset?.id];
    const isLoading = isLoadingRename?.[dataset?.id] === true;

    return (
      <div className={styles.settings}>
        <div className={styles.settingsSection}>
          <div>{"Dataset Name"}</div>
          <div>
            <LineInput
              isSenseBox
              value={dataRename !== undefined ? dataRename : dataset?.label}
              onChange={(val) => {
                const retRenameDatasets = {
                  ...renameDatasets,
                  [dataset?.id]: val
                };

                this.setState({ renameDatasets: retRenameDatasets });
              }}
              onFocus={() => {
                if (dataRename === undefined) {
                  const retRenameDatasets = {
                    ...renameDatasets,
                    [dataset?.id]: dataset?.label
                  };

                  this.setState({ renameDatasets: retRenameDatasets });
                }
              }}
            />
          </div>
          {isLoading === true ? (
            <LoadingIndicator />
          ) : dataRename !== undefined ? (
            <div className={styles.settingsButtons}>
              <Button
                onClick={(val) => {
                  const retRenameDatasets = {
                    ...renameDatasets,
                    [dataset?.id]: undefined
                  };

                  this.setState({ renameDatasets: retRenameDatasets });
                }}
              >
                {"Cancel"}
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  changeDatasetName(dataset?.id, dataRename);

                  this.setState({
                    isLoadingRename: {
                      ...this.state.isLoadingRename,
                      [dataset?.id]: true
                    }
                  });

                  setTimeout(
                    () =>
                      this.setState({
                        isLoadingRename: {
                          ...this.state.isLoadingRename,
                          [dataset?.id]: undefined
                        },
                        renameDatasets: {
                          ...this.state.renameDatasets,
                          [dataset?.id]: undefined
                        }
                      }),
                    2000
                  );
                }}
              >
                {"Apply"}
              </Button>
            </div>
          ) : (
            <div />
          )}
        </div>
        <div className={styles.settingsBot} style={{ marginTop: "20px" }}>
          <div>{"Created By"}</div>
          <div className={styles.settingsSub}>
            {dataset?.created_by?.fullname +
              ", " +
              moment.utc(dataset.created).local().format("MMMM Do YYYY, h:mm:ss a")}
          </div>
        </div>
      </div>
    );
  }

  renderReviewRecommendations(dataset, isReadinessSection) {
    const { openCreateModels } = this.props;
    const { isLoadingExplore, outcomeSuccess } = this.state;

    const dCount = dataset?.suggested_features_count ?? 0;

    const outcomeOptions =
      dataset?.fields?.[dataset?.outcome]?.type !== "number" && dataset?.fields?.[dataset?.outcome]?.data
        ? dataset?.fields?.[dataset?.outcome]?.data.map((d) => ({
            value: d,
            label: d.value
          }))
        : undefined;

    const outcomeValue = outcomeSuccess?.[dataset?.id] || outcomeOptions?.[0];

    return (
      <div className={styles.derivedFields}>
        <Transform id={dataset?.id} setupId={dataset?.id} isManual isSense />
        {/*

        {isEnabled("new-sense") ? (
          <div />
        ) : isEnabled("aible-optimize") ? (
          <div className={styles.upgrade}>
            <div className={styles.revBot}>
              <div className={styles.revBotButton}>
                {outcomeOptions && (
                  <div className={styles.revBotSelect}>
                    <div className={styles.revBotLabel}>
                      {`${dataset?.target} is:`}
                    </div>
                    <Select
                      options={outcomeOptions}
                      value={outcomeValue}
                      onChange={(val) =>
                        this.setState({
                          outcomeSuccess: {
                            ...this.state.outcomeSuccess,
                            [dataset?.id]: val,
                          },
                        })
                      }
                      menuPlacement={"top"}
                    />
                  </div>
                )}
                <Button
                  style={{ marginLeft: "10px" }}
                  onClick={() => openCreateModels(dataset?.id, outcomeValue)}
                >
                  {"Create AI With These Derived Fields"}
                </Button>
              </div>
              <div style={{ marginTop: "10px" }}>
                <span style={{ fontWeight: "bold" }}>{"Note"}</span>
                <span>
                  {
                    ": Your data will not change, this creates a new AI analysis in Aible Optimize"
                  }
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.upgrade}>
            {
              "Please get Aible Optimize if you want your AI to automatically benefit from these derived fields"
            }
          </div>
        )}
        */}
      </div>
    );
  }

  renderAuto(dataset) {
    const { addDataTransform, removeDataTransform, allTransforms } = this.props;
    const { autoTransformLabels } = this.state;

    const existingTransforms = allTransforms?.[dataset?.id] || [];

    const dCount =
      dataset?.suggested_features?.reduce((acc, field) => {
        const fieldOptions = field?.choices?.filter((c) => TRANSFORM_TYPE_MAP[c.type] !== undefined);
        return acc + (fieldOptions?.length ?? 0);
      }, 0) ?? 0;

    // const dCount = dataset?.suggested_features_count ?? 0;

    return (
      <div className={styles.autoFields}>
        <div className={styles.aBody}>
          {dataset &&
            dataset.suggested_features &&
            dataset.suggested_features.map((field, i) => {
              const transformChoices =
                field && field.choices && field.choices.filter((c) => TRANSFORM_TYPE_MAP[c.type] !== undefined);

              if (!transformChoices?.length) {
                return <React.Fragment />;
              }

              const name =
                field && field.choices && field.choices.length > 0 ? field.choices[0].variable : "Field Name";

              const hasChoices =
                field &&
                field.choices &&
                field.choices
                  .filter((c) => TRANSFORM_TYPE_MAP[c.type] !== undefined)
                  .filter((c, j) => {
                    const isChecked = existingTransforms.find((col) => col.variable === name && col.type === c.type);
                    return isChecked;
                  }).length > 0;

              return isEnabled("aible-optimize") ? (
                <div className={styles.nonFlex} style={{ marginBottom: "20px" }}>
                  <div>
                    <div className={styles.pFlex}>
                      <div className={styles.aCol} style={{ fontWeight: "bold", flexGrow: 1 }}>
                        {name}
                      </div>
                      {hasChoices && (
                        <div
                          className={styles.bCol}
                          style={{
                            minWidth: "90px",
                            fontWeight: "bold",
                            textAlign: "center"
                          }}
                        >
                          {"Filter Original"}
                        </div>
                      )}
                      {hasChoices && (
                        <div className={styles.bCol} style={{ fontWeight: "bold" }}>
                          {"New Field Label"}
                        </div>
                      )}
                    </div>
                    {transformChoices.map((c, j) => {
                      const isChecked = existingTransforms.find((col) => col.variable === name && col.type === c.type);

                      return (
                        <div className={styles.flexRow} style={{ height: "35px" }}>
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() =>
                              isChecked ? removeDataTransform(dataset?.id, c) : addDataTransform(dataset?.id, c)
                            }
                            style={{
                              marginRight: "5px",
                              marginTop: "-1px"
                            }}
                          />
                          <div className={styles.derivedType}>{TRANSFORM_TYPE_MAP[c.type] || c.type}</div>
                          {isChecked && (
                            <div className={styles.dRemove}>
                              <input
                                type="checkbox"
                                checked={dataset?.ignored[name]}
                                onClick={() =>
                                  this.handleAddIgnoreFilter(
                                    dataset,
                                    name,
                                    dataset?.ignored?.[name] === true ? false : true
                                  )
                                }
                              />
                            </div>
                          )}
                          {isChecked && (
                            <div className={styles.derivedName}>
                              <LineInput
                                value={
                                  autoTransformLabels?.[dataset?.id]?.[c?.variable + "_" + c?.type] ||
                                  c?.variable + "_" + c?.type
                                }
                                onChange={(val) =>
                                  this.setState({
                                    autoTransformLabels: {
                                      ...autoTransformLabels,
                                      [dataset?.id]: {
                                        ...autoTransformLabels?.[dataset?.id],
                                        [c?.variable + "_" + c?.type]: val
                                      }
                                    }
                                  })
                                }
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div key={i}>
                  <div className={styles.aRow} style={{ marginTop: "20px" }}>
                    <div className={styles.aCol} style={{ fontWeight: "bold" }}>
                      {name}
                    </div>
                    <div className={styles.aCol}></div>
                  </div>
                  <ul>
                    {transformChoices.map((c, j) => {
                      const isChecked = existingTransforms.includes(JSON.stringify(c));

                      return (
                        <li>
                          {/*
                                TODO: Hook up derived variables
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() =>
                                  isChecked
                                    ? removeDataTransform(c)
                                    : addDataTransform(c)
                                }

                                style={{
                                  marginRight: "5px",
                                  marginTop: "-1px",
                                }}
                              />
                              */}
                          {TRANSFORM_TYPE_MAP[c.type] || c.type}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
        </div>
      </div>
    );
  }

  renderTileActions(dataset) {
    const {
      history,
      openExploration,
      openDashboard,
      openCreateModels,
      openDataset,
      handleDelete,
      copyAndChangeDatasetSuccess,
      isTableauMode
    } = this.props;

    const { isLoadingExplore, isLoadingCreateAI, outcomeSuccess } = this.state;

    const {
      dateFieldOptions,
      dateField,
      dateValue,
      dateFilterValue,
      dateRowsExcluded,
      dateRowsBefore,
      dateFieldMax,
      dateRowsAfter,
      dateAnalysisTarget
    } = this.calculateDateValues(dataset);

    const isReady = dataset?.rowCount !== -1;
    const isProcessing = dataset?.status_name !== "DONE";
    const dCount = dataset?.suggested_features_count ?? 0;
    const isError = dataset?.dataset_status === "ERROR";
    const isContinuous = dataset?.fields[dataset?.outcome]?.type === "number";

    const showActions = dataset?.outcome !== undefined && isReady;

    const showTransformActions = true || (isError !== true && isProcessing !== true);

    // const outcomeOptions =
    //   dataset?.fields?.[dataset?.outcome]?.type !== "number" &&
    //   dataset?.fields?.[dataset?.outcome]?.data
    //     ? dataset?.fields?.[dataset?.outcome]?.data.map((d) => ({
    //         value: d,
    //         label: d.value,
    //       }))
    //     : undefined;

    const outcomeOptions =
      dataset?.fields?.[dataset?.outcome]?.type !== "number" && dataset?.fields?.[dataset?.outcome]?.data
        ? dataset?.datasetSuccessOptions?.map((o) => ({
            value: o,
            label: o.label
          }))
        : undefined;

    const outcomeValue =
      outcomeSuccess?.[dataset?.id] ||
      outcomeOptions?.find((o) => o?.value?.value === dataset?.defaultSuccess) ||
      outcomeOptions?.[0];

    const showReevaluate = dataset?.isMulticategorical && outcomeValue?.value?.value !== dataset?.defaultSuccess;

    if (isError) {
      return (
        <div
          className={styles.openOverview}
          style={{
            maxHeight: "500px",
            width: "100%",
            overflow: "hidden",
            marginLeft: "10px"
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Button onClick={() => handleDelete(dataset?.id)}>{"Delete Evaluation"}</Button>
          </div>
        </div>
      );
    }

    if (!(isEnabled("aible-optimize") || isEnabled("aible-explore"))) {
      return <React.Fragment />;
    }

    return (
      <div
        className={styles.openOverview}
        style={{
          maxHeight: "500px",
          width: "100%",
          overflow: "show",
          marginLeft: "10px"
        }}
      >
        <div className={styles.senseActionsBody} style={{ flexDirection: "row" }}>
          {isContinuous ? (
            <React.Fragment>
              <span style={{ whiteSpace: "pre" }}>{"How would you like to proceed with "}</span>
              <strong style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" }}>
                {dataset?.outcome}
              </strong>
              <span style={{ whiteSpace: "pre" }}>{"?"}</span>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <span style={{ whiteSpace: "pre" }}>{"What outcome of "}</span>
              <strong style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" }}>
                {dataset?.outcome}
              </strong>
              <span style={{ whiteSpace: "pre" }}>{" would you like to proceed with?"}</span>
            </React.Fragment>
          )}
        </div>
        <div className={styles.dButtons} style={outcomeOptions === undefined ? { justifyContent: "center" } : {}}>
          {outcomeOptions?.length > 0 && (
            <div className={styles.oSelect} style={{ marginBottom: "8px" }}>
              <Select
                options={outcomeOptions}
                value={outcomeValue}
                onChange={(val) =>
                  this.setState({
                    outcomeSuccess: {
                      ...this.state.outcomeSuccess,
                      [dataset?.id]: val
                    }
                  })
                }
                menuPlacement={"top"}
              />
            </div>
          )}
          <ButtonGroup style={{ marginLeft: "10px" }}>
            {showReevaluate ? (
              <React.Fragment>
                <Button
                  onClick={() => {
                    this.setState({
                      outcomeSuccess: {
                        ...this.state.outcomeSuccess,
                        [dataset?.id]:
                          outcomeOptions?.find((o) => o?.value?.value === dataset?.defaultSuccess) ||
                          outcomeOptions?.[0]
                      }
                    });
                  }}
                >
                  {"Cancel"}
                </Button>
                <Button
                  onClick={() => {
                    const promiseHelper = () => {
                      let outcomeSuccess = { ...this.state.outcomeSuccess };
                      outcomeSuccess[dataset?.id] = undefined;
                      this.setState({
                        outcomeSuccess: outcomeSuccess
                      });
                    };
                    copyAndChangeDatasetSuccess(dataset?.id, this.state.outcomeSuccess[dataset?.id]?.value?.value)
                      .then(promiseHelper)
                      .catch(promiseHelper);
                  }}
                  type={"primary"}
                >
                  {"Create New Data Analysis"}
                </Button>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {(isEnabled("aible-optimize") || isEnabled("aible-explore") || Boolean(isTableauMode)) && (
                  <Tooltip
                    trigger={
                      (dateValue || dateFilterValue) &&
                      dateRowsBefore !== dateFieldMax &&
                      (dateAnalysisTarget === "EXPLORE" || dateAnalysisTarget === "BOTH")
                        ? ["hover"]
                        : []
                    }
                    overlay={
                      <div className={styles.dateFieldTooltip}>
                        {`Your exploration will be created using the ${dateRowsBefore} rows` +
                          (dateFilterValue && dateRowsExcluded > 0 ? ` after ${dateFilterValue?.value}` : "") +
                          (dateFilterValue && dateRowsExcluded > 0 && dateValue && dateRowsAfter > 0 ? ` and ` : "") +
                          (dateValue && dateRowsAfter > 0
                            ? ` before ${dateValue?.value} and will compare them to the ${dateRowsAfter} rows after ${dateValue?.value}`
                            : "")}
                      </div>
                    }
                  >
                    <Button
                      onClick={() => {
                        this.setState({
                          isLoadingExplore: {
                            ...isLoadingExplore,
                            [dataset?.id]: true
                          }
                        });

                        setTimeout(
                          () =>
                            openExploration(
                              dataset?.id,
                              outcomeValue,
                              dateAnalysisTarget === "EXPLORE" || dateAnalysisTarget === "BOTH"
                                ? {
                                    dateField: dateField?.label,
                                    dateValue: dateValue?.value,
                                    dateFilterValue: dateFilterValue?.value
                                  }
                                : undefined
                            )
                              .then(() => {
                                this.setState({
                                  isLoadingExplore: {
                                    ...this.state.isLoadingExplore,
                                    [dataset?.id]: false
                                  }
                                });
                              })
                              .catch((e) => {
                                console.log(e);
                                this.setState({
                                  isLoadingExplore: {
                                    ...this.state.isLoadingExplore,
                                    [dataset?.id]: false
                                  }
                                });
                              }),
                          5
                        );
                      }}
                      style={{ minWidth: "131px", minheight: "40px" }}
                    >
                      {isLoadingExplore?.[dataset?.id] === true ? (
                        <React.Fragment>
                          <LoadingIndicator
                            color={"#333"}
                            style={{
                              height: "13px",
                              width: "13px",
                              margin: "0px",
                              position: "absolute",
                              transform: "scale(0.4)",
                              top: "0px",
                              left: "8px"
                            }}
                          />
                          <span style={{ marginLeft: "28px" }}>{"Starting Exploration..."}</span>
                        </React.Fragment>
                      ) : (
                        "Explore Insights"
                      )}
                    </Button>
                  </Tooltip>
                )}
              </React.Fragment>
            )}
          </ButtonGroup>
        </div>
      </div>
    );
  }

  renderAll(key, dataset) {
    const { history, openExploration, openCreateModels, openDataset, handleDelete } = this.props;
    const { isLoadingExplore, isLoadingCreateAI, outcomeSuccess } = this.state;

    const isReady = dataset?.rowCount !== -1;
    const isProcessing = dataset?.status_name !== "DONE";
    const dCount = dataset?.suggested_features_count ?? 0;
    const isError = dataset?.dataset_status === "ERROR";

    const isWideDatasetWarning = dataset?.wideDatasetWarning;

    const showActions = dataset?.outcome !== undefined && isReady && !isWideDatasetWarning;

    const showTransformActions = true || (isError !== true && isProcessing !== true);

    const outcomeOptions =
      dataset?.fields?.[dataset?.outcome]?.type !== "number" && dataset?.fields?.[dataset?.outcome]?.data
        ? dataset?.fields?.[dataset?.outcome]?.data.map((d) => ({
            value: d,
            label: d.value
          }))
        : undefined;

    const outcomeValue = outcomeSuccess?.[dataset?.id] || outcomeOptions?.[0];

    if (isError) {
      return (
        <div className={styles.senseAll}>
          {this.renderOverviewError(dataset)}
          {this.renderDataFormatting(dataset)}
          {this.renderTroubleShootingTips(dataset)}
          {this.renderErrorAdvanced(dataset)}
          {showTransformActions && isEnabled("sense-transformations") && this.renderLineage(dataset, true)}
        </div>
      );
    }

    return (
      <div className={styles.senseAll}>
        {isError !== true && this.renderOutcomeTile(dataset)}
        {showActions && isError !== true && this.renderAIReadiness(dataset)}
        {showActions && isError !== true && this.renderMiniInsights(dataset)}
        {isError !== true && isWideDatasetWarning && !isProcessing && this.renderWideDatasetWarning(dataset)}
        {isError && this.renderOverviewError(dataset)}
        {this.renderDataEvaluated(dataset, showActions)}
        {this.renderDataValidation(dataset)}
        {showActions && isError !== true && this.renderTileActions(dataset)}
      </div>
    );
  }

  // Lol Join reducer. TODO: Real Join reduccer
  updateJoinData(datasetId, key, data) {
    const { joinData } = this.state;

    return this.setState({
      joinData: {
        ...joinData,
        [datasetId]: {
          ...joinData?.[datasetId],
          [key]: data
        }
      }
    });
  }

  updateJoinBase(datasetId, data) {
    const { joinData } = this.state;

    return this.setState({
      joinData: {
        ...joinData,
        [datasetId]: {
          ...data
        }
      }
    });
  }

  updateLookupKey(datasetId, index, data) {
    const { joinData } = this.state;

    return this.setState({
      joinData: {
        ...joinData,
        [datasetId]: {
          ...joinData?.[datasetId],
          ["lookupKeys"]: {
            ...joinData?.[datasetId]?.lookupKeys,
            [index]: { ...joinData?.[datasetId]?.lookupKeys?.[index], ...data }
          }
        }
      }
    });
  }

  deleteLookupKey(datasetId, index) {
    return this.updateLookupKey(datasetId, index, { isDelete: true });
  }

  renderJoin(dataset) {
    const { datasets } = this.props;
    const { joinData } = this.state;

    const selectedDataset = joinData?.[dataset?.id]?.selectedDataset;
    const fieldOption = joinData?.[dataset?.id]?.fieldOption;
    const fieldOptionSelected = joinData?.[dataset?.id]?.fieldOptionSelected;
    const joinType = joinData?.[dataset?.id]?.joinType;
    const prefix = joinData?.[dataset?.id]?.prefix;

    const fieldOptions =
      dataset && dataset?.fields
        ? Object.keys(dataset.fields).map((fKey) => ({
            value: dataset?.fields?.[fKey],
            label: fKey
          }))
        : [];

    const fieldOptionsSelected =
      selectedDataset && selectedDataset?.value?.fields
        ? Object.keys(selectedDataset.value.fields).map((fKey) => ({
            value: selectedDataset?.value?.fields?.[fKey],
            label: fKey
          }))
        : [];

    const isJoinDisabled =
      selectedDataset === undefined || fieldOption === undefined || fieldOptionSelected === undefined;

    const lookupKeys = joinData?.[dataset?.id]?.lookupKeys || {};

    return (
      <div className={styles.joinBodyLookup}>
        <div className={styles.jBold}>{selectedDataset ? "Selected Dataset" : "Select Dataset"}</div>
        <Select
          options={datasets ? datasets.map((d) => ({ value: d, label: d.label })) : []}
          value={selectedDataset}
          onChange={(val) => this.updateJoinData(dataset?.id, "selectedDataset", val)}
          placeholder="Search or Select a Dataset"
        />
        <div className={styles.jBold} style={{ marginTop: "20px" }}>
          {"Lookup Keys"}
        </div>
        {Object.keys(lookupKeys)
          .filter((lKey) => lookupKeys[lKey]?.isDelete !== true)
          .map((lKey, i) => (
            <div className={styles.jFlex} style={{ marginTop: "10px" }}>
              <div className={styles.jFlexItem} style={{ width: "45%", marginRight: "5px" }}>
                <div className={styles.jLabel}>{dataset?.label}</div>
                <Select
                  options={fieldOptions}
                  onChange={(val) => this.updateLookupKey(dataset?.id, lKey, { left: val })}
                  isDisabled={selectedDataset === undefined}
                  value={
                    lookupKeys[lKey].left !== undefined
                      ? fieldOptions.find((opt) => opt.label === lookupKeys[lKey].left)
                      : undefined
                  }
                />
              </div>
              <div className={styles.jFlexItem} style={{ width: "45%", marginLeft: "5px" }}>
                <div className={styles.jLabel}>{selectedDataset?.label || "No Dataset Selected"}</div>
                <Select
                  options={fieldOptionsSelected}
                  onChange={(val) => this.updateLookupKey(dataset?.id, lKey, { right: val })}
                  isDisabled={selectedDataset === undefined}
                  value={
                    lookupKeys[lKey].right !== undefined
                      ? fieldOptionsSelected.find((opt) => opt.label === lookupKeys[lKey].right)
                      : undefined
                  }
                />
              </div>
              <Button
                onClick={() => this.deleteLookupKey(dataset?.id, lKey)}
                style={{
                  padding: "5px",
                  marginLeft: "5px",
                  marginTop: "15px"
                }}
                disabled={selectedDataset === undefined}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            </div>
          ))}
        <Button
          style={{ marginTop: "10px" }}
          onClick={() => {
            this.updateLookupKey(dataset?.id, Object.keys(lookupKeys).length, {
              left: undefined,
              right: undefined
            });
          }}
          disabled={selectedDataset === undefined}
        >
          {"Add Lookup Key"}
        </Button>
        <div className={styles.jBold} style={{ marginTop: "20px" }}>
          {"Join Type"}
        </div>
        <div className={styles.jFlex} style={{ justifyContent: "flex-start" }}>
          <div className={styles.jIcon}>
            <img src={LeftJoinIconGray} />
          </div>
          {"Left (Lookup)"}
        </div>
        <div style={{ width: "50%", marginTop: "20px" }}>
          <div className={styles.jBold}>{"Prefix"}</div>
          <LineInput
            placeholder={"Enter Prefix"}
            onChange={(val) => this.updateJoinData(dataset?.id, "prefix", val)}
            isDisabled={selectedDataset === undefined}
            value={prefix}
          />
        </div>
      </div>
    );
  }

  /*
  <ButtonGroup className={styles.joinType}>
    {/*
    <Button
      style={{ fontSize: "12px" }}
      active={joinType === "LOOKUP"}
      onClick={() =>
        this.updateJoinData(dataset?.id, "joinType", "LOOKUP")
      }
      disabled={selectedDataset === undefined}
    >
      <div className={styles.jIcon}>
        <img src={LookupIcon} />
      </div>
      {"Lookup"}
    </Button>

    <Button
      style={{ fontSize: "12px" }}
      active={joinType === "LEFT"}
      onClick={() => this.updateJoinData(dataset?.id, "joinType", "LEFT")}
      disabled={selectedDataset === undefined}
    >
      <div className={styles.jIcon}>
        <img src={LeftJoinIcon} />
      </div>
      {"Left (Lookup)"}
    </Button>

    <Button
      style={{ fontSize: "12px" }}
      active={joinType === "INNER"}
      onClick={() =>
        this.updateJoinData(dataset?.id, "joinType", "INNER")
      }
    >
      <div className={styles.jIcon}>
        <img src={InnerJoinIcon} />
      </div>
      {"Inner"}
    </Button>

    <Button
      style={{ fontSize: "12px" }}
      active={joinType === "OUTER"}
      onClick={() =>
        this.updateJoinData(dataset?.id, "joinType", "OUTER")
      }
    >
      <div className={styles.jIcon}>
        <img src={FullOuterIcon} />
      </div>
      {"Full Outer"}
    </Button>
  </ButtonGroup>
  */

  // Lol Append reducer. TODO: Real Append. reduccer
  updateAppendDataField(datasetId, key, data) {
    const { appendData } = this.state;

    return this.setState({
      appendData: {
        ...appendData,
        [datasetId]: key
          ? {
              ...appendData?.[datasetId],
              ["fields"]: {
                ...appendData?.[datasetId]["fields"],
                [key]: data
              }
            }
          : { ...data }
      }
    });
  }

  // Lol Append reducer. TODO: Real Append. reduccer
  updateAppendData(datasetId, key, data) {
    const { appendData } = this.state;

    return this.setState({
      appendData: {
        ...appendData,
        [datasetId]: key
          ? {
              ...appendData?.[datasetId],
              [key]: data
            }
          : { ...data }
      }
    });
  }

  handleUpdateAppendDataset(dataset, appendDataset) {
    let retAppend = {
      selectedDataset: appendDataset,
      fields: {}
    };

    appendDataset?.fields &&
      Object.keys(appendDataset.fields).forEach((oKey) => {
        const field = appendDataset.fields[oKey];

        const foundField = dataset?.fields
          ? Object.keys(dataset.fields).find((fKey) => fKey === field.label)
          : undefined;

        retAppend.fields[oKey] =
          foundField !== undefined
            ? {
                label: foundField,
                value: dataset.fields[foundField],
                isAutomatic: true
              }
            : undefined;
      });

    this.updateAppendData(dataset?.id, undefined, retAppend);
  }

  renderAppend(dataset) {
    const { datasets } = this.props;
    const { appendData } = this.state;

    const aData = appendData?.[dataset?.id];

    const selectedDataset = aData?.selectedDataset;
    const isShowAuto = aData?.isShowAuto;

    const fieldOptions =
      dataset && dataset?.fields
        ? Object.keys(dataset.fields).map((fKey) => ({
            value: dataset?.fields?.[fKey],
            label: fKey
          }))
        : [];

    const totalFields = aData?.fields
      ? Object.keys(aData.fields).map((f) => ({
          label: f,
          mappedFieldSelection: aData.fields[f]
        }))
      : [];

    const remainingFields = totalFields.filter((f) => f?.mappedFieldSelection === undefined);

    const nonAutoFields = totalFields.filter((f) => f?.mappedFieldSelection?.isAutomatic !== true);

    const mappedFields = totalFields.filter(
      (f) => f?.mappedFieldSelection !== undefined && f?.mappedFieldSelection?.isAutomatic === true
    );

    return (
      <div className={styles.joinBody}>
        <div className={styles.jBold}>
          {selectedDataset ? "Selected Dataset" : "Select Dataset (Minimum of 1,000 rows required)"}
        </div>
        <Select
          options={datasets ? datasets.map((d) => ({ value: d, label: d.label })) : []}
          value={selectedDataset}
          onChange={(val) => this.handleUpdateAppendDataset(dataset, val?.value)}
          placeholder="Search or Select a Dataset"
          isClearable
        />
        {selectedDataset && selectedDataset.rowCount < 1000 && (
          <div className={styles.appendWarning}>
            <span>
              <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#F8CD7E" }} />
            </span>
            <span style={{ marginLeft: "5px" }}>{"Dataset has too few rows. Minimum 1,000 required."}</span>
          </div>
        )}
        {selectedDataset && (
          <div style={{ marginTop: "20px" }}>
            {nonAutoFields && nonAutoFields.length > 0 ? (
              <div>
                {remainingFields && remainingFields.length > 0 ? (
                  <div>
                    <div className={styles.jBold}>
                      {"Unable to map " + remainingFields.length + " field" + (remainingFields.length > 1 ? "s" : "")}
                    </div>
                    <div>
                      {"Please map the fields in the new dataset to the fields in " +
                        dataset?.label +
                        ". Any fields you do no map will be ignored."}
                    </div>
                  </div>
                ) : (
                  <div>{"All fields mapped"}</div>
                )}
                <div className={styles.jFlex} style={{ marginTop: "20px" }}>
                  <div className={styles.jFlexItem} style={{ marginRight: "5px" }}>
                    <div className={styles.jBold + " " + styles.jLabel}>{"Field in " + selectedDataset?.label}</div>
                  </div>
                  <div className={styles.jFlexItem} style={{ marginLeft: "5px" }}>
                    <div className={styles.jBold}>{"Map To"}</div>
                  </div>
                </div>
                {nonAutoFields.map((f, i) => (
                  <div className={styles.aFlex}>
                    <div className={styles.jFlexItem} style={{ marginRight: "5px" }}>
                      {f?.label}
                    </div>
                    <div className={styles.jFlexItem} style={{ marginLeft: "5px" }}>
                      <Select
                        key={f?.label}
                        options={fieldOptions}
                        onChange={(val) => this.updateAppendDataField(dataset?.id, f?.label, val)}
                        value={f?.mappedFieldSelection}
                        isDisabled={selectedDataset === undefined}
                      />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.jBold}>{"All fields automatically matched"}</div>
            )}
            <div>
              <a onClick={() => this.updateAppendData(dataset?.id, "isShowAuto", !isShowAuto)}>
                {(isShowAuto ? "Hide " : "View ") + mappedFields.length + " Automaticaly Mapped Fields"}
              </a>
              {isShowAuto && (
                <div>
                  {mappedFields.map((f, i) => (
                    <div className={styles.aFlex}>
                      <div className={styles.jFlexItem} style={{ marginRight: "5px" }}>
                        {f?.label}
                      </div>
                      <div className={styles.jFlexItem} style={{ marginLeft: "5px" }}>
                        <Select
                          key={f?.label}
                          options={fieldOptions}
                          onChange={(val) => this.updateAppendDataField(dataset?.id, f?.label, val)}
                          value={f?.mappedFieldSelection}
                          isDisabled={selectedDataset === undefined}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderModifyFields(dataset) {
    const { modifyFields } = this.state;

    const transformQuery = this.getTransformQuery(dataset);

    const ignored = dataset?.ignored;

    return (
      <div className={styles.modifyFields}>
        <div className={styles.jFlex} style={{ marginTop: "10px" }}>
          <div className={styles.jFlexItem} style={{ marginRight: "5px", maxWidth: "40px" }}>
            <div className={styles.jBold + " " + styles.jLabel}>{"Filter"}</div>
          </div>
          <div className={styles.jFlexItem} style={{ marginRight: "5px", maxWidth: "350px" }}>
            <div className={styles.jBold + " " + styles.jLabel}>{"Field"}</div>
          </div>
          <div className={styles.jFlexItem} style={{ marginLeft: "5px", maxWidth: "350px" }}>
            <div className={styles.jBold}>{"Type"}</div>
          </div>
        </div>
        {dataset?.fields ? (
          Object.keys(dataset.fields).map((fKey, i) => {
            const isRemoveReplay =
              ignored?.[fKey] !== true &&
              transformQuery?.query?.exclude_columns !== undefined &&
              transformQuery.query.exclude_columns.indexOf(fKey) !== -1;

            return (
              <div
                key={fKey}
                style={{
                  marginTop: "20px",
                  paddingBottom: i === Object.keys(dataset.fields).length - 1 ? "200px" : "0px"
                }}
              >
                {isRemoveReplay && (
                  <div className={styles.removeWarn}>{"Column removed from Dataset Transformation Replay"}</div>
                )}
                <div
                  className={styles.jFlex}
                  style={{
                    opacity: ignored?.[fKey] === true || isRemoveReplay ? 0.5 : 1,
                    pointerEvents: isRemoveReplay ? "none" : "all"
                  }}
                >
                  <div className={styles.jFlexItem} style={{ marginRight: "5px", maxWidth: "40px" }}>
                    <input
                      type="checkbox"
                      style={{ marginLeft: "8px" }}
                      onClick={() => this.handleAddIgnoreFilter(dataset, fKey, ignored?.[fKey] === true ? false : true)}
                      checked={ignored?.[fKey] === true}
                      disabled={isRemoveReplay}
                    />
                  </div>
                  <div
                    className={styles.jFlexItem}
                    style={{
                      marginRight: "5px",
                      fontSize: "14px",
                      maxWidth: "350px"
                    }}
                  >
                    <LineInput
                      isSenseBox
                      value={modifyFields?.[dataset?.id]?.[fKey]?.changeName || fKey}
                      topLabel={fKey}
                      labelStyle={{ top: "-12px", fontSize: "10px" }}
                      onChange={(val) => {
                        const tVal =
                          modifyFields?.[dataset?.id]?.[fKey]?.changeName !== undefined
                            ? modifyFields?.[dataset?.id]?.[fKey]?.changeName
                            : fKey;

                        if (val !== tVal) {
                          this.setState({
                            modifyFields: {
                              ...modifyFields,
                              [dataset?.id]: {
                                ...(modifyFields?.[dataset?.id] || {}),
                                [fKey]: {
                                  ...(modifyFields?.[dataset?.id]?.[fKey] || {}),
                                  ["changeName"]: val === fKey ? undefined : val
                                }
                              }
                            }
                          });
                        }
                      }}
                    />
                  </div>
                  <div className={styles.jFlexItem} style={{ marginLeft: "20px", maxWidth: "350px" }}>
                    <Select
                      options={[
                        { label: "Text", value: "TEXT" },
                        { label: "Number", value: "NUMERIC" }
                      ]}
                      value={
                        modifyFields?.[dataset?.id]?.[fKey]
                          ? {
                              label: modifyFields?.[dataset?.id]?.[fKey]?.changeType === "NUMERIC" ? "Number" : "Text",
                              value: modifyFields?.[dataset?.id]?.[fKey]?.changeType
                            }
                          : dataset.fields[fKey]?.type === "number" || dataset.fields[fKey].isNumeric
                            ? { label: "Number", value: "NUMERIC" }
                            : { label: "Text", value: "TEXT" }
                      }
                      onChange={(val) =>
                        this.setState({
                          modifyFields: {
                            ...modifyFields,
                            [dataset?.id]: {
                              ...(modifyFields?.[dataset?.id] || {}),
                              [fKey]: {
                                ...(modifyFields?.[dataset?.id]?.[fKey] || {}),
                                ["changeType"]: val.value
                              }
                            }
                          }
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div />
        )}
      </div>
    );
  }

  // BEGIN BAD CUSTOM TRANSFORM
  // TODO: Move this into nice neat reducer and container.
  // Only relies on dataset object
  updateCustomTransforms(datasetId, key, data) {
    const { customTransforms } = this.state;

    return this.setState({
      customTransforms: {
        ...customTransforms,
        [datasetId]: {
          ...customTransforms?.[datasetId],
          [key]: data
        }
      }
    });
  }

  deleteCustomTransforms(datasetId, key) {
    const { customTransforms } = this.state;

    let retCustomTransforms = { ...customTransforms };

    if (retCustomTransforms?.[datasetId]?.[key]) {
      delete retCustomTransforms[datasetId][key];

      return this.setState({
        customTransforms: retCustomTransforms
      });
    }
  }

  deleteCustomTransformSegment(datasetId, key, segmentIndex) {
    const { customTransforms } = this.state;

    let retCustomTransforms = { ...customTransforms };

    if (retCustomTransforms?.[datasetId]?.[key]?.segments) {
      delete retCustomTransforms[datasetId][key].segments[segmentIndex];

      return this.setState({
        customTransforms: retCustomTransforms
      });
    }
  }

  getInitTransform() {
    return {
      segments: [{ columnName: undefined, columnValue: undefined, conditions: [] }]
    };
  }

  updateCustomTransform(datasetId, index, key, data) {
    const { customTransforms } = this.state;

    return this.setState({
      customTransforms: {
        ...customTransforms,
        [datasetId]: {
          ...customTransforms?.[datasetId],
          [index]: {
            ...(customTransforms?.[datasetId]?.[index] || this.getInitTransform()),
            [key]: data
          }
        }
      }
    });
  }

  updateCustomTransformSegment(datasetId, colIndex, segIndex, key, data) {
    const { customTransforms } = this.state;

    const cTransforms = customTransforms?.[datasetId] || {};

    let retSegments = cTransforms?.[colIndex]?.segments
      ? { ...cTransforms[colIndex].segments }
      : { ...this.getInitTransform().segments };

    retSegments[segIndex] = {
      ...retSegments[segIndex],
      [key]: data
    };

    this.updateCustomTransform(datasetId, colIndex, "segments", retSegments);
  }

  addSegment(datasetId, colIndex) {
    const { customTransforms } = this.state;

    const cTransforms = customTransforms?.[datasetId] || {};

    let retSegments = cTransforms?.[colIndex]?.segments ? { ...cTransforms[colIndex].segments } : {};

    retSegments[Object.keys(retSegments).length] = {
      columnName: undefined,
      columnValue: undefined,
      conditions: [],
      elseValue: "Other (Custom Field)"
    };

    this.updateCustomTransform(datasetId, colIndex, "segments", retSegments);
  }

  renderCustomTransformations(dataset) {
    const { customTransforms } = this.state;

    const cTransforms = customTransforms?.[dataset?.id] || {
      0: {
        segments: [
          {
            columnName: undefined,
            columnValue: undefined,
            conditions: [],
            elseValue: "Other (Custom Field)"
          }
        ]
      }
    };

    const hasUnsavedTransforms = Object.keys(cTransforms).reduce(
      (a, b) => a || cTransforms[b]?.isSavedTransform !== true,
      false
    );

    return (
      <div>
        {Object.keys(cTransforms).map((t, i) => {
          const columnName = cTransforms[t]?.columnName;
          const elseValue = cTransforms[t]?.elseValue || "Other (Custom Field)";

          return (
            <div className={styles.customTransform}>
              <div className={styles.customRuleList}>
                {cTransforms[t]?.segments &&
                  Object.keys(cTransforms[t].segments).map((s, index) => {
                    const segment = cTransforms[t].segments[s];
                    const conditions =
                      segment?.conditions && segment?.conditions.length > 0
                        ? segment?.conditions
                        : [
                            {
                              type: "EQUAL",
                              column: undefined,
                              value: undefined
                            }
                          ];
                    const columnValue = segment?.columnValue;

                    return segment?.isSaved !== true ? (
                      <div className={styles.customRule} key={index}>
                        <div className={styles.customRuleHeader}>{"Rule " + (index + 1)}</div>
                        <ConditionListInput
                          conditions={conditions}
                          onChange={(val) => this.updateCustomTransformSegment(dataset?.id, t, s, "conditions", val)}
                          dataset={dataset}
                        />
                        <div className={styles.cTransformButtons}>
                          <div className={styles.transformValue}>
                            {"If the criteria is met the new column will display the value:"}
                            <LineInput
                              isSenseBox
                              placeholder="New value for this criteria"
                              value={columnValue}
                              onChange={(val) =>
                                this.updateCustomTransformSegment(dataset?.id, t, s, "columnValue", val)
                              }
                            />
                          </div>
                        </div>
                        <div className={styles.customRuleButtons}>
                          <Button
                            onClick={() => this.deleteCustomTransformSegment(dataset?.id, i, s)}
                            style={{ marginRight: "10px", color: "#C03E5A" }}
                          >
                            <FontAwesomeIcon icon={faTrash} style={{ marginRight: "5px" }} />
                            {"Delete Rule"}
                          </Button>
                          <Button
                            onClick={() => this.updateCustomTransformSegment(dataset?.id, t, s, "isSaved", true)}
                            disabled={columnValue === undefined || columnValue === ""}
                            title={
                              columnValue === undefined || columnValue === ""
                                ? "Enter Value Name to Save Rule"
                                : undefined
                            }
                            style={{ marginLeft: "10px" }}
                          >
                            <FontAwesomeIcon icon={faSave} style={{ marginRight: "5px" }} />
                            {"Save Rule"}
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className={styles.customRule}>
                          <div className={styles.customRuleSaved}>
                            <div>
                              <div className={styles.customRuleHeader}>{"Rule " + (index + 1)}</div>
                              {conditions && conditions.map((condition) => this.renderTextCondition(condition))}
                              <div className={styles.customRuleHeader}>{segment?.columnValue}</div>
                            </div>
                            <ButtonGroup>
                              <Button
                                onClick={() => this.deleteCustomTransformSegment(dataset?.id, i, s)}
                                style={{ color: "#C03E5A" }}
                              >
                                {"Delete Rule"}
                              </Button>
                              <Button
                                onClick={() => this.updateCustomTransformSegment(dataset?.id, t, s, "isSaved", false)}
                              >
                                {"Edit Rule"}
                              </Button>
                            </ButtonGroup>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                <Button onClick={() => this.addSegment(dataset?.id, t)}>
                  <FontAwesomeIcon icon={faPlus} style={{ marginRight: "5px" }} />
                  {"Add Rule"}
                </Button>
              </div>
              <div className={styles.tColumnActions} style={{ marginTop: "10px" }}>
                {
                  <div className={styles.cTransformInput} style={{ marginBottom: "10px" }}>
                    {"If no criteria are met, the new column will display the value: "}
                    <LineInput
                      isSenseBox
                      onChange={(val) => this.updateCustomTransform(dataset?.id, t, "elseValue", val)}
                      value={elseValue}
                      style={{ background: "white" }}
                    />
                  </div>
                }
              </div>
              <div className={styles.tColumnActions} style={{ marginTop: "10px" }}>
                {cTransforms[t]?.isSavedTransform === true ? (
                  <div className={styles.jBold} style={{ width: "calc(100% - 261px)" }}>
                    {columnName}
                  </div>
                ) : (
                  <div className={styles.cTransformInput} style={{ marginBottom: "10px" }}>
                    {"New Column Name"}
                    <LineInput
                      isSenseBox
                      onChange={(val) => this.updateCustomTransform(dataset?.id, t, "columnName", val)}
                      value={columnName}
                      style={{ background: "white" }}
                    />
                  </div>
                )}
                {cTransforms[t]?.isSavedTransform === true ? (
                  <div className={styles.addSegment}>
                    <ButtonGroup>
                      <Button
                        onClick={() => this.deleteCustomTransforms(dataset?.id, t, "isSavedTransform", true)}
                        style={{ color: "#C03E5A" }}
                      >
                        {"Delete Column"}
                      </Button>
                      <Button onClick={() => this.updateCustomTransform(dataset?.id, t, "isSavedTransform", false)}>
                        {"Edit Column Name"}
                      </Button>
                    </ButtonGroup>
                  </div>
                ) : (
                  <div className={styles.addSegment}>
                    <Button
                      type="primary"
                      disabled={
                        columnName === undefined ||
                        columnName === "" ||
                        cTransforms[t]?.segments === undefined ||
                        Object.keys(cTransforms[t]?.segments).length === 0
                      }
                      onClick={() => this.updateCustomTransform(dataset?.id, t, "isSavedTransform", true)}
                    >
                      {"Create New Column"}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
        {hasUnsavedTransforms ? (
          <div />
        ) : (
          <Button
            onClick={() =>
              this.updateCustomTransforms(dataset?.id, Object.keys(cTransforms).length, {
                segments: {}
              })
            }
            style={{ marginTop: "20px" }}
          >
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: "5px" }} />
            {"Add If-Then-Else Field"}
          </Button>
        )}
      </div>
    );
  }

  renderTextConditions(column, segment) {
    const columnName = column?.columnName;
    const conditions = segment?.conditions;

    return (
      <div>
        <div>{"When"}</div>
        {conditions && conditions.map((condition) => this.renderTextCondition(condition))}
        <div>{"Then"}</div>
        <div className={styles.jBold}>{columnName + " is " + segment?.columnValue}</div>
      </div>
    );
  }

  renderCondition(condition) {
    return condition?.conditions !== undefined ? (
      <div>{condition?.conditions.map((c) => this.renderTextCondition(c))}</div>
    ) : (
      this.renderTextCondition(condition)
    );
  }

  /*
  export enum ConditionType {
      LessThan = "LESS_THAN",
      LessThanOrEqual = "LESS_THAN_OR_EQUAL",
      GreaterThan = "GREATER_THAN",
      GreaterThanOrEqual = "GREATER_THAN_OR_EQUAL",
      Equal = "EQUAL",
      NotEqual = "NOT_EQUAL",
      Between = "BETWEEN",
      NotBetween = "NOT_BETWEEN",
      In = "IN",
      NotIn = "NOT_IN",
      And = "AND",
      Or = "OR",
      Null = "NULL",
      NotNull = "NOT_NULL",
      Not = "NOT",
  }
  */

  renderTypeText(conditionType) {
    const readableConditions = {
      ["LESS_THAN"]: "less than",
      ["LESS_THAN_OR_EQUAL"]: "less than or equal to",
      ["GREATER_THAN"]: "greater than",
      ["GREATER_THAN_OR_EQUAL"]: "greater than or equal to",
      ["EQUAL"]: "is",
      ["NOT_EQUAL"]: "is not",
      ["BETWEEN"]: "between",
      ["NOT_BETWEEN"]: "not between",
      ["IN"]: "in",
      ["NOT_IN"]: "not in",
      ["AND"]: "and",
      ["OR"]: "or",
      ["NULL"]: "null",
      ["NOT_NULL"]: "not null",
      ["NOT"]: "not"
    };

    return readableConditions[conditionType] || conditionType;
  }

  renderTextCondition(condition) {
    return condition?.conditions && condition?.conditions.length > 0 ? (
      <div>{condition.conditions.map((c) => this.renderTextCondition(c))}</div>
    ) : (
      <div>
        {condition?.column !== undefined ? (
          <div>
            {condition?.column +
              " " +
              this.renderTypeText(condition?.type) +
              " " +
              (condition?.value?.column || condition?.value)}
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }
  // END BAD CUSTOM TRANSFORM

  getTransformUpdates(datasetId) {
    const { joinData, appendData, customTransforms, filterData } = this.state;

    const dJoinData = joinData?.[datasetId];
    const dAppendData = appendData?.[datasetId];
    const dCustomTransforms = customTransforms?.[datasetId];

    const retUpdates = {
      JOIN:
        dJoinData?.selectedDataset && dJoinData?.fieldOption && dJoinData?.fieldOptionSelected ? dJoinData : undefined,
      APPEND: dAppendData?.selectedDataset ? dAppendData : undefined,
      CUSTOM: dCustomTransforms,
      FILTER: filterData?.[datasetId]
    };

    return retUpdates;
  }

  getReadableTransformUpdates(dataset) {
    const { filterData, modifyFields } = this.state;

    const datasetId = dataset?.id;
    const transformUpdates = this.getTransformUpdates(datasetId);

    const filterState = filterData?.[datasetId];

    const rowFilters = filterState?.row_filters || [];
    const excludeColumns = filterState?.exclude_columns || [];
    const distinctColumns = filterState?.unique_id_columns || [];

    const modifyState = modifyFields?.[datasetId];

    /*
    const {
      joinData,
      appendData,
      filterData,
      customTransforms,
      modifyFields,
      autoTransformLabels,
      replayTransform,
    } = this.state;
    console.log("state before query state dataset", this.state, dataset);

    const datasetId = dataset?.id;

    const joinState = joinData?.[datasetId];
    const appendState = appendData?.[datasetId];
    const filterState = filterData?.[datasetId];
    const customState = customTransforms?.[datasetId];
    const modifyState = modifyFields?.[datasetId];

    const aTransformLabels = autoTransformLabels?.[datasetId];

    const autoTransforms = dataset?.dataTransforms;
    const manualTransforms = dataset?.manualTransforms;

    const excludeColumns = filterState?.exclude_columns;
    */

    const autoTransforms = dataset?.dataTransforms;
    const manualTransforms = dataset?.manualTransforms;

    let retUpdates = {
      FILTER: {
        count: rowFilters.filter((r) => r.column && r.value).length + excludeColumns.length + distinctColumns.length
      },
      DERIVED: {
        count:
          (autoTransforms ? autoTransforms.length : 0) + (manualTransforms ? Object.keys(manualTransforms).length : 0)
      },
      MODIFY: {
        count:
          modifyState !== undefined
            ? Object.keys(modifyState).filter(
                (mKey) => modifyState[mKey].changeName !== undefined || modifyState[mKey].changeType !== undefined
              ).length
            : 0
      },
      JOIN: {
        data: transformUpdates.JOIN,
        count: transformUpdates.JOIN === undefined ? 0 : 1,
        smallText:
          transformUpdates.JOIN === undefined
            ? "No Join"
            : "Joining with " + transformUpdates.JOIN?.selectedDataset?.label
      },
      APPEND: {
        data: transformUpdates.APPEND,
        count: transformUpdates.APPEND === undefined ? 0 : 1,
        smallText:
          transformUpdates.APPEND === undefined
            ? "No Append"
            : "Appending with " + transformUpdates.APPEND?.selectedDataset?.label
      },
      CUSTOM: {
        data: transformUpdates.CUSTOM,
        count: transformUpdates.CUSTOM === undefined ? 0 : Object.keys(transformUpdates.CUSTOM).length,
        smallText:
          transformUpdates.CUSTOM === undefined
            ? "None"
            : "Applying " + Object.keys(transformUpdates.CUSTOM).length + " If/Then/Else rules"
      }
    };

    retUpdates.totalCount =
      retUpdates.DERIVED.count +
      retUpdates.FILTER.count +
      retUpdates.JOIN.count +
      retUpdates.APPEND.count +
      retUpdates.CUSTOM.count;

    return retUpdates;
  }

  openAndScrollLineage(dataset, divId, inline = undefined) {
    const isOpenLineage = this.getIsOpenTile(dataset?.id, "Lineage");

    if (isOpenLineage !== true) {
      this.toggleIsOpenTile(dataset?.id, "Lineage");
    }

    setTimeout(() => {
      const pendingUpdatesDiv = document.getElementById(divId);
      if (pendingUpdatesDiv) {
        pendingUpdatesDiv.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: inline
        });
      }
    }, 100);
  }

  // Left of three
  renderTransformations(dataset) {
    const { copyAndApplyTransformations, copyAndApplyPlan } = this.props;
    const { isTransformSaving } = this.state;

    const oStyle = {};

    const isOpenTransformations = this.getIsOpenTile(dataset?.id, "Transformations");
    const isOpenSettings = this.getIsOpenTile(dataset?.id, "Settings");
    const isOpenLineage = this.getIsOpenTile(dataset?.id, "Lineage");
    const isOpenDataEvaluated = this.getIsOpenTile(dataset?.id, "Data Evaluated");

    const isWideDatasetWarning = dataset?.wideDatasetWarning;

    const totalUpdates = this.getReadableTransformUpdates(dataset);
    const lineageUpdates = this.getReplayUpdates(dataset, dataset?.transformations?.query);

    const pendingQuery = this.getTransformQuery(dataset);
    const pendingTransformUpdates = this.getReplayUpdates(dataset, pendingQuery?.query);

    return (
      <div
        className={isOpenTransformations ? styles.openOverview : styles.overview}
        style={{
          maxHeight: isOpenTransformations ? "5000px" : "190px",
          width: isOpenTransformations ? "calc(100% - 20px)" : isOpenDataEvaluated ? "100%" : "calc(33.333% - 14px)",
          overflow: isOpenTransformations ? "visible" : "hidden",
          marginLeft: isOpenTransformations || isOpenDataEvaluated ? "10px" : "0px",
          borderColor: !isWideDatasetWarning ? undefined : "transparent",
          cursor: !isWideDatasetWarning ? undefined : "default"
        }}
        onClick={
          isOpenTransformations !== true && !isWideDatasetWarning
            ? () => this.toggleIsOpenTile(dataset?.id, "Transformations")
            : () => {}
        }
      >
        <div className={styles.senseTitle}>
          <div className={styles.sTitle}>
            <span className={styles.sIcon}>
              <img src={ToolsIcon} style={{ height: "16px", width: "16px" }} />
            </span>
            <span>{"Transformations"}</span>
          </div>
          {isWideDatasetWarning ? (
            <React.Fragment />
          ) : isOpenTransformations ? (
            <div className={styles.closeButton} onClick={() => this.toggleIsOpenTile(dataset?.id, "Transformations")}>
              <Button style={{ padding: "3px" }}>
                <div className={styles.selIcon} title="Close">
                  <FontAwesomeIcon icon={faCompressArrowsAlt} />
                </div>
              </Button>
            </div>
          ) : (
            <div className={styles.selIcon + " " + styles.expandIcon}>
              <FontAwesomeIcon icon={faExpandArrowsAlt} />
            </div>
          )}
        </div>
        <div className={styles.updateTiles}>
          <div className={styles.uFlex}>
            <div className={styles.updateTileFlex}>
              <div className={styles.tTop}>
                <span>{lineageUpdates.length}</span>
              </div>
              <div className={styles.tBot}>
                {isOpenTransformations && lineageUpdates.length > 0 ? (
                  <a onClick={() => this.openAndScrollLineage(dataset, "lastUpdates_" + dataset?.id)}>
                    {"UPDATES MADE"}
                  </a>
                ) : isOpenTransformations ? (
                  "UPDATES MADE"
                ) : lineageUpdates.length === 1 ? (
                  "UPDATE"
                ) : (
                  "UPDATES"
                )}
              </div>
            </div>
            <div className={styles.updateTileFlex}>
              <div className={styles.tTop}>
                <span>{pendingTransformUpdates.length}</span>
              </div>
              <div className={styles.tBot}>
                {isOpenTransformations && pendingTransformUpdates.length > 0 ? (
                  <a onClick={() => this.openAndScrollLineage(dataset, "pendingUpdates_" + dataset?.id)}>
                    {"PENDING UPDATES"}
                  </a>
                ) : isOpenTransformations ? (
                  "PENDING UPDATES"
                ) : (
                  "PENDING"
                )}
              </div>
            </div>
          </div>
          {/*
          <div
            className={styles.updateTileFlex}
            style={
              totalUpdates.DERIVED.count === 0 || isOpenTransformations !== true
                ? { width: "0px", padding: "0px", overflow: "hidden" }
                : {}
            }
          >
            <div className={styles.tTop}>
              <span>{totalUpdates.DERIVED.count}</span>
            </div>
            <div className={styles.tBot}>
              {"DERIVED UPDATE" + (totalUpdates.DERIVED.count > 1 ? "S" : "")}
            </div>
          </div>
          <div
            className={styles.updateTileFlex}
            style={
              totalUpdates.FILTER.count === 0 || isOpenTransformations !== true
                ? { width: "0px", padding: "0px", overflow: "hidden" }
                : {}
            }
          >
            <div className={styles.tTop}>
              <span>{totalUpdates.FILTER.count}</span>
            </div>
            <div className={styles.tBot}>
              {"FILTER UPDATE" + (totalUpdates.FILTER.count > 1 ? "S" : "")}
            </div>
          </div>
          <div
            className={styles.updateTileFlex}
            style={
              totalUpdates.MODIFY.count === 0 || isOpenTransformations !== true
                ? { width: "0px", padding: "0px", overflow: "hidden" }
                : {}
            }
          >
            <div className={styles.tTop}>
              <span>{totalUpdates.MODIFY.count}</span>
            </div>
            <div className={styles.tBot}>
              {"FIELD" +
                (totalUpdates.MODIFY.count > 1 ? "S" : "") +
                " UPDATED"}
            </div>
          </div>
          <div
            className={styles.updateTileFlex}
            style={
              totalUpdates.JOIN.count === 0 || isOpenTransformations !== true
                ? { width: "0px", padding: "0px", overflow: "hidden" }
                : {}
            }
          >
            <div className={styles.tTop}>
              <span>{totalUpdates.JOIN.count}</span>
            </div>
            <div className={styles.tBot}>{"JOIN APPLIED"}</div>
          </div>
          <div
            className={styles.updateTileFlex}
            style={
              totalUpdates.APPEND.count === 0 || isOpenTransformations !== true
                ? { width: "0px", padding: "0px", overflow: "hidden" }
                : {}
            }
          >
            <div className={styles.tTop}>
              <span>{totalUpdates.APPEND.count}</span>
            </div>
            <div className={styles.tBot}>{"APPEND APPLIED"}</div>
          </div>
          <div
            className={styles.updateTileFlex}
            style={
              totalUpdates.CUSTOM.count === 0 || isOpenTransformations !== true
                ? { width: "0px", padding: "0px", overflow: "hidden" }
                : {}
            }
          >
            <div className={styles.tTop}>
              <span>{totalUpdates.CUSTOM.count}</span>
            </div>
            <div className={styles.tBot}>
              {"IF/ADD/ELSE UPDATE" +
                (totalUpdates.CUSTOM.count > 1 ? "S" : "")}
            </div>
          </div>
          */}
        </div>
        {isOpenTransformations && (
          <div className={styles.accordionHolder}>
            <SenseAccordion
              items={[
                {
                  header: (
                    <div className={styles.accordionHeader}>
                      <div className={styles.aIcon}>
                        <img src={Sparkles} />
                      </div>
                      {"Apply Transformations From Another Dataset"}
                    </div>
                  ),
                  body: this.renderReplayTransform(dataset),
                  isOverflowVisible: true
                },
                {
                  header: (
                    <div className={styles.accordionHeader}>
                      <div className={styles.aIcon}>
                        <img src={Sliders} />
                      </div>
                      {"Update Columns"}
                      {totalUpdates.MODIFY.count > 0 && (
                        <div className={styles.undo}>
                          <Button
                            style={{ padding: "3px" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              this.setState({
                                modifyFields: {
                                  ...this.state.modifyFields,
                                  [dataset?.id]: undefined
                                }
                              });
                            }}
                          >
                            {"Undo Changes"}
                          </Button>
                        </div>
                      )}
                    </div>
                  ),
                  body: this.renderModifyFields(dataset)
                },
                {
                  header: (
                    <div className={styles.accordionHeader}>
                      <div className={styles.aIcon}>
                        <img src={JoinIcon} />
                      </div>
                      {"Join"}
                      {totalUpdates?.JOIN?.data !== undefined && false && (
                        <div className={styles.updateBadge}>{"Updated"}</div>
                      )}
                    </div>
                  ),
                  body: <div className={styles.accordionBody}>{this.renderJoin(dataset)}</div>,
                  isCenter: true
                },
                {
                  header: (
                    <div className={styles.accordionHeader}>
                      <div className={styles.aIcon}>
                        <img src={AppendIcon} />
                      </div>
                      {"Append"}
                      {totalUpdates?.APPEND?.data !== undefined && false && (
                        <div className={styles.updateBadge}>{"Updated"}</div>
                      )}
                    </div>
                  ),
                  body: <div className={styles.dedupeRows}>{this.renderAppend(dataset)}</div>,
                  isOverflowVisible: true,
                  isNoMaxHeight: true
                },
                {
                  header: (
                    <div className={styles.accordionHeader}>
                      <div className={styles.aIcon}>
                        <img src={DerivedIcon} />
                      </div>
                      {"Create Derived Fields"}
                    </div>
                  ),
                  body: this.renderReviewRecommendations(dataset),
                  isCenter: false
                },
                {
                  header: (
                    <div className={styles.accordionHeader}>
                      <div className={styles.aIcon}>
                        <img src={IfElseIcon} />
                      </div>
                      {"Conditional Derived Fields (If-Then-Else)"}
                      {totalUpdates?.CUSTOM?.data !== undefined && false && (
                        <div className={styles.updateBadge}>
                          {Object.keys(totalUpdates?.CUSTOM?.data).length + " Updates"}
                        </div>
                      )}
                    </div>
                  ),
                  body: (
                    <div className={styles.accordionBody} style={{ maxWidth: "100%" }}>
                      {this.renderCustomTransformations(dataset)}
                    </div>
                  )
                },
                {
                  header: (
                    <div className={styles.accordionHeader}>
                      <div className={styles.aIcon}>
                        <img src={PivotIcon} />
                      </div>
                      {"Pivot or Unpivot the Data"}
                    </div>
                  ),
                  body: <div className={styles.pivotBody}>{this.renderPivot(dataset)}</div>,
                  isOverflowVisible: true,
                  isCenter: false,
                  isNoMaxHeight: true
                },
                {
                  header: (
                    <div className={styles.accordionHeader}>
                      <div className={styles.aIcon}>
                        <img src={Code} />
                      </div>
                      <span>{"View Generated Query"}</span>
                      <span style={{ marginLeft: "3px", fontSize: "12px" }}>{"(the nerdy stuff)"}</span>
                    </div>
                  ),
                  body: <div className={styles.accordionBodyViewQuery}>{this.renderViewQuery(dataset)}</div>,
                  isOverflowHidden: true
                }
              ]}
            ></SenseAccordion>
          </div>
        )}
        {isOpenTransformations && (
          <div className={styles.tFooter}>
            {/*

            <div className={styles.outcomePicker}>
              <Select options={[]} />
              <div>{": Evaluating"}</div>
            </div>

            */}
            <div className={styles.nameInput}>
              <LineInput
                value={this.state?.transformDataName?.[dataset?.id] || "Transformed_" + dataset?.label}
                onChange={(val) =>
                  this.setState({
                    transformDataName: {
                      ...this.state.transformDataName,
                      [dataset?.id]: val
                    }
                  })
                }
              />
            </div>
            {isTransformSaving === dataset?.id ? (
              <LoadingIndicator style={{ margin: "0px" }} />
            ) : (
              <Button
                type="primary"
                onClick={() => {
                  const replayTransform = this.state.replayTransform?.[dataset?.id];

                  console.log("what is replayTransform", replayTransform);

                  /*
                  if (
                    dataset?.transformations?.plan?.relation?.input?.right
                      ?.type === "UNPIVOT_PIVOT"
                  ) {
                    console.log("force dataset copy plan");

                    return copyAndApplyPlan(
                      dataset?.id,
                      this.state.transformDataName[dataset?.id] ||
                        "Transformed_" + dataset?.label,
                      oOutcome,
                      outcomeSuccess
                    );
                  }
                  */

                  const oSuccess = this.state.outcomeSuccess?.[dataset?.id]?.value?.value;
                  const oOutcome = this.state.datasetOutcomes[dataset?.id];

                  const tQuery = this.getTransformQuery(dataset);
                  const outcomeSuccess =
                    oSuccess !== undefined
                      ? oSuccess
                      : oOutcome !== undefined && oOutcome !== dataset?.target
                        ? undefined
                        : dataset?.target_value?.[0];

                  copyAndApplyTransformations(
                    dataset?.id,
                    tQuery,
                    this.state.transformDataName[dataset?.id] || "Transformed_" + dataset?.label,
                    oOutcome,
                    outcomeSuccess
                  );

                  this.setState({ isTransformSaving: dataset?.id });
                  setTimeout(() => {
                    /* TODO: Maybe uncomment this to reset state after save as
                    this.resetTransformState(dataset?.id);
                    */

                    this.setState({ isTransformSaving: false });
                  }, 5000);
                }}
              >
                {"Save As"}
              </Button>
            )}
          </div>
        )}
      </div>
    );
  }

  resetTransformState(datasetId) {
    const {
      joinData,
      appendData,
      filterData,
      customTransforms,
      modifyFields,
      autoTransformLabels,
      replayTransform,
      pivotData,
      isBadPivot,
      isIdColumns
    } = this.state;

    delete joinData?.[datasetId];
    delete appendData?.[datasetId];
    delete filterData?.[datasetId];
    delete customTransforms?.[datasetId];
    delete modifyFields?.[datasetId];
    delete autoTransformLabels?.[datasetId];

    this.setState({
      joinData,
      appendData,
      filterData,
      customTransforms,
      modifyFields,
      autoTransformLabels
    });
  }

  // Lol Join reducer. TODO: Real Join reduccer
  updatePivotData(dataset, key, data) {
    const { pivotData, isIdColumns } = this.state;

    const datasetId = dataset?.id;

    let retPivotData = {
      ...pivotData,
      [datasetId]: {
        ...pivotData?.[datasetId],
        [key]: data
      }
    };

    if (key === "idColumns") {
      const rowColumns = Object.keys(dataset.fields)
        .filter((fKey) => data.filter((r) => r.label === fKey).length === 0)
        .map((fKey) => ({ label: fKey, value: fKey }));

      retPivotData[datasetId].rowColumns = [...rowColumns];
    } else if (key === "rowColumns") {
      const idColumns = Object.keys(dataset.fields)
        .filter((fKey) => data.filter((r) => r.label === fKey).length === 0)
        .map((fKey) => ({ label: fKey, value: fKey }));

      if (isIdColumns !== true) {
        retPivotData[datasetId].idColumns = [...idColumns];
      }
    }

    this.setState({
      pivotData: retPivotData
    });
  }

  updateIsColumn(dataset, isIdColumns) {
    const { isBadPivot, pivotData } = this.state;

    const idColumns = pivotData?.[dataset?.id]?.idColumns;
    const rowColumns = pivotData?.[dataset?.id]?.rowColumns;
    /*
    if (
      idColumns === undefined &&
      rowColumns !== undefined &&
      isIdColumns === true &&
      dataset?.fields
    ) {
      this.updatePivotData(
        dataset?.id,
        "idColumns",
        Object.keys(dataset.fields)
          .filter(
            (fKey) => rowColumns.filter((r) => r.label === fKey).length === 0
          )
          .map((fKey) => ({ label: fKey, value: fKey }))
      );
    }

    if (
      rowColumns === undefined &&
      idColumns !== undefined &&
      isIdColumns === false &&
      dataset?.fields
    ) {
      this.updatePivotData(
        dataset?.id,
        "rowColumns",
        Object.keys(dataset.fields)
          .filter(
            (fKey) => idColumns.filter((r) => r.label === fKey).length === 0
          )
          .map((fKey) => ({ label: fKey, value: fKey }))
      );
    }
    */

    this.setState({ isIdColumns: isIdColumns });
  }

  renderPivot(dataset) {
    // TODO: Fixme this saved across datasets
    const { isBadPivot, pivotData, isIdColumns } = this.state;

    const varColName = pivotData?.[dataset?.id]?.varColName;
    const valColName = pivotData?.[dataset?.id]?.valColName;
    const idColumns = pivotData?.[dataset?.id]?.idColumns;
    const rowColumns = pivotData?.[dataset?.id]?.rowColumns;
    const wideColumn = pivotData?.[dataset?.id]?.wideColumn;
    const valueColumn = pivotData?.[dataset?.id]?.valueColumn;
    const aggFunc = pivotData?.[dataset?.id]?.aggFunc;

    console.log("what is thisisihshis", idColumns, this.state, pivotData);

    return (
      <div className={styles.pivot}>
        <div className={styles.pBold}>{"I would like to"}</div>
        <div className={styles.pType}>
          <div className={styles.pivotOption}>
            <Select
              options={[
                { label: "Unpivot", value: "Unpivot" },
                { label: "Pivot", value: "Pivot" },
                { label: "Pivot and unpivot", value: "Both" }
              ]}
              value={
                isBadPivot === "Pivot"
                  ? { label: "Pivot", value: "Pivot" }
                  : isBadPivot === "Both"
                    ? { label: "Pivot and unpivot", value: "Both" }
                    : { label: "Unpivot", value: "Unpivot" }
              }
              onChange={(val) => this.setState({ isBadPivot: val.value })}
            />
          </div>
          <div style={{ marginLeft: "5px", color: "#A4A6B7" }}>{"this dataset"}</div>
        </div>
        {isBadPivot === "Both" ? (
          <div>
            <div>
              <div className={styles.pStuff}>
                <div className={styles.chooseId}>
                  <input
                    type="checkbox"
                    style={{ marginTop: "0px", marginRight: "5px" }}
                    checked={isIdColumns}
                    onClick={() => this.updateIsColumn(dataset, !isIdColumns)}
                  />
                  {"I'd like to choose ID columns"}
                </div>
              </div>
              {isIdColumns && (
                <div className={styles.pivotOption}>
                  <div className={styles.pBold} style={{ marginTop: "20px" }}>
                    {"Which columns are the ID columns"}
                  </div>
                  <div className={styles.pivotOption}>
                    <Select
                      options={
                        dataset?.fields
                          ? Object.keys(dataset.fields).map((fKey) => ({
                              label: fKey,
                              value: fKey
                            }))
                          : []
                      }
                      value={idColumns || []}
                      isMulti
                      closeMenuOnSelect={false}
                      onChange={(val) => this.updatePivotData(dataset, "idColumns", val)}
                      placeholder="Select Column"
                    />
                  </div>
                </div>
              )}
              <div className={styles.pStuff}>
                <div className={styles.pivotOption}>
                  <div className={styles.pBold} style={{ marginTop: "20px" }}>
                    {"Which columns do you want to turn into rows?"}
                  </div>
                  <Select
                    options={
                      dataset?.fields
                        ? Object.keys(dataset.fields).map((fKey) => ({
                            label: fKey,
                            value: fKey
                          }))
                        : []
                    }
                    value={rowColumns}
                    isMulti
                    closeMenuOnSelect={false}
                    onChange={(val) => this.updatePivotData(dataset, "rowColumns", val)}
                    placeholder="Select Column"
                  />
                </div>
              </div>
            </div>
            <div className={styles.pBold} style={{ marginTop: "20px" }}>
              {"What would you call the new column?"}
            </div>
            <div className={styles.pivotOption}>
              <LineInput
                isSenseBox
                onChange={(val) => this.updatePivotData(dataset, "varColName", val)}
                value={varColName}
              />
            </div>
            <div className={styles.pBold} style={{ marginTop: "20px" }}>
              {"Which row values would you like to turn into new columns?"}
            </div>
            <div className={styles.pivotOption}>
              <Select
                options={
                  dataset?.fields
                    ? Object.keys(dataset.fields).map((fKey) => ({
                        label: fKey,
                        value: fKey
                      }))
                    : []
                }
                onChange={(val) => this.updatePivotData(dataset, "wideColumn", val.value)}
                menuPlacement="top"
                value={
                  typeof wideColumn !== "string"
                    ? wideColumn
                    : {
                        label: wideColumn,
                        value: wideColumn
                      }
                }
              />
            </div>
            {/*
            <Button style={{ marginTop: "20px" }}>
              {"Add Pivot and Unpivot"}
            </Button>
            */}
          </div>
        ) : isBadPivot === "Pivot" ? (
          <div>
            <div className={styles.pBold} style={{ marginTop: "20px" }}>
              {"Which columns are the ID columns"}
            </div>
            <div className={styles.pivotOption}>
              <Select
                options={
                  dataset?.fields
                    ? Object.keys(dataset.fields).map((fKey) => ({
                        label: fKey,
                        value: fKey
                      }))
                    : []
                }
                isMulti
                closeMenuOnSelect={false}
                onChange={(val) => this.updatePivotData(dataset, "idColumns", val)}
                value={idColumns}
              />
            </div>
            <div className={styles.pBold} style={{ marginTop: "20px" }}>
              {"Which row values would you like to turn into new columns?"}
            </div>
            <div className={styles.pivotOption}>
              <Select
                options={
                  dataset?.fields
                    ? Object.keys(dataset.fields).map((fKey) => ({
                        label: fKey,
                        value: fKey
                      }))
                    : []
                }
                onChange={(val) => this.updatePivotData(dataset, "wideColumn", val.value)}
                placeholder="Select Column"
                value={
                  typeof wideColumn !== "string"
                    ? wideColumn
                    : {
                        label: wideColumn,
                        value: wideColumn
                      }
                }
              />
            </div>
            <div className={styles.pBold} style={{ marginTop: "20px" }}>
              {"Select a value column"}
            </div>
            <div className={styles.pivotOption}>
              <Select
                options={
                  dataset?.fields
                    ? Object.keys(dataset.fields).map((fKey) => ({
                        label: fKey,
                        value: fKey
                      }))
                    : []
                }
                onChange={(val) => this.updatePivotData(dataset, "valueColumn", val.value)}
                menuPlacement="top"
                placeholder="Select Column"
                value={{
                  label: valueColumn,
                  value: valueColumn
                }}
              />
            </div>
            <div className={styles.pBold} style={{ marginTop: "20px" }}>
              {"Select an aggregator function"}
            </div>
            <div className={styles.pivotOption}>
              <Select
                options={[
                  { value: "first", label: "first" },
                  { value: "last", label: "last" },
                  { value: "count", label: "count" },
                  { value: "sum", label: "sum" },
                  { value: "mean", label: "mean" },
                  { value: "min", label: "min" },
                  { value: "max", label: "max" }
                ]}
                onChange={(val) => this.updatePivotData(dataset, "aggFunc", val.value)}
                menuPlacement="top"
                value={{
                  label: aggFunc,
                  value: aggFunc
                }}
              />
            </div>
          </div>
        ) : (
          <div>
            <div>
              <div className={styles.pStuff} style={{ marginTop: "20px" }}>
                <div className={styles.chooseId}>
                  <input
                    type="checkbox"
                    style={{ marginTop: "0px", marginRight: "5px" }}
                    checked={isIdColumns}
                    onClick={() => this.updateIsColumn(dataset, !isIdColumns)}
                  />
                  {"I'd like to choose ID columns"}
                </div>
              </div>
              {isIdColumns === true && (
                <div className={styles.pivotOption}>
                  <div className={styles.pBold}>{"Which columns are the ID columns"}</div>
                  <div className={styles.pivotOption}>
                    <Select
                      options={
                        dataset?.fields
                          ? Object.keys(dataset.fields).map((fKey) => ({
                              label: fKey,
                              value: fKey
                            }))
                          : []
                      }
                      value={idColumns}
                      isMulti
                      closeMenuOnSelect={false}
                      onChange={(val) => this.updatePivotData(dataset, "idColumns", val)}
                      placeholder="Select Column"
                    />
                  </div>
                </div>
              )}
              <div className={styles.pStuff}>
                <div className={styles.pivotOption}>
                  <div className={styles.pBold} style={{ marginTop: isIdColumns === true ? "20px" : "0px" }}>
                    {"Which columns do you want to turn into rows?"}
                  </div>
                  <Select
                    options={
                      dataset?.fields
                        ? Object.keys(dataset.fields).map((fKey) => ({
                            label: fKey,
                            value: fKey
                          }))
                        : []
                    }
                    value={rowColumns}
                    isMulti
                    closeMenuOnSelect={false}
                    onChange={(val) => this.updatePivotData(dataset, "rowColumns", val)}
                    isDisabled={isIdColumns === true}
                    placeholder="Select Column"
                  />
                </div>
              </div>
            </div>
            <div className={styles.pBold} style={{ marginTop: "20px" }}>
              {"What would you like to call this new column?"}
            </div>
            <div className={styles.pivotOption}>
              <LineInput
                isSenseBox
                onChange={(val) => this.updatePivotData(dataset, "varColName", val)}
                value={varColName}
              />
            </div>
            <div className={styles.pBold} style={{ marginTop: "20px" }}>
              {"What would you like to call the new column of values?"}
            </div>
            <div className={styles.pivotOption} style={{ paddingBottom: "30px" }}>
              <LineInput
                isSenseBox
                onChange={(val) => this.updatePivotData(dataset, "valColName", val)}
                value={valColName}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  renderViewQuery(dataset) {
    const transformQuery = this.getTransformQuery(dataset);

    const isEmpty = transformQuery?.query && Object.keys(transformQuery?.query).length === 0;

    return (
      <div className={styles.viewQuery} style={{ height: isEmpty ? "60px" : "600px" }}>
        <JSONInput
          viewOnly
          id="JSONQueryInput"
          placeholder={transformQuery}
          locale={locale}
          height={isEmpty ? "60px" : "600px"}
          confirmGood={false}
        />
      </div>
    );
  }

  renderQueryItem(dataset, action) {
    const { datasets } = this.props;
    const { replayTransform, ignoredActions } = this.state;

    const isIgnored = ignoredActions?.[dataset?.id]?.[action.datasetId + "_" + action.type];
    const condition = action?.data?.condition;

    return (
      <div className={styles.replayUpdate} style={isIgnored ? { opacity: 0.4 } : {}}>
        <LineageItem
          icon={action.icon}
          label={action.type}
          subItem={action.subItem}
          date={action.date}
          details={action.details}
          fromDatasetLabel={this.getDatasetLabelFromId(
            action?.isAddedFromPlan === true && action.sourceDatasetId !== undefined
              ? action.sourceDatasetId
              : action.datasetId
          )}
          style={{ marginBottom: "0px" }}
          onClick={
            action?.isAddedFromPlan !== true
              ? undefined
              : () => {
                  const datasetDiv = document.getElementById("dataset_" + action?.datasetId);

                  this.openAndScrollLineage({ id: action?.sourceDatasetId }, "dataset_" + action?.sourceDatasetId);
                }
          }
        />
        <div className={styles.replayCheckbox}>
          <input
            type="checkbox"
            onClick={() => this.handleIgnoreAction(dataset, action)}
            checked={isIgnored !== true}
          />
        </div>
      </div>
    );
  }

  handleIgnoreAction(dataset, action) {
    const { ignoredActions, customTransforms } = this.state;

    const isIgnored = ignoredActions?.[dataset?.id]?.[action.datasetId + "_" + action.type];

    // Custom select
    if (action?.data?.cases) {
      if (isIgnored !== true) {
        const segKey = customTransforms?.[dataset?.id]
          ? Object.keys(customTransforms?.[dataset?.id]).find(
              (sKey) => customTransforms[dataset.id][sKey]?.columnName === action?.data?.alias
            )
          : undefined;

        if (segKey !== undefined) {
          this.deleteCustomTransforms(dataset?.id, segKey);
        }
      } else {
        this.handleAddAction(dataset, action?.data);
      }
    }

    if (action?.type === "Pivot" || action?.type === "Unpivot" || action?.type === "Pivot and Unpivot") {
      if (isIgnored !== true) {
        this.deletePivotAction(dataset);
      } else {
        this.handleAddPivotAction(dataset, action?.data, action?.type === "Pivot and Unpivot" ? "Both" : action.type);
      }
    }

    this.setState({
      ignoredActions: {
        ...ignoredActions,
        [dataset?.id]: {
          ...(ignoredActions?.[dataset?.id] || {}),
          [action.datasetId + "_" + action.type]: !isIgnored
        }
      }
    });
  }

  handleAddAction(dataset, customSelect) {
    const { replayTransform, customTransforms } = this.state;

    let retCustomTransforms = JSON.parse(JSON.stringify(customTransforms));
    const retCustomState = { ...retCustomTransforms[dataset?.id] };

    const segments = customSelect.cases.map((c) => ({
      columnValue: c.value,
      conditions: [c.condition]
    }));

    retCustomTransforms[dataset.id] = {
      ...retCustomState,
      [Object.keys(retCustomState).length]: {
        columnName: customSelect.alias,
        segments: segments,
        elseValue: customSelect?.else_value ? customSelect?.else_value : undefined
      }
    };

    this.setState({ customTransforms: retCustomTransforms });
  }

  deletePivotAction(dataset) {
    const { replayTransform, pivotData } = this.state;

    let retPivotData = pivotData ? JSON.parse(JSON.stringify(pivotData)) : {};

    delete retPivotData[dataset.id];

    return this.setState({ pivotData: retPivotData, isBadPivot: undefined });
  }

  handleAddPivotAction(dataset, pivotAction, pivotType) {
    const { replayTransform, pivotData } = this.state;

    let retPivotData = pivotData ? JSON.parse(JSON.stringify(pivotData)) : {};

    retPivotData[dataset.id] = {
      ...retPivotData[dataset.id],
      varColName: pivotAction?.variable_alias,
      valColName: pivotAction?.value_alias,
      idColumns: pivotAction?.id_columns ? pivotAction?.id_columns.map((c) => ({ value: c, label: c })) : undefined,
      rowColumns: pivotAction?.value_columns
        ? pivotAction?.value_columns.map((c) => ({ value: c, label: c }))
        : undefined,
      wideColumn: pivotAction?.wide_column ? pivotAction?.wide_column : undefined,
      valueColumn: pivotAction?.value_column ? pivotAction?.value_column : undefined,
      aggFunc: pivotAction?.agg_func ? pivotAction?.agg_func : undefined
    };

    this.setState({
      pivotData: retPivotData,
      isBadPivot: pivotType,
      isIdColumns: true
    });
  }

  handleAddDedupe(datasetId, column) {
    const { filterData } = this.state;

    return this.setState({
      filterData: {
        ...filterData,
        [datasetId]: {
          ...(filterData?.[datasetId] || {}),
          unique_id_columns: [column]
        }
      }
    });
  }

  handleAddFilter(datasetId, filter) {
    const { filterData } = this.state;

    return this.setState({
      filterData: {
        ...filterData,
        [datasetId]: {
          ...(filterData?.[datasetId] || {}),
          row_filters: [filter]
        }
      }
    });
  }

  handleRemoveReplay(oDataset, rDataset) {
    const { replayTransform, customTransforms } = this.state;

    const query = rDataset?.transformations?.query;

    console.log("hanbdle remove replay oDatset rDataset", oDataset, rDataset);

    if (query?.unions) {
      this.setState({
        appendData: { ...this.state.appendData, [oDataset?.id]: undefined }
      });
    }

    if (query?.distinct?.columns?.[0]) {
      this.setState({
        filterData: { ...this.state.filterData, [oDataset?.id]: undefined }
      });
    }

    if (query?.filter) {
      this.setState({
        filterData: { ...this.state.filterData, [oDataset?.id]: undefined }
      });
    }

    if (query?.select) {
      if (query.select.filter((s) => s?.cases !== undefined).length > 0) {
        this.setState({
          customTransforms: {
            ...this.state.customTransforms,
            [oDataset?.id]: undefined
          }
        });
      }
    }
    if (query?.mutate) {
      query.mutate.forEach((customSelect) => {
        if (customSelect.type === "EXPRESSION") {
          //TODO handle removing manuald erived fields ehrer
        } else {
          this.setState({
            customTransforms: {
              ...this.state.customTransforms,
              [oDataset?.id]: undefined
            }
          });
        }
      });
    }
    if (query?.unpivot_and_pivot || query?.pivot || query?.unpivot) {
      let pivotData = this.state.pivotData;

      delete pivotData[oDataset?.id];

      this.setState({
        pivotData: {
          ...pivotData
        }
      });
    }

    if (query?.joins) {
      this.setState({
        joinData: {
          ...this.state.joinData,
          [oDataset?.id]: undefined
        }
      });
    }
  }

  handleReplay(oDataset, datasetOptions) {
    const { addField } = this.props;
    const { replayTransform, customTransforms } = this.state;

    const oldDatasetOptions = replayTransform?.[oDataset?.id];

    const nDatasets =
      datasetOptions === undefined
        ? []
        : datasetOptions.filter(
            (d) =>
              oldDatasetOptions === undefined ||
              oldDatasetOptions.filter((o) => o?.value?.id === d?.value?.id).length === 0
          );

    nDatasets.forEach((tDataset) => {
      const query = tDataset?.value?.transformations?.query;

      if (query?.unions) {
        query.unions.forEach((union) => {
          const uDataset = this.getDatasetFromId(union.source);
          this.handleUpdateAppendDataset(oDataset, uDataset);
        });
      }

      if (query?.distinct?.columns?.[0]) {
        this.handleAddDedupe(oDataset?.id, query?.distinct?.columns?.[0]);
      }

      if (query?.filter) {
        this.handleAddFilter(oDataset?.id, query?.filter);
      }

      if (query?.select) {
        query.select
          .filter((s) => s?.cases !== undefined)
          .forEach((customSelect) => {
            this.handleAddAction(oDataset, customSelect);
          });
      }
      if (query?.mutate) {
        query.mutate.forEach((customSelect) => {
          if (customSelect.type === "EXPRESSION") {
            addField(
              oDataset?.id,
              {
                value: customSelect?.expr?.operator,
                label: customSelect?.expr?.operator
              },
              {
                one: customSelect?.expr?.exprs?.[0]?.column,
                two: customSelect?.expr?.exprs?.[1]?.column
              },
              { columnLabel: customSelect.alias }
            );
          } else {
            this.handleAddAction(oDataset, customSelect);
          }
        });
      }
      if (query?.unpivot_and_pivot) {
        this.handleAddPivotAction(oDataset, query.unpivot_and_pivot, "Both");
      } else if (query?.pivot) {
        this.handleAddPivotAction(oDataset, query.pivot, "Pivot");
      } else if (query?.unpivot) {
        this.handleAddPivotAction(oDataset, query.unpivot, "Unpivot");
      }

      if (query?.joins) {
        query.joins.forEach((join) => {
          const jDataset = this.getDatasetFromId(join.source);

          const selectedDataset = {
            label: jDataset?.label,
            value: jDataset
          };

          let jData = {
            selectedDataset: selectedDataset,
            prefix: join.prefix,
            type: join.type,
            lookupKeys: {}
          };

          if (join.conditions !== undefined) {
            join.conditions.forEach((lookKey, lookIndex) => {
              jData.lookupKeys[lookIndex] = {
                left: lookKey["left_key"],
                right: lookKey["right_key"]
              };
            });
          }

          this.updateJoinBase(oDataset?.id, jData);

          /*
          if (jDataset !== undefined) {
            this.updateJoinData(oDataset?.id, "selectedDataset", {
              label: jDataset?.label,
              value: jDataset,
            });
          }

          if (join.prefix !== undefined) {
            this.updateJoinData(oDataset?.id, "prefix", join.prefix);
          }
          if (join.type !== undefined) {
            this.updateJoinData(oDataset?.id, "type", join.type);
          }

          if (join.conditions !== undefined) {
            join.conditions.forEach((lookKey, lookIndex) => {
              this.updateLookupKey(oDataset?.id, lookIndex, {
                left: lookKey["left_key"],
                right: lookKey["right_key"],
              });
            });
          }
          */
        });
      }
    });

    this.setState({
      replayTransform: { ...replayTransform, [oDataset?.id]: datasetOptions }
    });
  }

  renderReplayTransform(dataset) {
    const { datasets } = this.props;
    const { replayTransform, ignoredActions } = this.state;

    const selectedDatasets = replayTransform?.[dataset?.id];

    let allUpdates = [];

    const findPivot = (node) => {
      if (node?.right?.type === "UNPIVOT_PIVOT") {
        return node;
      } else if (node?.input) {
        return findPivot(node?.input);
      }
    };

    selectedDatasets &&
      selectedDatasets.forEach((d) => {
        const sDataset = d?.value;
        const transformQuery = sDataset?.transformations?.query;
        const replayUpdates = this.getReplayUpdates(sDataset, transformQuery);

        const plan = sDataset?.transformations?.plan;

        allUpdates = [...allUpdates, ...replayUpdates];
      });

    return (
      <div className={styles.replayTransform}>
        <div className={styles.jBold}>{selectedDatasets ? "Selected Dataset(s)" : "Select Dataset"}</div>
        <Select
          options={
            datasets
              ? datasets
                  .filter(
                    (d) => d?.transformations?.query !== undefined && Object.keys(d?.transformations?.query).length > 0
                  )
                  .map((d) => {
                    const dUpdates = this.getReplayUpdates(d, d?.transformations?.query);

                    return {
                      value: d,
                      label: d.label + (dUpdates ? " (" + dUpdates.length + ")" : "")
                    };
                  })
              : []
          }
          onChange={(val) => {
            const rDataset = val?.[0]?.value;

            const oldReplays = this.state.replayTransform?.[dataset?.id];

            const missingDatasets =
              oldReplays === undefined
                ? []
                : oldReplays.filter(
                    (oOption) => val.find((fOptions) => fOptions?.value?.id === oOption?.value?.id) === undefined
                  );

            const mDataset = missingDatasets?.[0]?.value;

            console.log("old replays, new replays", oldReplays, val, missingDatasets, mDataset);

            this.handleReplay(dataset, val);

            this.setState({
              datasetOutcomes: {
                ...this.state.datasetOutcomes,
                [dataset?.id]: rDataset?.outcome
              }
            });

            if (mDataset !== undefined) {
              this.handleRemoveReplay(dataset, mDataset);
            }
          }}
          isMulti
          isClearable={false}
          placeholder="Search or Select a Dataset"
        />
        {allUpdates && allUpdates.length > 0 ? (
          <div className={styles.replayTransformActions}>
            {allUpdates.map((action) => this.renderQueryItem(dataset, action))}
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }

  getDatasetLabelFromId(datasetId) {
    const { datasets } = this.props;

    return datasets ? datasets.find((d) => d.id === datasetId)?.label || "..." : "...";
  }

  getDatasetFromId(datasetId) {
    const { datasets } = this.props;

    return datasets ? datasets.find((d) => d.id === datasetId) : undefined;
  }

  getDatasetFromSourceUrl(sourceUrl) {
    const { datasets } = this.props;

    return datasets ? datasets.find((d) => d.source?.url === sourceUrl) : undefined;
  }

  getReplayUpdates(dataset, transformQuery, isAddedFromPlan = false) {
    let replayUpdates = [];

    // IGNORE AUTO EXCLUDED COLUMNS (FROM MODIFY COLUMN NAME/TYPE)
    const excludeColumns =
      transformQuery?.exclude_columns === undefined
        ? []
        : transformQuery?.exclude_columns.filter((eColumn) => {
            const fMutate =
              transformQuery?.mutate === undefined
                ? undefined
                : transformQuery.mutate.find(
                    (mutate) =>
                      eColumn !== undefined &&
                      (mutate?.column === eColumn ||
                        (mutate?.expr?.type === "CAST" && mutate?.expr?.expr?.column === eColumn))
                  );

            return fMutate === undefined ? true : false;
          });

    // EXCLUDE COLUMNS JQL TO READABLE
    if (excludeColumns.length > 0) {
      replayUpdates.push({
        type: "Exclude",
        data: excludeColumns,
        key: "exclude_columns",
        icon: FilterIcon,
        label: "Filtering Columns",
        subItem: excludeColumns?.reduce((a, b, i) => a + b + (i < excludeColumns.length - 1 ? ", " : ""), ""),
        date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
        details: undefined,
        datasetId: dataset?.id
      });
    }

    // APPEND JQL TO READABLE
    if (transformQuery?.unions !== undefined) {
      replayUpdates.push({
        type: "Append",
        data: transformQuery?.unions,
        key: "unions",
        icon: AppendIcon,
        label: "Appending Dataset",
        subItem: this.getDatasetLabelFromId(transformQuery?.unions?.[0]?.source),
        date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
        details: undefined,
        datasetId: dataset?.id
      });
    }

    // DEDUPLICATE JQL TO READABLE
    if (transformQuery?.distinct !== undefined) {
      replayUpdates.push({
        type: "Distinct",
        data: transformQuery?.distinct,
        key: "distinct",
        icon: BanIcon,
        label: "Deduplicate Rows",
        subItem: transformQuery?.distinct?.columns
          ? transformQuery.distinct.columns.reduce(
              (a, b, i) => a + (i < transformQuery.distinct.columns.length - 1 ? ", " : "") + b,
              ""
            )
          : "",
        date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
        details: undefined,
        datasetId: dataset?.id
      });
    }

    // PIVOT JQL TO READABLE
    if (transformQuery?.pivot !== undefined) {
      const columns =
        transformQuery?.pivot?.id_columns !== undefined && transformQuery?.pivot?.id_columns.length > 0
          ? transformQuery.pivot.id_columns
          : transformQuery?.pivot?.value_columns !== undefined
            ? transformQuery.pivot.value_columns
            : [];
      const isId = transformQuery?.pivot?.id_columns && transformQuery?.pivot?.id_columns.length > 0 ? true : false;

      replayUpdates.push({
        type: "Pivot",
        data: transformQuery?.pivot,
        key: "pivot",
        icon: PivotIcon,
        label: "Pivot Dataset",
        subItem:
          (isId ? "ID Columns: " : "Row Columns: ") +
          columns.reduce((a, b, i) => a + b + (i < columns.length - 1 ? ", " : ""), ""),
        date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
        details: undefined,
        datasetId: dataset?.id
      });
    }

    // PIVOT JQL TO READABLE
    if (transformQuery?.unpivot !== undefined) {
      const columns =
        transformQuery?.unpivot?.id_columns !== undefined && transformQuery?.unpivot?.id_columns.length > 0
          ? transformQuery.unpivot.id_columns
          : transformQuery?.unpivot?.value_columns !== undefined
            ? transformQuery.unpivot.value_columns
            : [];
      const isId = transformQuery?.unpivot?.id_columns && transformQuery?.unpivot?.id_columns.length > 0 ? true : false;

      replayUpdates.push({
        type: "Unpivot",
        data: transformQuery?.unpivot,
        key: "unpivot",
        icon: PivotIcon,
        label: "Unpivot Dataset",
        subItem:
          (isId ? "ID Columns: " : "Row Columns: ") +
          columns.reduce((a, b, i) => a + b + (i < columns.length - 1 ? ", " : ""), ""),
        date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
        details: undefined,
        datasetId: dataset?.id
      });
    }

    // PIVOT JQL TO READABLE
    if (transformQuery?.unpivot_and_pivot !== undefined) {
      const columns =
        transformQuery?.unpivot_and_pivot?.id_columns !== undefined &&
        transformQuery?.unpivot_and_pivot?.id_columns.length > 0
          ? transformQuery.unpivot_and_pivot.id_columns
          : transformQuery?.unpivot_and_pivot?.value_columns !== undefined
            ? transformQuery.unpivot_and_pivot.value_columns
            : [];
      const isId =
        transformQuery?.unpivot_and_pivot?.id_columns && transformQuery?.unpivot_and_pivot?.id_columns.length > 0
          ? true
          : false;

      const sourceDataset = this.getDatasetFromSourceUrl(transformQuery?.unpivot_and_pivot?.input?.source?.url);

      replayUpdates.push({
        type: "Pivot and Unpivot",
        data: transformQuery?.unpivot_and_pivot,
        key: "unpivot_and_pivot",
        icon: PivotIcon,
        label: "Pivot and Unpivot Dataset",
        subItem:
          (isId ? "ID Columns: " : "Row Columns: ") +
          columns.reduce((a, b, i) => a + b + (i < columns.length - 1 ? ", " : ""), ""),
        date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
        details: undefined,
        datasetId: dataset?.id,
        sourceDatasetId: sourceDataset?.id,
        isAddedFromPlan: isAddedFromPlan
      });
    }

    // JOIN JQL TO READABLE
    if (transformQuery?.joins !== undefined) {
      const join = transformQuery?.joins?.[0];

      replayUpdates.push({
        type: "Join",
        joinType:
          join.type === "INNER"
            ? "Inner Join"
            : join.type === "LOOKUP"
              ? "Lookup"
              : join.type === "LEFT"
                ? "Left Join"
                : join.type === "Right"
                  ? "Right Join"
                  : "Left Join",
        data: transformQuery?.joins,
        key: "joins",
        icon:
          join.type === "INNER"
            ? InnerJoinIcon
            : join.type === "LOOKUP"
              ? LookupIcon
              : join.type === "LEFT"
                ? LeftJoinIcon
                : join.type === "RIGHT"
                  ? RightJoinIcon
                  : JoinIcon,
        label: "Joining Dataset",
        subItem:
          (transformQuery?.joins?.[0]?.type === "INNER"
            ? "Inner"
            : transformQuery?.joins?.[0]?.type === "LEFT"
              ? "Left"
              : transformQuery?.joins?.[0]?.type !== undefined
                ? transformQuery?.joins?.[0]?.type
                : "Left") +
          " join with " +
          this.getDatasetLabelFromId(transformQuery?.joins?.[0]?.source),
        date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
        details: undefined,
        datasetId: dataset?.id
      });
    }

    // FILTER JQL TO READABLE
    if (transformQuery?.filter !== undefined) {
      replayUpdates.push({
        type: "Row Filter",
        data: transformQuery?.filter,
        key: "filter",
        icon: FilterIcon,
        label: "Row Filter",
        subItem: this.renderCondition(transformQuery?.filter),
        date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
        details: undefined,
        datasetId: dataset?.id
      });
    }

    const baseSelect = this.generateBaseSelect(dataset);

    // SELECT JQL TO READABLE
    if (transformQuery?.select !== undefined) {
      let derivedVariables = [];
      let customVariables = [];

      transformQuery?.select.forEach((select) => {
        if (select?.expr !== undefined || select?.exprs !== undefined) {
          derivedVariables.push(select);
        }

        if (select?.cases !== undefined) {
          customVariables.push(select);
        }
      });

      // DERIVED
      if (derivedVariables.length > 0) {
        replayUpdates.push({
          type: "Created Derived Variable" + (derivedVariables.length > 1 ? "s" : ""),
          key: "select",

          data: transformQuery?.select,
          icon: DerivedIcon,
          label: "Created Derived Variable" + (derivedVariables.length > 1 ? "s" : ""),
          subItem: derivedVariables.reduce(
            (a, b, i) => a + b?.alias + (derivedVariables.length === i + 1 ? "" : ", "),
            ""
          ),
          date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
          details: undefined,
          datasetId: dataset?.id
        });
      }

      // CUSTOM
      if (customVariables.length > 0) {
        customVariables.forEach((cSelect) => {
          replayUpdates.push({
            type: "Created If/Then/Else Rule",
            key: "select",

            data: cSelect,
            icon: IfElseIcon,
            label: "Created If/Then/Else Rule",
            subItem: customVariables.reduce(
              (a, b, i) => a + b?.alias + (customVariables.length === i + 1 ? "" : ", "),
              ""
            ),
            date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
            details: undefined,
            datasetId: dataset?.id
          });
        });
      }
    }

    // MUTATE JQL TO READABLE
    if (transformQuery?.mutate !== undefined) {
      let derivedVariables = [];
      let customVariables = [];
      let modifyType = [];
      let modifyCol = [];

      transformQuery?.mutate.forEach((mutate) => {
        if ((mutate?.expr !== undefined && mutate?.expr?.type !== "CAST") || mutate?.exprs !== undefined) {
          derivedVariables.push(mutate);
        }

        if (mutate?.expr !== undefined && mutate?.expr?.type === "CAST") {
          modifyType.push(mutate);
        }

        if (mutate?.column) {
          modifyCol.push(mutate);
        }

        if (mutate?.cases !== undefined) {
          customVariables.push(mutate);
        }
      });

      // DERIVED
      if (derivedVariables.length > 0) {
        replayUpdates.push({
          type: "Created Derived Variable" + (derivedVariables.length > 1 ? "s" : ""),
          key: "mutate",

          data: transformQuery?.mutate,
          icon: DerivedIcon,
          label: "Created Derived Variable" + (derivedVariables.length > 1 ? "s" : ""),
          subItem: derivedVariables.reduce(
            (a, b, i) => a + b?.alias + (derivedVariables.length === i + 1 ? "" : ", "),
            ""
          ),
          date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
          details: undefined,
          datasetId: dataset?.id
        });
      }

      // MODIFY TYPE
      if (modifyType.length > 0) {
        replayUpdates.push({
          type: "Updated Column Type" + (modifyType.length > 1 ? "s" : ""),
          key: "mutate",

          data: transformQuery?.mutate,
          icon: Sliders,
          label: "Updated Column Type" + (modifyType.length > 1 ? "s" : ""),
          subItem: modifyType.reduce(
            (a, b, i) =>
              a +
              (b?.alias + ": " + (b?.expr?.new_type === "TEXT" ? "Text" : "Number")) +
              (modifyType.length === i + 1 ? "" : ", "),
            ""
          ),
          date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
          details: undefined,
          datasetId: dataset?.id
        });
      }

      // MODIFY NAME
      if (modifyCol.length > 0) {
        replayUpdates.push({
          type: "Updated Column Name" + (modifyCol.length > 1 ? "s" : ""),
          key: "mutate",

          data: transformQuery?.mutate,
          icon: Sliders,
          label: "Updated Column Name" + (modifyCol.length > 1 ? "s" : ""),
          subItem: modifyCol.reduce(
            (a, b, i) => a + (b?.column + ": " + b?.alias) + (modifyCol.length === i + 1 ? "" : ", "),
            ""
          ),
          date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
          details: undefined,
          datasetId: dataset?.id
        });
      }

      // CUSTOM
      if (customVariables.length > 0) {
        customVariables.forEach((cSelect) => {
          replayUpdates.push({
            type: "Created If/Then/Else Rule",
            key: "mutate",

            data: cSelect,
            icon: IfElseIcon,
            label: "Created If/Then/Else Rule",
            subItem: customVariables.reduce(
              (a, b, i) => a + b?.alias + (customVariables.length === i + 1 ? "" : ", "),
              ""
            ),
            date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
            details: undefined,
            datasetId: dataset?.id
          });
        });
      }
    }

    return replayUpdates;
  }

  // QUERY BUILDER TRANSFORM
  getTransformQuery(dataset) {
    const {
      joinData,
      appendData,
      filterData,
      customTransforms,
      modifyFields,
      autoTransformLabels,
      replayTransform,
      pivotData,
      isBadPivot,
      isIdColumns
    } = this.state;
    const datasetId = dataset?.id;

    const joinState = joinData?.[datasetId];
    const appendState = appendData?.[datasetId];
    const filterState = filterData?.[datasetId];
    const customState = customTransforms?.[datasetId];
    const modifyState = modifyFields?.[datasetId];

    const aTransformLabels = autoTransformLabels?.[datasetId];

    const autoTransforms = dataset?.dataTransforms;
    const manualTransforms = dataset?.manualTransforms;

    const excludeColumns = filterState?.exclude_columns;

    let retQuery = {
      query: {}
    };
    let infoQuery = {};

    // EXCLUDE COLUMNS
    if (excludeColumns && excludeColumns.length > 0) {
      retQuery.query.exclude_columns = excludeColumns.map((c) => c);
    }

    // FILTER
    if (filterState !== undefined) {
      const rowFilters = filterState?.row_filters
        ? filterState?.row_filters.filter((c) => ConditionUtils.isValid(c))
        : [];

      if (rowFilters && rowFilters.length > 0) {
        retQuery.query.filter = this.getConditionFromConditions(rowFilters);
      }

      if (filterState?.unique_id_columns) {
        retQuery.query.distinct = {
          columns: [...filterState?.unique_id_columns]
        };
      }
    }

    // JOINS
    if (joinState !== undefined && joinState?.lookupKeys && joinState?.selectedDataset) {
      retQuery.query.joins = [
        {
          source: joinState?.selectedDataset?.value?.id,
          type:
            joinState?.joinType === "LOOKUP" || joinState?.joinType === "RIGHT"
              ? joinState?.joinType === "LEFT"
              : joinState?.joinType !== undefined
                ? joinState?.joinType
                : "LEFT",
          prefix: joinState?.prefix,
          conditions: Object.keys(joinState?.lookupKeys)
            .filter((lKey) => joinState?.lookupKeys?.[lKey]?.isDelete !== true)
            .map((lKey) => ({
              left_key: joinState?.lookupKeys?.[lKey]?.left?.label,
              right_key: joinState?.lookupKeys?.[lKey]?.right?.label
            }))
        }
      ];
    }

    // DERIVED FIELDS
    if (autoTransforms && autoTransforms.length > 0) {
      if (retQuery.query.mutate === undefined) {
        retQuery.query.mutate = this.generateBaseSelect(dataset);
      }

      autoTransforms.forEach((auto) => {
        const expr = this.generateExpr(auto, aTransformLabels);

        if (expr) {
          retQuery.query.mutate.push(expr);
        }
      });
    }

    // CREATE DERIVED FIELDS (MANUAL CALC FIELDS)
    if (manualTransforms && Object.keys(manualTransforms).length > 0) {
      if (retQuery.query.mutate === undefined) {
        retQuery.query.mutate = this.generateBaseSelect(dataset);
      }

      Object.keys(manualTransforms)
        .filter(
          (mKey) =>
            manualTransforms[mKey]?.deleted !== true &&
            manualTransforms[mKey]?.fieldOne !== undefined &&
            manualTransforms[mKey]?.operation !== undefined
        )
        .forEach((mKey) => {
          const manual = manualTransforms[mKey];

          const alias =
            manual?.columnLabel ||
            manual?.fieldOne?.value + "_" + manual?.operation?.value + "_" + manual?.fieldTwo?.value;

          const pSelect = Expressions.aliasedExpression(
            Expressions.binaryOperation(manual?.operation?.value, [
              Expressions.column(manual?.fieldOne?.value),
              Expressions.column(manual?.fieldTwo?.value)
            ]),
            alias
          );

          retQuery.query.mutate.push(pSelect);
        });
    }

    if (customState !== undefined && Object.keys(customState).length > 0) {
      if (retQuery.query.mutate === undefined) {
        retQuery.query.mutate = this.generateBaseSelect(dataset);
      }

      Object.keys(customState).forEach((cKey, cInd) => {
        const customCol = customState[cKey];

        const cases = customCol?.segments
          ? Object.keys(customCol.segments).map((sKey, vInd) => ({
              value:
                customCol.segments[sKey]?.columnValue !== undefined
                  ? customCol.segments[sKey]?.columnValue
                  : "Custom Value" + vInd,
              condition: this.getConditionFromConditions(customCol.segments[sKey]?.conditions)
            }))
          : [];

        const elseValue = customCol?.elseValue || "Other (Custom Field)";

        const alias = customCol?.columnName !== undefined ? customCol?.columnName : "Custom Field" + cInd;

        const retSelect = Expressions.ifThenWithAlias(cases, elseValue, alias);

        retQuery.query.mutate.push(retSelect);
      });
    }

    // APPEND
    if (appendState && appendState?.selectedDataset) {
      const unmatchedFields = appendState?.fields
        ? Object.keys(appendState.fields).filter((fKey) => appendState.fields[fKey]?.isAutomatic !== true)
        : [];

      retQuery.query.unions =
        unmatchedFields.length === 0
          ? [{ source: appendState?.selectedDataset?.id }]
          : [
              {
                source: {
                  query: {
                    select: this.generateBaseSelect(
                      appendState?.selectedDataset,
                      [],
                      unmatchedFields.map((uField) => ({
                        column: uField,
                        alias: appendState.fields[uField]?.label
                      }))
                    )
                  },
                  source: appendState?.selectedDataset?.id
                }
              }
            ];
    }

    // PIVOT
    const pivotState = pivotData?.[datasetId];

    const idColumnsClean = pivotState?.idColumns ? pivotState?.idColumns.map((c) => c.value) : [];
    const rowColumnsClean = pivotState?.rowColumns ? pivotState?.rowColumns.map((c) => c.value) : [];

    if (pivotState !== undefined) {
      if (isBadPivot === "Unpivot" || isBadPivot === undefined) {
        retQuery.query.unpivot = {
          id_columns:
            pivotState?.idColumns === undefined && pivotState?.rowColumns !== undefined && isIdColumns !== true
              ? Object.keys(dataset.fields)
                  .filter((fKey) => rowColumnsClean.indexOf(fKey) === -1)
                  .map((fKey) => fKey)
              : pivotState?.idColumns === undefined
                ? []
                : pivotState?.idColumns.map((c) => c.value),
          value_columns:
            pivotState?.rowColumns === undefined && pivotState?.idColumns !== undefined && isIdColumns == true
              ? Object.keys(dataset.fields)
                  .filter((fKey) => idColumnsClean.indexOf(fKey) === -1)
                  .map((fKey) => fKey)
              : pivotState?.rowColumns === undefined
                ? undefined
                : pivotState?.rowColumns.map((c) => c.value),
          variable_alias: pivotState?.varColName !== undefined ? pivotState?.varColName : "group",
          value_alias: pivotState?.valColName !== undefined ? pivotState?.valColName : "value"
        };
      } else if (isBadPivot === "Pivot") {
        retQuery.query.pivot = {
          id_columns: pivotState?.idColumns === undefined ? [] : pivotState?.idColumns.map((c) => c.value),
          wide_column: pivotState?.wideColumn !== undefined ? pivotState?.wideColumn : "value",
          wide_values: dataset.fields?.[pivotState?.wideColumn]?.data
            ? dataset.fields?.[pivotState?.wideColumn]?.data.map((d) => d.value)
            : [],
          value_column: pivotState?.valueColumn,
          agg_func: pivotState?.aggFunc !== undefined ? pivotState?.aggFunc : "first"
        };
      } else if (isBadPivot === "Both") {
        retQuery.query.unpivot_and_pivot = {
          id_columns:
            pivotState?.idColumns === undefined && pivotState?.rowColumns !== undefined && isIdColumns !== true
              ? Object.keys(dataset.fields)
                  .filter((fKey) => rowColumnsClean.indexOf(fKey) === -1)
                  .map((fKey) => fKey)
              : pivotState?.idColumns === undefined
                ? []
                : pivotState?.idColumns.map((c) => c.value),
          value_columns:
            pivotState?.rowColumns === undefined && pivotState?.idColumns !== undefined && isIdColumns == true
              ? Object.keys(dataset.fields)
                  .filter((fKey) => idColumnsClean.indexOf(fKey) === -1)
                  .map((fKey) => fKey)
              : pivotState?.rowColumns === undefined
                ? undefined
                : pivotState?.rowColumns.map((c) => c.value),
          variable_alias: pivotState?.varColName !== undefined ? pivotState?.varColName : "group",
          wide_column: pivotState?.wideColumn !== undefined ? pivotState?.wideColumn : "value",
          wide_values: dataset.fields?.[pivotState?.wideColumn]?.data
            ? dataset.fields?.[pivotState?.wideColumn]?.data.map((d) => d.value).filter((v) => v != "{Other}")
            : []
        };
      }
    }

    // MODIFY
    if (modifyState !== undefined) {
      if (retQuery.query.mutate === undefined) {
        retQuery.query.mutate = this.generateBaseSelect(dataset);
      }
    }

    const selectedDatasets = replayTransform?.[dataset?.id];
    const ignoredUpdates = this.state?.ignoredActions?.[dataset?.id];

    let allUpdates = [];

    selectedDatasets &&
      selectedDatasets.forEach((d) => {
        const sDataset = d?.value;
        const transformQuery = sDataset?.transformations?.query;
        const replayUpdates = this.getReplayUpdates(sDataset, transformQuery);

        allUpdates = [...allUpdates, ...replayUpdates].filter(
          (u) => ignoredUpdates === undefined || ignoredUpdates?.[u?.datasetId + "_" + u.type] !== true
        );
      });

    if (allUpdates.length > 0) {
      allUpdates
        .filter((rUpdate) => rUpdate?.data?.cases === undefined)
        .forEach((rUpdate) => {
          if (rUpdate?.key === "filter") {
            if (retQuery?.query?.filter?.condition?.conditions !== undefined) {
              retQuery.query.filter.condition.conditions.push(rUpdate?.data);
            } else if (retQuery?.query?.filter?.condition) {
              const tCondition = { ...retQuery?.query?.filter?.condition };
              retQuery.query.filter.condition = {
                type: "AND",
                conditions: [...tCondition, ...rUpdate.data]
              };
            } else {
              retQuery.query.filter = rUpdate.data;
            }
          } else if (rUpdate?.key === "mutate") {
            if (retQuery?.query?.[rUpdate.key] === undefined) {
              retQuery.query[rUpdate.key] = [];
            }

            if (Array.isArray(rUpdate?.data)) {
              if (rUpdate?.type === "Created Derived Variable") {
                retQuery.query[rUpdate.key] = retQuery.query[rUpdate.key].concat(
                  rUpdate?.data.filter((sObj) => sObj?.alias !== undefined && sObj?.alias === rUpdate?.subItem)
                );
              } else {
                retQuery.query[rUpdate.key] = retQuery.query[rUpdate.key].concat(rUpdate?.data);
              }
            } else {
              retQuery.query[rUpdate.key].push(rUpdate?.data);
            }
          } else if (rUpdate?.key === "exclude_columns") {
            if (retQuery?.query?.[rUpdate.key] === undefined) {
              retQuery.query[rUpdate.key] = [];
            }

            if (Array.isArray(rUpdate?.data)) {
              retQuery.query[rUpdate.key] = retQuery.query[rUpdate.key].concat(
                rUpdate?.data.filter((eKey) => retQuery.query[rUpdate.key].indexOf(eKey) === -1)
              );
            } else {
              retQuery.query[rUpdate.key].push(rUpdate?.data);
            }
          } else {
            retQuery.query[rUpdate.key] = rUpdate?.data;
          }
        });
    }

    return retQuery;
  }

  getConditionFromConditions(conditions) {
    return conditions === undefined
      ? {}
      : conditions.length === 1
        ? { ...conditions[0] }
        : { type: "AND", conditions: [...conditions] };
  }

  generateBaseSelect(dataset, excludeColumns = [], replaceColumns = []) {
    const { modifyFields } = this.state;

    const modifyState = modifyFields?.[dataset?.id];

    let retSelect = [];

    dataset &&
      dataset.fields &&
      Object.keys(dataset.fields)
        .filter((f) => excludeColumns.find((c) => c === f) === undefined)
        .forEach((fKey) => {
          const modify = modifyState?.[fKey];
          const replaceColumn = replaceColumns.find((r) => r?.column === fKey);

          let retSelectField = replaceColumn ? replaceColumn : fKey;

          if (modify) {
            if (modify?.changeType) {
              retSelectField = Expressions.aliasedExpression(
                Expressions.cast(Expressions.column(fKey), modify?.changeType),
                modify?.changeName || fKey
              );
            } else {
              retSelectField = Expressions.columnProjection(fKey, modify?.changeName);
            }

            retSelect.push(retSelectField);
          }
        });

    return retSelect;
  }

  generateExpr(autoTransform, autoTransformLabels) {
    const dateTypes = [
      { type: "MonthlySeasonalityTransform", part: "month" },
      { type: "WeekdaySeasonalityTransform", part: "dow" },
      { type: "TimeTrendTransform", part: "epoch" }
    ];

    const mathTypes = [
      { type: "LogTransform", func: "log" },
      { type: "SquareRootTransform", func: "sqrt" }
    ];

    const mType = mathTypes.find((f) => f.type === autoTransform?.type);
    const dType = dateTypes.find((f) => f.type === autoTransform?.type);

    const alias =
      autoTransformLabels?.[autoTransform?.variable + "_" + autoTransform?.type] ||
      autoTransform?.variable + "_" + autoTransform?.type;

    const retExpr =
      autoTransform?.type === "ReciprocalTransform"
        ? Expressions.binaryOperation("/", [1, Expressions.column(autoTransform?.variable)])
        : mType
          ? Expressions.unaryFunction(mType?.func, Expressions.column(autoTransform?.variable))
          : dType
            ? Expressions.datePart(Expressions.column(autoTransform?.variable), dType?.part)
            : undefined;

    if (retExpr === undefined) {
      return retExpr;
    }

    return Expressions.aliasedExpression(retExpr, alias);
  }

  // Mid of three
  renderSettings(dataset) {
    const { updateDatasetRefreshSchedule } = this.props;
    const oStyle = {};

    const isOpenDataValidation = this.getIsOpenTile(dataset?.id, "Data Validation");
    const isOpenSettings = this.getIsOpenTile(dataset?.id, "Settings");
    const isOpenLineage = this.getIsOpenTile(dataset?.id, "Lineage");

    const hasRefreshRate = dataset?.source?.content?.type === "CONNECTION_METADATA";
    const refreshRate = dataset?.datasetRefreshSchedule;
    const selectedRefreshRate = DATASET_REFRESH_RATE_OPTIONS?.find((o) => o.value === refreshRate);

    return (
      <div
        className={isOpenSettings ? styles.openOverview : styles.overview}
        style={{
          maxHeight: isOpenSettings ? "500px" : "190px",
          width:
            isOpenSettings || (isOpenDataValidation && (isOpenLineage || !isEnabled("sense-transformations")))
              ? "100%"
              : (isOpenDataValidation && !isOpenLineage) ||
                  (!isOpenDataValidation && isOpenLineage) ||
                  !isEnabled("sense-transformations")
                ? "calc(50% - 15px)"
                : "calc(33.333% - 14px)",
          overflow: isOpenSettings ? "auto" : "hidden",
          marginLeft:
            isOpenSettings || isOpenDataValidation
              ? "10px"
              : isOpenLineage || !isEnabled("sense-transformations")
                ? "0px"
                : "0px"
        }}
        onClick={isOpenSettings !== true ? () => this.toggleIsOpenTile(dataset?.id, "Settings") : () => {}}
      >
        <div className={styles.senseTitle}>
          <div className={styles.sTitle}>
            <span className={styles.sIcon}>
              <img src={GearIcon} style={{ height: "16px", width: "16px" }} />
            </span>
            <span>{"Settings"}</span>
          </div>
          {isOpenSettings ? (
            <div className={styles.closeButton} onClick={() => this.toggleIsOpenTile(dataset?.id, "Settings")}>
              <Button style={{ padding: "3px" }}>
                <div className={styles.selIcon} title="Close">
                  <FontAwesomeIcon icon={faCompressArrowsAlt} />
                </div>
              </Button>
            </div>
          ) : (
            <div className={styles.selIcon + " " + styles.expandIcon}>
              <FontAwesomeIcon icon={faExpandArrowsAlt} />
            </div>
          )}
        </div>
        {/* TODO: Add this settings slider
        <div className={styles.tileFlex}>
          <div className={styles.tTop} style={{ color: "#54C06C" }}>
            <FontAwesomeIcon icon={faChevronDown} />
          </div>
          <div className={styles.tBot}>{"MINIMIZE COSTS"}</div>
        </div>
        */}
        {hasRefreshRate ? (
          <div className={styles.tileFlex}>
            <div className={styles.tTop}>{selectedRefreshRate?.label}</div>
            <div className={styles.tBot}>{"REFRESH RATE"}</div>
          </div>
        ) : (
          <div className={styles.tileFlex}>
            <div className={styles.tTop}>{dataset?.created_by?.fullname}</div>
            <div className={styles.tBot}>{"CREATED BY"}</div>
          </div>
        )}
        {isOpenSettings && (
          <div className={styles.dSettings}>
            {/* TODO: Add this settings slider
            <div className={styles.dSlider}>
              <div>{"What is your priority for the AI evaluations?"}</div>
              <div>
                {"Aible will minimize costs by not automatically " +
                  "running any AI or insight analyses."}
              </div>
            </div>
            */}
            {hasRefreshRate && (
              <div className={styles.settingsRefreshWrapper}>
                <div className={styles.settingsRefreshTitle}>
                  {"How often would you like this dataset to automatically refresh?"}
                </div>
                <div className={styles.settingsRefreshSelect}>
                  <Select
                    options={DATASET_REFRESH_RATE_OPTIONS}
                    value={selectedRefreshRate}
                    onChange={(val) => {
                      updateDatasetRefreshSchedule(dataset?.id, val.value);
                    }}
                    menuPlacement={"bottom"}
                  />
                </div>
              </div>
            )}
            {this.renderRename(dataset)}
          </div>
        )}
      </div>
    );
  }

  // Terrible way to extract the dataset source from the plans object
  findFromDataset(dataset) {
    const firstInput = dataset?.transformations?.plan?.relation;

    const dUrl = this.checkForDataset(firstInput);
    const retDataset = this.getDatasetFromSourceUrl(dUrl);

    return retDataset;
  }

  checkForDataset(input) {
    if (input?.source?.url) {
      return input?.source?.url;
    } else if (input?.input) {
      return this.checkForDataset(input?.input);
    } else {
      return undefined;
    }
  }

  // Right of three
  renderLineage(dataset, isSingleCol = false) {
    const { isOpenLastTransformQuery } = this.state;

    const oStyle = {};

    const isOpenTransformations = this.getIsOpenTile(dataset?.id, "Transformations");
    const isOpenDataValidation = this.getIsOpenTile(dataset?.id, "Data Validation");
    const isOpenSettings = this.getIsOpenTile(dataset?.id, "Settings");
    const isOpenLineage = this.getIsOpenTile(dataset?.id, "Lineage");

    const totalUpdates = this.getReadableTransformUpdates(dataset);

    const transformQuery = dataset?.transformations?.query;
    const lastTransformUpdates = this.getReplayUpdates(dataset, transformQuery);

    const pendingQuery = this.getTransformQuery(dataset);
    const pendingTransformUpdates = this.getReplayUpdates(dataset, pendingQuery?.query);

    const isEmpty = transformQuery?.query && Object.keys(transformQuery?.query).length === 0;

    const isOpenQuery = isOpenLastTransformQuery?.[dataset?.id] === true;

    const fromDataset = this.findFromDataset(dataset);

    return (
      <div
        className={isOpenLineage ? styles.openOverview : styles.overview}
        style={{
          maxHeight: isOpenLineage ? "500px" : "190px",
          width: isSingleCol
            ? "100%"
            : isOpenSettings
              ? "100%"
              : isOpenLineage
                ? "100%"
                : isOpenDataValidation
                  ? "calc(50% - 15px)"
                  : "calc(33.333% - 14px)",
          overflow: isOpenQuery ? "hidden" : isOpenLineage ? "auto" : "auto",
          marginLeft: isSingleCol || isOpenSettings || isOpenLineage ? "10px" : "0px"
        }}
        onClick={isOpenLineage !== true ? () => this.toggleIsOpenTile(dataset?.id, "Lineage") : () => {}}
        id={"lineage_" + dataset?.id}
      >
        <div className={styles.senseTitle}>
          <div className={styles.sTitle}>
            <span className={styles.sIcon}>
              <img src={ClockIcon} style={{ height: "16px", width: "16px" }} />
            </span>
            <span>{"Lineage/Usage"}</span>
          </div>
          {isOpenLineage ? (
            <div className={styles.closeButton} onClick={() => this.toggleIsOpenTile(dataset?.id, "Lineage")}>
              <Button style={{ padding: "3px" }}>
                <div className={styles.selIcon} title="Close">
                  <FontAwesomeIcon icon={faCompressArrowsAlt} />
                </div>
              </Button>
            </div>
          ) : (
            <div className={styles.selIcon + " " + styles.expandIcon}>
              <FontAwesomeIcon icon={faExpandArrowsAlt} />
            </div>
          )}
        </div>
        <div className={styles.updateTiles}>
          <div className={styles.tileFlex}>
            <div className={styles.tTop}>
              <span title={moment.utc(dataset.updated_date).local().format("MMMM Do YYYY, h:mm:ss a")}>
                {moment.utc(dataset.updated_date).local().fromNow()}
              </span>
            </div>
            <div className={styles.tBot}>{"LAST UPDATE"}</div>
          </div>
        </div>
        {isOpenLineage && (
          <div>
            <div
              className={styles.lineageItems}
              style={lastTransformUpdates && lastTransformUpdates.length > 0 ? { paddingBottom: "0px" } : {}}
            >
              {pendingTransformUpdates && pendingTransformUpdates.length > 0 && (
                <div className={styles.pendingUpdates} id={"pendingUpdates_" + dataset?.id}>
                  <div className={styles.tileFlex}>
                    <div className={styles.tTop}>
                      <span>{pendingTransformUpdates.length}</span>
                    </div>
                    <div className={styles.tBot}>{"PENDING UPDATES"}</div>
                  </div>
                  {pendingTransformUpdates.map((uItem, uIndex) => (
                    <LineageItem
                      icon={uItem.icon}
                      label={uItem.label}
                      subItem={uItem.subItem}
                      date={uItem.date}
                      details={uItem.details}
                      style={uIndex === pendingTransformUpdates.length - 1 ? { marginBottom: "0px" } : {}}
                    />
                  ))}
                </div>
              )}
              {lastTransformUpdates && (
                <div id={"lastUpdates_" + dataset?.id}>
                  <div className={styles.tileFlex}>
                    <div className={styles.tTop}>
                      <span>{lastTransformUpdates.length}</span>
                    </div>
                    <div className={styles.tBot}>{"UPDATES MADE"}</div>
                  </div>
                  {lastTransformUpdates.map((uItem) => (
                    <LineageItem
                      icon={uItem.icon}
                      label={uItem.label}
                      subItem={uItem.subItem}
                      date={uItem.date}
                      details={uItem.details}
                      style
                    />
                  ))}
                </div>
              )}
            </div>
            <LineageContainer
              datasetId={dataset?.id}
              senseState={totalUpdates}
              fromDataset={fromDataset}
              openAndScrollLineage={(dataset, divId) => this.openAndScrollLineage(dataset, divId, "center")}
            />
          </div>
        )}
        {isOpenLineage && transformQuery && (
          <div>
            <a
              className={styles.aLink}
              onClick={() => {
                this.setState({
                  isOpenLastTransformQuery: {
                    ...isOpenLastTransformQuery,
                    [dataset?.id]: !isOpenQuery
                  }
                });

                const lineageScroll = document.getElementById("lineage_" + dataset?.id);

                if (lineageScroll && isOpenQuery) {
                  setTimeout(() => lineageScroll.scrollTo({ top: 0, behavior: "smooth" }), 25);
                }

                if (lineageScroll && !isOpenQuery) {
                  setTimeout(() => {
                    const nextScroll = document.getElementById("lineage_" + dataset?.id);

                    nextScroll &&
                      nextScroll.scrollTo({
                        top: nextScroll.scrollHeight - nextScroll.offsetHeight,
                        behavior: "smooth"
                      });
                  }, 25);
                }
              }}
            >
              {isOpenQuery ? "Hide Last Transform Query" : "View Last Transform Query"}
            </a>
          </div>
        )}
        {isOpenLineage && transformQuery && isOpenQuery && (
          <div className={styles.viewLastTransformQuery}>
            <div>{"Last Transformation Query"}</div>
            <JSONInput
              viewOnly
              id="JSONQueryInput"
              placeholder={transformQuery}
              locale={locale}
              height={isEmpty ? "60px" : "440px"}
              confirmGood={false}
            />
          </div>
        )}
      </div>
    );
  }

  handleLoadWideDataset(datasetId) {
    const { fetchDatasetWithoutDetails } = this.props;

    this.setState({
      isLoading: {
        ...this.state?.isLoading,
        [datasetId]: true
      }
    });
    return fetchDatasetWithoutDetails(datasetId)
      .then(() => {
        this.setState({
          isLoading: {
            ...this.state?.isLoading,
            [datasetId]: false
          }
        });
      })
      .catch((e) => {
        console.log(e);
        this.setState({
          isLoading: {
            ...this.state?.isLoading,
            [datasetId]: true
          }
        });
      });
  }

  renderWideDatasetWarning(dataset) {
    const { tenant } = this.props;

    const datasetId = dataset?.id;

    const isLoadingDataset = this.state?.isLoading?.[datasetId];

    return (
      <div
        className={styles.overview}
        style={{
          maxHeight: "200px",
          width: "100%",
          overflow: "hidden",
          borderColor: "transparent",
          cursor: "default"
        }}
      >
        {isLoadingDataset ? (
          <div className={styles.dataErrorHeader + " " + styles.isWideDataset}>
            <LoadingIndicator style={{ margin: "0px" }} />
            <div style={{ marginLeft: "10px" }}>{"Loading Dataset..."}</div>
          </div>
        ) : (
          <React.Fragment>
            <div className={styles.senseTitle}>
              <div className={styles.dataErrorHeader + " " + styles.isWideDataset}>
                <span>
                  <Icon type={"warning"} size={18} />
                </span>
                <span style={{ marginLeft: "5px" }}>{"This is a really wide dataset"}</span>
              </div>
            </div>
            <div className={styles.senseErrorBody} style={{ marginTop: "10px" }}>
              {`This dataset is wider than ${WIDE_DATASET_COLUMN_COUNT} columns. Using this dataset may create performance issues up to a browser crash.`}
            </div>
            <div className={styles.senseErrorBody + " " + styles.isWideDataset} style={{ marginTop: "10px" }}>
              <Button type={"secondary"} onClick={() => this.handleLoadWideDataset(datasetId)}>
                {"I understand"}
              </Button>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }

  renderOverviewError(dataset) {
    const { tenant } = this.props;

    const isOpenOverviewError = this.getIsOpenTile(dataset?.id, "OverviewError");

    const datasetErrors = dataset?.errors?.filter((e) => e?.message && !e.message.includes("See notebook output:"));

    const hasErrors = Boolean(datasetErrors?.length);

    const isSchemaDownload = dataset?.source?.content?.type === "CONNECTION_METADATA";
    let datasetSource;
    if (isSchemaDownload) {
      datasetSource = DATA_SOURCES.find((source) => source?.value === dataset?.source?.content?.provider);
    }

    return (
      <div
        className={isOpenOverviewError ? styles.openOverview : styles.overview}
        style={{
          maxHeight: isOpenOverviewError ? "1000px" : "200px",
          width: "100%",
          overflow: "hidden",
          borderColor: hasErrors ? undefined : "transparent",
          cursor: hasErrors ? undefined : "default"
        }}
        onClick={
          isOpenOverviewError !== true && hasErrors
            ? () => this.toggleIsOpenTile(dataset?.id, "OverviewError")
            : () => {}
        }
      >
        <div className={styles.senseTitle}>
          <div className={styles.dataErrorHeader}>
            <span>
              <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#F8CD7E" }} />
            </span>
            <span style={{ marginLeft: "5px" }}>{"Uh oh, the dataset failed to upload"}</span>
          </div>
          {!hasErrors ? (
            <React.Fragment />
          ) : isOpenOverviewError ? (
            <div className={styles.closeButton} onClick={() => this.toggleIsOpenTile(dataset?.id, "OverviewError")}>
              <Button style={{ padding: "3px" }}>
                <div className={styles.selIcon} title="Close">
                  <FontAwesomeIcon icon={faCompressArrowsAlt} />
                </div>
              </Button>
            </div>
          ) : (
            <div className={styles.selIcon + " " + styles.expandIcon}>
              <FontAwesomeIcon icon={faExpandArrowsAlt} />
            </div>
          )}
        </div>
        {dataset?.source?.content?.type === "CONNECTION_METADATA" && (
          <div className={styles.senseErrorBody} style={{ marginTop: "10px" }}>
            {`Please check that the login information for your ${
              datasetSource ? (datasetSource?.shortLabel ?? datasetSource?.label) : "data warehouse"
            } link is up to date`}
          </div>
        )}
        <div className={styles.senseErrorBody} style={{ marginTop: "10px" }}>
          {`${
            dataset?.source?.content?.type === "CONNECTION_METADATA" ? "If that doesn't work, p" : "P"
          }lease contact your customer success representative with the error information. ` +
            "While you're waiting please review the data requirements and troubleshooting tips below"}
        </div>
        <div className={styles.senseErrorBody} style={{ marginTop: "10px" }}>
          <div>
            <strong>{"Error Details:"}</strong>
          </div>
          {tenant && <div>{"Tenant: " + tenant?.fullname}</div>}
          <div>{"Dataset ID: " + dataset?.id}</div>
          {!isOpenOverviewError && hasErrors && <div>{"Errors: " + datasetErrors?.length}</div>}
        </div>
        {isOpenOverviewError && hasErrors && (
          <ul
            className={styles.senseErrorBody}
            style={{
              marginTop: "10px",
              paddingLeft: "30px",
              maxHeight: "500px"
            }}
          >
            {datasetErrors?.map((e, i) => (
              <li key={`error${dataset?.id}_${i}`} style={{ marginBottom: "10px" }}>
                {e.message}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }

  // Left Error Tile
  renderDataFormatting(dataset) {
    const isOpenDataFormatting = this.getIsOpenTile(dataset?.id, "DataFormatting");
    const isOpenTroubleshooting = this.getIsOpenTile(dataset?.id, "Troubleshooting");
    const isOpenErrorAdvanced = this.getIsOpenTile(dataset?.id, "ErrorAdvanced");

    const FORMATTING_RECOMMENDATIONS = [
      "The file shoud be in CSV UTF-8 file format (or a CSV in GZIP file format) and must contain uniquely named column headers in the first row of data",
      "Each row should represent an individual unit/record/transaction/KPI period",
      "At least one clearly labeled binary or continuous variable outcome column with no missing values",
      "Rows: Minimum of 300 and no more than 500,000 rows of data",
      "Columns: Minimum of 3 and no more than 150 columns of data",
      "At least 2 usable numeric or categorical independent variable columns representing attributes of the unit/record/transaction, Aible recommends 10+ columns for best results"
    ];

    return (
      <div
        className={isOpenDataFormatting ? styles.openOverview : styles.overview}
        style={{
          maxHeight: isOpenDataFormatting ? "500px" : "170px",
          width: isOpenDataFormatting
            ? "100%"
            : isOpenTroubleshooting
              ? "100%"
              : isOpenErrorAdvanced
                ? "calc(50% -  15px)"
                : "calc(33.333% - 14px)",
          overflow: "hidden"
        }}
        onClick={isOpenDataFormatting !== true ? () => this.toggleIsOpenTile(dataset?.id, "DataFormatting") : () => {}}
      >
        <div className={styles.senseTitle}>
          <div className={styles.sTitle}>
            <span className={styles.sIcon}>
              <img src={ClipboardIcon} style={{ height: "16px", width: "16px" }} />
            </span>
            <span style={{ whiteSpace: "nowrap" }}>
              {"Data Formatting" + (isOpenDataFormatting ? " Recommendations" : "")}
            </span>
          </div>
          {isOpenDataFormatting ? (
            <div className={styles.closeButton} onClick={() => this.toggleIsOpenTile(dataset?.id, "DataFormatting")}>
              <Button style={{ padding: "3px" }}>
                <div className={styles.selIcon} title="Close">
                  <FontAwesomeIcon icon={faCompressArrowsAlt} />
                </div>
              </Button>
            </div>
          ) : (
            <div className={styles.selIcon + " " + styles.expandIcon}>
              <FontAwesomeIcon icon={faExpandArrowsAlt} />
            </div>
          )}
        </div>
        {!isOpenDataFormatting ? (
          <div className={styles.tileFlex}>
            <div className={styles.tTop}>
              <span>{FORMATTING_RECOMMENDATIONS.length}</span>
            </div>
            <div className={styles.tBot}>{"RECOMMENDATIONS"}</div>
          </div>
        ) : (
          <ol
            className={styles.senseErrorBody}
            style={{
              marginTop: "10px",
              paddingLeft: "30px",
              maxHeight: "445px"
            }}
          >
            {FORMATTING_RECOMMENDATIONS.map((r, i) => (
              <li key={`format${dataset?.id}_${i}`} style={{ marginBottom: "4px" }}>
                {r}
              </li>
            ))}
          </ol>
        )}
      </div>
    );
  }

  // Center Error Tile
  renderTroubleShootingTips(dataset) {
    const isOpenDataFormatting = this.getIsOpenTile(dataset?.id, "DataFormatting");
    const isOpenTroubleshooting = this.getIsOpenTile(dataset?.id, "Troubleshooting");
    const isOpenErrorAdvanced = this.getIsOpenTile(dataset?.id, "ErrorAdvanced");

    const TROUBLESHOOTING_RECOMMENDATIONS = [
      "Set your CSV encoding to UTF-8 (for example Windows-1252 will not work)",
      "Your dataset may be too large - try dropping some rows or columns if they are above the suggested limits",
      "Drop date fields or convert to ISO-8601 format (YYYY-MM-DD)",
      "Make sure that your column headers are all uniquely labeled, i.e. no duplicates or blanks",
      "Make sure there are no commas or any other separators in the headers",
      "Remove/edit any text fields that contains any special characters (such as parentheses, quotation marks, commas) or ensure these values are properly quoted or escaped",
      "Remove any units from numeric variables (such as $, %)"
    ];
    return (
      <div
        className={isOpenTroubleshooting ? styles.openOverview : styles.overview}
        style={{
          maxHeight: isOpenTroubleshooting ? "500px" : "170px",
          width: isOpenTroubleshooting
            ? "100%"
            : isOpenErrorAdvanced || isOpenDataFormatting
              ? "calc(50% -  15px)"
              : "calc(33.333% - 14px)",
          overflow: isOpenTroubleshooting ? "auto" : "hidden",
          marginLeft: isOpenDataFormatting || isOpenTroubleshooting ? "10px" : "0px"
        }}
        onClick={
          isOpenTroubleshooting !== true ? () => this.toggleIsOpenTile(dataset?.id, "Troubleshooting") : () => {}
        }
      >
        <div className={styles.senseTitle}>
          <div className={styles.sTitle}>
            <span className={styles.sIcon}>
              <img src={QuestionMarkIcon} style={{ height: "16px", width: "16px" }} />
            </span>
            <span>{"Troubleshooting" + (isOpenTroubleshooting ? " Tips" : "")}</span>
          </div>
          {isOpenTroubleshooting ? (
            <div className={styles.closeButton} onClick={() => this.toggleIsOpenTile(dataset?.id, "Troubleshooting")}>
              <Button style={{ padding: "3px" }}>
                <div className={styles.selIcon} title="Close">
                  <FontAwesomeIcon icon={faCompressArrowsAlt} />
                </div>
              </Button>
            </div>
          ) : (
            <div className={styles.selIcon + " " + styles.expandIcon}>
              <FontAwesomeIcon icon={faExpandArrowsAlt} />
            </div>
          )}
        </div>
        {!isOpenTroubleshooting ? (
          <div className={styles.tileFlex}>
            <div className={styles.tTop}>
              <span>{TROUBLESHOOTING_RECOMMENDATIONS.length}</span>
            </div>
            <div className={styles.tBot}>{"TIPS"}</div>
          </div>
        ) : (
          <ol
            className={styles.senseErrorBody}
            style={{
              marginTop: "10px",
              paddingLeft: "30px",
              maxHeight: "445px"
            }}
          >
            {TROUBLESHOOTING_RECOMMENDATIONS.map((r, i) => (
              <li key={`format${dataset?.id}_${i}`} style={{ marginBottom: "4px" }}>
                {r}
              </li>
            ))}
          </ol>
        )}
      </div>
    );
  }

  // Right Error Tile
  renderErrorAdvanced(dataset) {
    const isOpenDataFormatting = this.getIsOpenTile(dataset?.id, "DataFormatting");
    const isOpenTroubleshooting = this.getIsOpenTile(dataset?.id, "Troubleshooting");
    const isOpenErrorAdvanced = this.getIsOpenTile(dataset?.id, "ErrorAdvanced");

    const notebookErrors = dataset?.errors?.filter((e) => e?.message?.includes("See notebook output:"));

    return (
      <div
        className={isOpenErrorAdvanced ? styles.openOverview : styles.overview}
        style={{
          maxHeight: isOpenErrorAdvanced ? "500px" : "170px",
          width: isOpenErrorAdvanced
            ? "100%"
            : isOpenTroubleshooting
              ? "100%"
              : isOpenDataFormatting
                ? "calc(50% -  15px)"
                : "calc(33.333% - 14px)",
          overflow: isOpenErrorAdvanced ? "auto" : "hidden",
          marginLeft: isOpenTroubleshooting || isOpenErrorAdvanced ? "10px" : "0px"
        }}
        onClick={isOpenErrorAdvanced !== true ? () => this.toggleIsOpenTile(dataset?.id, "ErrorAdvanced") : () => {}}
      >
        <div className={styles.senseTitle}>
          <div className={styles.sTitle}>
            <span className={styles.sIcon}>
              <img src={GearsIcon} style={{ height: "16px", width: "16px" }} />
            </span>
            <span>{"Advanced"}</span>
          </div>
          {isOpenErrorAdvanced ? (
            <div className={styles.closeButton} onClick={() => this.toggleIsOpenTile(dataset?.id, "ErrorAdvanced")}>
              <Button style={{ padding: "3px" }}>
                <div className={styles.selIcon} title="Close">
                  <FontAwesomeIcon icon={faCompressArrowsAlt} />
                </div>
              </Button>
            </div>
          ) : (
            <div className={styles.selIcon + " " + styles.expandIcon}>
              <FontAwesomeIcon icon={faExpandArrowsAlt} />
            </div>
          )}
        </div>
        {!isOpenErrorAdvanced ? (
          <div className={styles.tileFlex}>
            <div className={styles.tTop}>&nbsp;</div>
            <div className={styles.tBot}>{"VIEW NOTEBOOK"}</div>
          </div>
        ) : (
          <React.Fragment>
            <div className={styles.senseErrorBody} style={{ marginTop: "10px" }}>
              {"Here is the associated notebook with this error. " +
                "Your customer success rep may need access to this:"}
            </div>
            <ul
              className={styles.senseErrorBody}
              style={{
                marginTop: "10px",
                paddingLeft: "30px",
                maxHeight: "455px"
              }}
            >
              {notebookErrors?.map((e, i) => (
                <li key={`notebookError${dataset?.id}_${i}`} style={{ marginBottom: "10px" }}>
                  {e.message}
                </li>
              ))}
              <li style={{ marginBottom: "10px" }}>{"Dataset CSV URL: " + dataset?.sourceUrl}</li>
            </ul>
          </React.Fragment>
        )}
      </div>
    );
  }

  renderOverviewLoading(dataset) {
    const isInitialImport = dataset?.outcome == undefined;

    return (
      <div className={styles.overviewLoading}>
        <LoadingIndicator style={{ margin: "0px" }} />
        <span style={{ marginLeft: "20px" }}>
          {isInitialImport ? "Data evaluation in progress..." : "Evaluating " + dataset?.outcome}
        </span>
      </div>
    );
  }

  renderInteractionPredictions(key, dataset) {
    const possiblePredictors = dataset?.aiReadyMetrics?.secondOrder?.aiReady;

    const isDone = dataset?.status_name === "DONE";
    const hasOutcome = dataset?.outcome !== undefined;

    return (
      <React.Fragment>
        {isDone && hasOutcome ? (
          <div style={{ marginTop: "20px" }}>
            <span className={styles.sIcon}>
              <FontAwesomeIcon icon={faCheckCircle} />
            </span>
            <span style={{ fontWeight: "bold" }}>
              {possiblePredictors
                ? possiblePredictors.length + " Possible Predictor Interactions Found"
                : "0 Possible Predictor Interactions Found"}
            </span>
          </div>
        ) : (
          <div style={{ marginTop: "20px" }}>
            <span className={styles.sIcon}>
              <FontAwesomeIcon icon={faCircle} style={{ color: "rgb(200, 202, 212)" }} />
            </span>
            <span style={{ fontWeight: "bold" }}>{"Select an outcome to view Possible Predictors"}</span>
          </div>
        )}
        {isDone !== true || hasOutcome !== true ? (
          <div></div>
        ) : possiblePredictors && possiblePredictors.length > 0 ? (
          <div className={styles.possiblePredictors} style={{ marginTop: "10px" }}>
            <div className={styles.pRow}>
              <div className={styles.pLeft + " " + styles.pHeader}>{"PREDICTORS"}</div>
              <div className={styles.pRight + " " + styles.pHeader}>{"QUALITY"}</div>
            </div>
            {possiblePredictors &&
              possiblePredictors
                .filter((p, i) => this.state.viewAllInteractionPredictors?.[key] === true || i < 5)
                .map((p, i) => (
                  <div
                    key={i}
                    className={styles.pRow}
                    style={{
                      opacity: dataset?.ignored?.[p.label] === true ? 0.3 : 1
                    }}
                  >
                    <div className={styles.pLeft} title={p.label}>
                      {p.label}
                    </div>
                    <div className={styles.pRight}>
                      <div className={styles.outerBar}>
                        <div className={styles.innerBar} style={{ width: p.value * 100 + "%" }}>
                          <span>{(p.value * 10).toFixed(1)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            {possiblePredictors && possiblePredictors.length > 5 && (
              <div
                className={styles.purpleA}
                onClick={() => {
                  let viewAllInteractionPredictors = this.state.viewAllInteractionPredictors ?? {};
                  viewAllInteractionPredictors[key] = !viewAllInteractionPredictors[key];
                  this.setState({
                    viewAllInteractionPredictors: viewAllInteractionPredictors,
                    fixMe: !this.state.fixMe
                  });
                }}
              >
                {this.state.viewAllInteractionPredictors?.[key] === true
                  ? "Collapse All Predictors"
                  : "View All Predictors"}
              </div>
            )}
          </div>
        ) : (
          <div>{"None"}</div>
        )}
      </React.Fragment>
    );
  }

  handleAddIgnoreFilter(dataset, field, isIgnore) {
    const { updateIgnored } = this.props;

    updateIgnored("data_" + dataset?.id, field, isIgnore);

    const retFilterData = { ...this.state.filterData };
    const excludeState = retFilterData?.[dataset?.id]?.exclude_columns;

    if (excludeState) {
      if (isIgnore === false) {
        retFilterData[dataset?.id].exclude_columns = excludeState.filter((e) => e !== field);
      } else {
        retFilterData[dataset?.id].exclude_columns = [...retFilterData?.[dataset?.id]?.exclude_columns, field];
      }
    } else {
      if (retFilterData?.[dataset?.id] === undefined) {
        retFilterData[dataset?.id] = {
          exclude_columns: []
        };
      }

      retFilterData[dataset?.id].exclude_columns = [...(retFilterData[dataset?.id].exclude_columns || []), field];
    }

    this.setState({ filterData: retFilterData });
  }

  renderOpenAIReadiness(key, dataset) {
    const { updateIgnored, copyTransformFromSetup } = this.props;
    const { filterData } = this.state;

    const aiScore = (dataset?.aiReadyMetrics?.aiReadinessScore ?? 0) * 10;
    const aiStatus = dataset?.aiReadyMetrics?.aiReadinessStatus;

    const predictors = dataset?.aiReadyMetrics?.aiReady;
    const possiblePredictorsFirst = dataset?.aiReadyMetrics?.aiReady || [];
    const possiblePredictorsSecond = dataset?.aiReadyMetrics?.secondOrder?.aiReady || [];

    const possiblePredictors = [
      ...possiblePredictorsFirst,
      ...possiblePredictorsSecond.map((a) => ({
        ...a,
        label: a.label,
        firstLabel: a.keys?.[0],
        secondLabel: a.keys?.[1],
        isSecondOrder: true
      }))
    ].sort((a, b) => b.value - a.value);

    const problematicPredictors = dataset?.correlations?.problematicPredictors;

    const isDone = dataset?.status_name === "DONE";
    const hasOutcome = dataset?.outcome !== undefined;

    const isLowPredictors = predictors?.length <= AI_READINESS_PREDICTOR_WARNING.count;

    const hasInteractionScores = dataset?.interaction_model_metrics !== undefined && isNaN(aiScore) !== true;

    const isGray = aiStatus === "NO_SIGNAL";
    const isWarning = hasInteractionScores !== true || aiStatus === "LOW_SIGNAL" || aiStatus === "SUSPECT_SIGNAL";

    return (
      <div className={styles.readiness}>
        {isDone && hasOutcome ? (
          <div
            id={"problematicPredictorsSection_" + dataset?.id}
            className={styles.problemPredictors}
            style={{ marginTop: "20px" }}
          >
            <ProblematicPredictors
              id={`data_${dataset?.id}`}
              isSense
              selectedDataset={dataset}
              problematicPredictors={dataset?.correlations?.problematicPredictors}
              ignored={dataset?.ignored}
              predictors={dataset?.correlations?.predictors}
              updateIgnored={(c, v) => this.handleAddIgnoreFilter(dataset, c, v)}
            />
          </div>
        ) : (
          <div style={{ marginTop: "20px" }}>
            <span className={styles.sIcon}>
              <FontAwesomeIcon icon={faCircle} style={{ color: "rgb(200, 202, 212)" }} />
            </span>
            <span style={{ fontWeight: "bold" }}>{"Select an outcome to view Problematic Predictors"}</span>
          </div>
        )}
        {isDone && hasOutcome ? (
          <div style={{ marginTop: "20px" }}>
            <span className={styles.sIcon}>
              <FontAwesomeIcon icon={faCheckCircle} />
            </span>
            <span style={{ fontWeight: "bold" }}>
              {`${possiblePredictors?.length || 0} Possible Useful Variable${
                possiblePredictors?.length !== 1 ? "s" : ""
              } Found`}
            </span>
          </div>
        ) : (
          <div style={{ marginTop: "20px" }}>
            <span className={styles.sIcon}>
              <FontAwesomeIcon icon={faCircle} style={{ color: "rgb(200, 202, 212)" }} />
            </span>
            <span style={{ fontWeight: "bold" }}>{"Select an outcome to view Possible Useful Variables"}</span>
          </div>
        )}
        {isDone !== true || hasOutcome !== true ? (
          <div></div>
        ) : possiblePredictors && possiblePredictors.length > 0 ? (
          <div className={styles.possiblePredictors} style={{ marginTop: "10px" }}>
            <div className={styles.pRow}>
              <div className={styles.pLeft + " " + styles.pHeader}>{"USEFUL VARIABLES"}</div>
              <div className={styles.pRight + " " + styles.pHeader + " " + styles.hFlex}>
                <div>{"RELATIVE QUALITY"}</div>
                <div onClick={(e) => e.stopPropagation()}>
                  <OverlayTrigger
                    placement="top"
                    trigger={["click"]}
                    rootClose
                    overlay={
                      <Popover id="popover-positioned-top">
                        <div className={styles.aiReadinessOverlay}>
                          <div className={styles.aiReadinessBody}>
                            <strong>{"If you are analyzing data, "}</strong>
                            <span>
                              {
                                " variables with higher quality would be good to chart on the horizontal axis. Charts where a variable with low quality is in the horizontal axis may be statistically less informative and might mislead you."
                              }
                            </span>
                          </div>
                          <div className={styles.aiReadinessBody}>
                            <strong>{"If you are creating a predictive model, "}</strong>
                            <span>
                              {
                                "the data readiness step checks to see if there is sufficient predictive power in any of your variables. It's okay if your data is messy, there can still be enough to build predictive models."
                              }
                            </span>
                          </div>
                          <div className={styles.aiReadinessBody}>
                            {"Each variable is scored on a scale of 0 - 10."}
                          </div>
                        </div>
                      </Popover>
                    }
                  >
                    <div className={styles.aireadinessIcon + " " + styles.isInfo}>
                      <FontAwesomeIcon icon={faInfo} />
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
            {possiblePredictors &&
              possiblePredictors
                .filter((p, i) => this.state.viewAllPredictors?.[key] === true || i < 5)
                .map((p, i) => {
                  const isIgnored =
                    dataset?.ignored?.[p.label] === true ||
                    (p.firstLabel && dataset?.ignored?.[p.firstLabel] === true) ||
                    (p.secondLabel && dataset?.ignored?.[p.secondLabel] === true);

                  const isProblematicPredictor = Boolean(
                    problematicPredictors?.find(
                      (prob) =>
                        prob?.label === p?.label || prob?.label === p?.firstLabel || prob?.label === p?.secondLabel
                    )
                  );
                  return (
                    <div
                      key={i}
                      className={styles.pRow}
                      style={{
                        opacity: isIgnored ? 0.3 : 1
                      }}
                    >
                      {p.isSecondOrder === true && (
                        <OverlayTrigger
                          placement="top"
                          trigger={["hover"]}
                          rootClose
                          overlay={
                            <Popover id="popover-positioned-top" title={"Variable Interaction Found"}>
                              <div className={styles.aiReadinessOverlay}>
                                {"Interactions are variable combinations where the impact on your outcome " +
                                  "is significantly different than the two variables by themselves."}
                              </div>
                            </Popover>
                          }
                        >
                          <div className={styles.pIcon}>
                            <img src={InteractIcon} />
                          </div>
                        </OverlayTrigger>
                      )}
                      <div
                        className={styles.pLeft}
                        style={
                          p.isSecondOrder
                            ? {
                                minWidth: "calc(50% - 15px)",
                                marginLeft: "15px"
                              }
                            : {}
                        }
                      >
                        <OverlayTrigger
                          placement={"top"}
                          trigger={["hover"]}
                          rootClose
                          overlay={<Popover>{p.label}</Popover>}
                        >
                          <span>{p.label}</span>
                        </OverlayTrigger>
                      </div>
                      <div className={styles.pRight}>
                        <div className={styles.outerBar}>
                          <div
                            className={styles.innerBar}
                            style={{
                              width: p.value * 100 + "%",
                              background: isProblematicPredictor ? "#F8CD7E" : undefined,
                              color: isProblematicPredictor ? "#4B495B" : undefined
                            }}
                          >
                            <span>{(p.value * 10).toFixed(1)}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            {possiblePredictors && possiblePredictors.length > 5 && (
              <div
                className={styles.purpleA}
                onClick={() => {
                  let viewAllPredictors = this.state.viewAllPredictors;
                  viewAllPredictors[key] = !viewAllPredictors[key];
                  this.setState({
                    viewAllPredictors: viewAllPredictors,
                    fixMe: !this.state.fixMe
                  });
                }}
                style={{ fontSize: "13px" }}
              >
                {this.state.viewAllPredictors?.[key] === true ? "Hide" : "View all useful variables"}
              </div>
            )}
          </div>
        ) : (
          <div>{"None"}</div>
        )}
      </div>
    );
  }

  renderInsights(key, dataset) {
    const { history, openExploration } = this.props;
    const { isLoadingExplore } = this.state;

    return (
      <div className={styles.readiness}>
        {dataset?.rowCount === -1 &&
          dataset?.outcome === undefined &&
          this.renderOutcomeSelection(dataset, "Select an outcome to discover insights", true)}
        {dataset?.outcome !== undefined && this.renderMuscleChart(dataset)}

        {/* TODO: This needs to create an exploration */}
        {dataset?.outcome !== undefined && (isEnabled("aible-optimize") || isEnabled("aible-explore")) ? (
          <div className={styles.upgrade} style={{ marginTop: "40px" }}>
            {isLoadingExplore?.[dataset?.id] === true ? (
              <LoadingIndicator style={{ margin: "0px", right: "30px", position: "absolute" }} />
            ) : (
              <Button
                onClick={() => {
                  this.setState({
                    isLoadingExplore: {
                      ...isLoadingExplore,
                      [dataset?.id]: true
                    }
                  });

                  setTimeout(() => openExploration(dataset?.id), 5);
                }}
              >
                {"View Exploration"}
              </Button>
            )}
          </div>
        ) : (
          <div className={styles.upgrade}>{"Please get Aible Explore to see the insights for " + dataset?.outcome}</div>
        )}
      </div>
    );
  }

  renderDataQuality(dataset) {
    const updatedColumns = (dataset && dataset.warnings) || [];
    const groupedUpdates = parseValidation(updatedColumns);

    return <div className={styles.readiness}>{this.renderDataValidation(dataset)}</div>;
  }

  calculateDateValues(dataset) {
    const { selectedDateFields, selectedDateValues, selectedDateFilterValues, dateAnalysisTarget } = this.state;

    const retDateAnalysisTarget = dateAnalysisTarget?.[dataset?.id];

    const dateFieldOptions =
      dataset?.ranked_fields !== undefined
        ? dataset.ranked_fields
            .filter((f) => f.type === "date")
            .map((f) => ({
              value: f,
              label: f.label
            }))
        : [];

    const dateField =
      selectedDateFields?.[dataset?.id] !== undefined
        ? selectedDateFields?.[dataset?.id]
        : dateFieldOptions.length > 0
          ? dateFieldOptions[0].value
          : undefined;

    const dateValue = selectedDateValues?.[dataset?.id];
    const dateFilterValue = selectedDateFilterValues?.[dataset?.id];

    const dateRowsExcluded = dateField?.data
      .filter((d) => dateFilterValue !== undefined && d.value < dateFilterValue.value)
      .reduce((a, b) => a + b.count, 0);

    const dateRowsBefore =
      dateField?.data
        .filter((d) => dateValue === undefined || d.value <= dateValue.value)
        .reduce((a, b) => a + b.count, 0) + (dateRowsExcluded === undefined ? 0 : -dateRowsExcluded);

    const dateFieldMax = dateField?.data.reduce((a, b) => a + b.count, 0);

    const dateRowsAfter = dateFieldMax - dateRowsBefore - dateRowsExcluded;

    return {
      dateFieldOptions,
      dateField,
      dateValue,
      dateFilterValue,
      dateRowsExcluded,
      dateRowsBefore,
      dateFieldMax,
      dateRowsAfter,
      dateAnalysisTarget: retDateAnalysisTarget
    };
  }

  renderDataCollection(dataset) {
    const { isTableauMode } = this.props;
    const {
      dateFieldOptions,
      dateField,
      dateValue,
      dateFilterValue,
      dateRowsExcluded,
      dateRowsBefore,
      dateFieldMax,
      dateRowsAfter,
      dateAnalysisTarget
    } = this.calculateDateValues(dataset);

    let explorationAndAIString;
    switch (dateAnalysisTarget) {
      case "EXPLORE":
        explorationAndAIString = "Exploration";
        break;
      case "CREATE_AI":
        explorationAndAIString = "AI creation";
        break;
      case "BOTH":
        explorationAndAIString = "Exploration and AI creation";
        break;
    }

    const pieData = [
      {
        name: "rows ignored",
        value: dateRowsExcluded,
        color: "#C8CAD4"
      },
      {
        name: " training rows",
        value: dateRowsBefore,
        color: "#8884d8"
      },
      {
        name: " comparison rows",
        value: dateRowsAfter,
        color: "#34D399"
      }
    ];

    const isTestTrainSplit = isEnabled("test-train-split") && isEnabled("aible-optimize") && !isTableauMode;
    const isDatasetWhatsChanged =
      isEnabled("dataset-whats-changed") && (isEnabled("aible-optimize") || isEnabled("aible-explore"));

    const flagTargets =
      (isDatasetWhatsChanged ? "the Exploration" : "") +
      (isDatasetWhatsChanged && isTestTrainSplit ? " and " : "") +
      (isTestTrainSplit ? "the AI creation" : "");

    return (
      <div className={styles.dateCharts}>
        {/* this.renderDataEvaluated(dataset)}*/}
        {/* <div className={styles.dataCollectGraph}>{<SmallBarChart />}</div> */}
        <div className={styles.rInner}>
          {dataset?.outcome !== undefined &&
            (isTestTrainSplit || isDatasetWhatsChanged) &&
            (dateFieldOptions.length > 0 ? (
              <div>
                <div className={styles.dateExploreSelect}>
                  <div className={styles.dateLabel}>
                    {`Do you want to focus on a specific set of dates ${
                      isDatasetWhatsChanged ? "to see what has changed" : ""
                    }${
                      isDatasetWhatsChanged && isTestTrainSplit ? " or " : ""
                    }${isTestTrainSplit ? "to test predictive models" : ""}?`}
                  </div>
                  <ButtonGroup>
                    <Button
                      active={dateAnalysisTarget === undefined}
                      onClick={() =>
                        this.setState({
                          dateAnalysisTarget: {
                            ...this.state.dateAnalysisTarget,
                            [dataset?.id]: undefined
                          }
                        })
                      }
                    >
                      {"No"}
                    </Button>
                    {isDatasetWhatsChanged && (
                      <Button
                        active={dateAnalysisTarget === "EXPLORE"}
                        onClick={() =>
                          this.setState({
                            dateAnalysisTarget: {
                              ...this.state.dateAnalysisTarget,
                              [dataset?.id]: "EXPLORE"
                            }
                          })
                        }
                      >
                        {"Explore What's Changed for a KPI"}
                      </Button>
                    )}
                    {isTestTrainSplit && (
                      <Button
                        active={dateAnalysisTarget === "CREATE_AI"}
                        onClick={() =>
                          this.setState({
                            dateAnalysisTarget: {
                              ...this.state.dateAnalysisTarget,
                              [dataset?.id]: "CREATE_AI"
                            }
                          })
                        }
                      >
                        {"AI Training and Evaluation Split"}
                      </Button>
                    )}
                    {isDatasetWhatsChanged && isTestTrainSplit && (
                      <Button
                        active={dateAnalysisTarget === "BOTH"}
                        onClick={() =>
                          this.setState({
                            dateAnalysisTarget: {
                              ...this.state.dateAnalysisTarget,
                              [dataset?.id]: "BOTH"
                            }
                          })
                        }
                      >
                        {"Both"}
                      </Button>
                    )}
                  </ButtonGroup>
                </div>
                {dateAnalysisTarget === undefined ? (
                  <React.Fragment />
                ) : (
                  <React.Fragment>
                    <div className={styles.dateTitle}>
                      <div className={styles.dateLabel}>
                        {"Which date field should be used for " + explorationAndAIString}
                      </div>
                      <div className={styles.dateColSelect}>
                        <Select
                          options={dateFieldOptions}
                          onChange={(val) => {
                            let retSelectedDateFields = {
                              ...this.state.selectedDateFields,
                              [dataset?.id]: val?.value
                            };
                            this.setState({
                              selectedDateFields: retSelectedDateFields
                            });
                          }}
                          menuPlacement={"top"}
                          value={dateField}
                          placeholder="Select a Date Field"
                        />
                      </div>
                    </div>
                    {dateField !== undefined ? (
                      <React.Fragment>
                        <div className={styles.smallDateChart}>
                          {/* This is outdated and needs to be updated */}
                          <SmallDateChart
                            field={dateField}
                            dateValue={dateValue?.value}
                            updateDateValue={(val) => {
                              let retSelectedDateValues = {
                                ...this.state.selectedDateValues,
                                [dataset?.id]: val
                              };
                              this.setState({
                                selectedDateValues: retSelectedDateValues
                              });
                            }}
                            dateFilterValue={dateFilterValue?.value}
                            updateDateFilterValue={(val) => {
                              let retSelectedDateFilterValues = {
                                ...this.state.selectedDateFilterValues,
                                [dataset?.id]: val
                              };

                              if (dateValue !== undefined && dateValue.value < val?.value) {
                                this.setState({
                                  selectedDateValues: {
                                    ...this.state.selectedDateValues,
                                    [dataset?.id]: val
                                  }
                                });
                              }
                              this.setState({
                                selectedDateFilterValues: retSelectedDateFilterValues
                              });
                            }}
                          />
                        </div>
                        <div className={styles.dateExtraWrapper}>
                          <div className={styles.dateExtra}>
                            {dateRowsExcluded !== undefined && (
                              <div className={styles.dateInfo}>
                                <div className={styles.dateDot} style={{ background: "#C8CAD4" }} />
                                <div className={styles.dateMessage}>
                                  <span style={{ fontWeight: "bold" }}>{dateRowsExcluded}</span>
                                  <span style={{ marginLeft: "5px" }}>
                                    {dateFilterValue
                                      ? "rows before " + dateFilterValue?.value + " will be ignored"
                                      : "rows ignored"}
                                  </span>
                                </div>
                                <Tooltip
                                  overlay={
                                    <div className={styles.dateFieldTooltip}>
                                      {dateFilterValue && dateRowsExcluded > 0
                                        ? `Your ${explorationAndAIString} will exclude data created before ${dateFilterValue?.value}`
                                        : `Your ${explorationAndAIString} will not exclude any rows`}
                                    </div>
                                  }
                                />
                              </div>
                            )}
                            {dateRowsAfter !== undefined && (
                              <div>
                                <div className={styles.dateInfo}>
                                  <div className={styles.dateDot} style={{ background: "#8884d8" }} />
                                  <div className={styles.dateMessage}>
                                    <span style={{ fontWeight: "bold" }}>{dateRowsBefore}</span>
                                    <span style={{ marginLeft: "5px" }}>
                                      {dateValue
                                        ? "rows up to " +
                                          dateValue?.value +
                                          ` will be used for ${
                                            (dateAnalysisTarget === "CREATE_AI" || dateAnalysisTarget === "BOTH"
                                              ? "AI training"
                                              : "") +
                                            (dateAnalysisTarget === "BOTH" ? " and " : "") +
                                            (dateAnalysisTarget === "EXPLORE" || dateAnalysisTarget === "BOTH"
                                              ? "the comparison period for what has changed"
                                              : "")
                                          }`
                                        : "training rows"}
                                    </span>
                                  </div>
                                  <Tooltip
                                    overlay={
                                      <div className={styles.dateFieldTooltip}>
                                        {dateRowsBefore === dateFieldMax
                                          ? `Your ${explorationAndAIString} will be created using all ${dateRowsBefore} rows`
                                          : `Your ${explorationAndAIString} will be created using the ${dateRowsBefore} rows` +
                                            (dateFilterValue && dateRowsExcluded > 0
                                              ? ` after ${dateFilterValue?.value}`
                                              : "") +
                                            (dateFilterValue && dateRowsExcluded > 0 && dateValue && dateRowsAfter > 0
                                              ? ` and `
                                              : "") +
                                            (dateValue && dateRowsAfter > 0
                                              ? ` before ${dateValue?.value} and will compare them to the ${dateRowsAfter} rows after ${dateValue?.value}`
                                              : "")}
                                      </div>
                                    }
                                  />
                                </div>
                                {dateValue && (
                                  <div className={styles.dateInfo}>
                                    <div className={styles.dateDot} style={{ background: "#34D399" }} />
                                    <div className={styles.dateMessage}>
                                      <span style={{ fontWeight: "bold" }}>{dateRowsAfter}</span>
                                      <span style={{ marginLeft: "5px" }}>
                                        {"rows after " +
                                          dateValue?.value +
                                          ` will be used for ${
                                            (dateAnalysisTarget === "CREATE_AI" || dateAnalysisTarget === "BOTH"
                                              ? "AI evaluation"
                                              : "") +
                                            (dateAnalysisTarget === "BOTH" ? " and " : "") +
                                            (dateAnalysisTarget === "EXPLORE" || dateAnalysisTarget === "BOTH"
                                              ? "the current time period for what has changed"
                                              : "")
                                          }`}
                                      </span>
                                    </div>
                                    <Tooltip
                                      overlay={
                                        <div className={styles.dateFieldTooltip}>
                                          {(dateAnalysisTarget === "EXPLORE" || dateAnalysisTarget === "BOTH") && (
                                            <div>
                                              <strong>{"If you are analyzing data, "}</strong>
                                              <span>
                                                {"these rows are the new data you're comparing your previous data to."}
                                              </span>
                                            </div>
                                          )}
                                          {(dateAnalysisTarget === "CREATE_AI" || dateAnalysisTarget === "BOTH") && (
                                            <div>
                                              <strong>{"If you are creating a predictive model, "}</strong>
                                              <span>
                                                {"these rows are the data the AI will use to test the models."}
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          <div className={styles.datePieChart}>
                            <PieChart width={100} height={100}>
                              <Pie data={pieData} labelLine={false} dataKey={"value"} paddingAngle={0}>
                                {pieData.map((entry, index) => (
                                  <Cell key={`cell-${index}`} fill={entry.color} stroke={entry.color} />
                                ))}
                              </Pie>
                            </PieChart>
                          </div>
                        </div>
                      </React.Fragment>
                    ) : (
                      <div className={styles.dFlex} style={{ marginTop: "10px" }}>
                        {"Select a date field to view the data collection graph"}
                      </div>
                    )}
                  </React.Fragment>
                )}
              </div>
            ) : (
              <div>
                <div className={styles.dateLabel} style={{ marginTop: "10px" }}>
                  {"No Date Field Detected"}
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }

  renderOutcomeTile(dataset) {
    const {
      setDatasetTarget,
      changeDatasetOutcome,
      copyAndChangeDatasetTarget,
      getSuccessOptions,
      getIsOutcomeMulticategorical,
      updateDatasetOptions
    } = this.props;

    const { customTransforms } = this.state;

    const retQuery = this.getTransformQuery(dataset);

    let customOutcomeOptions = [];

    if (retQuery?.query?.mutate) {
      retQuery.query.mutate.forEach((mutate) => {
        if ((mutate?.cases && mutate?.cases.length === 2) || (mutate?.cases && mutate?.cases.length === 1)) {
          customOutcomeOptions.push({
            label: mutate?.alias,
            value: mutate?.alias
          });
        }
      });
    }

    const columnCount = dataset?.fields ? Object.keys(dataset.fields).length : 0;

    const isProcessing = dataset?.status_name !== "DONE";
    const isWideDatasetWarning = dataset?.wideDatasetWarning;

    const options = dataset?.datasetOutcomeOptions ? [...customOutcomeOptions, ...dataset.datasetOutcomeOptions] : [];

    const isRetargeting = this.state.isLoadingRetarget?.[dataset?.id];

    const isOpenOutcome = this.getIsOpenTile(dataset?.id, "Outcome");
    const isTargetModelOptionsOpen = this.getIsTargetModelOptionsOpen(dataset?.id);
    const isExpandable = dataset?.outcome && !isProcessing && !isWideDatasetWarning;

    const isMulticategorical = dataset?.isMulticategorical;

    const selOutcome = this.state.datasetOutcomes?.[dataset?.id] ?? dataset?.outcome;

    const oValue = this.state.datasetOutcomes?.[dataset?.id];

    let isSelOutcomeMulticategorical = false;
    let selOutcomeSuccessOptions;
    if (selOutcome !== undefined && getIsOutcomeMulticategorical(dataset, selOutcome)) {
      isSelOutcomeMulticategorical = true;
      selOutcomeSuccessOptions = getSuccessOptions(dataset, selOutcome).map((o) => ({
        value: o,
        label: o?.label
      }));
    }

    const oFoundvalue = options.find((opt) => opt?.value === oValue);

    return isProcessing && dataset?.outcome === undefined ? (
      <div />
    ) : (
      <div
        id={"outcomeSection_" + dataset?.id}
        className={isOpenOutcome || !isExpandable ? styles.openOverview : styles.overview}
        style={{
          width: "100%",
          zIndex: 55,
          maxHeight: isOpenOutcome || !isExpandable ? "1600px" : "42px"
        }}
        onClick={
          isOpenOutcome !== true && isExpandable ? () => this.toggleIsOpenTile(dataset?.id, "Outcome") : () => {}
        }
      >
        {dataset?.outcome ? (
          isProcessing ? (
            <div className={styles.oTitle}>
              <LoadingIndicator style={{ margin: "0px", marginRight: "10px" }} />
              <div className={styles.oTitleText}>
                <span style={{ marginRight: "3px" }}>{"Evaluating"}</span>
                <span style={{ fontWeight: "bold" }}>{dataset?.outcome}</span>
              </div>
            </div>
          ) : (
            <React.Fragment>
              <div className={styles.senseTitle}>
                <div className={styles.sTitle}>
                  <span className={styles.sIcon}>
                    <img src={TargetIcon} style={{ height: "16px", width: "16px" }} />
                  </span>
                  <span>{"Evaluating"}</span>
                  <span style={{ fontWeight: "bold", marginLeft: "3px" }}>{dataset?.outcome}</span>
                  {isMulticategorical && (
                    <React.Fragment>
                      <span style={{ marginLeft: "3px" }}>{"is"}</span>
                      <span style={{ fontWeight: "bold", marginLeft: "3px" }}>{dataset?.defaultSuccess}</span>
                    </React.Fragment>
                  )}
                </div>
                {isOpenOutcome ? (
                  <div
                    id={"outcomeSectionClose_" + dataset?.id}
                    className={styles.closeButton}
                    onClick={() => this.toggleIsOpenTile(dataset?.id, "Outcome")}
                  >
                    <Button style={{ padding: "3px" }}>
                      <div className={styles.selIcon} title="Close">
                        <FontAwesomeIcon icon={faCompressArrowsAlt} />
                      </div>
                    </Button>
                  </div>
                ) : (
                  <div className={styles.selIcon + " " + styles.expandIcon}>
                    <FontAwesomeIcon icon={faExpandArrowsAlt} />
                  </div>
                )}
              </div>
              {isOpenOutcome && (
                <React.Fragment>
                  <div className={styles.outcomeBodyText}>
                    {`You are viewing the data readiness analysis for ${dataset?.outcome}. If you would like to evaluate a different variable in this dataset, select it below and Aible will create a new analysis card for the outcome`}
                  </div>
                  <div className={styles.outcomeBodyText}>
                    {
                      "What new outcome would you like to evaluate? This is a KPI you would chart on the vertical axis or an outcome a model would predict"
                    }
                  </div>
                  <div className={styles.outcomeReselect}>
                    <Select
                      formatOptionLabel={outcomeOptionFormatter}
                      value={options?.find((e) => {
                        const targetOutcome = this.state.datasetOutcomes?.[dataset?.id];
                        if (targetOutcome !== undefined) {
                          return e.value === targetOutcome;
                        }
                        return false;
                        // return e.value === dataset?.outcome;
                      })}
                      options={options}
                      onChange={(val) => {
                        let datasetOutcomes = { ...this.state.datasetOutcomes };
                        datasetOutcomes[dataset?.id] = val.value;
                        let outcomeSuccess = { ...this.state.outcomeSuccess };
                        outcomeSuccess[dataset?.id] = undefined;
                        this.setState({
                          datasetOutcomes: datasetOutcomes,
                          outcomeSuccess: outcomeSuccess
                        });
                      }}
                      isDisabled={isRetargeting}
                    />
                  </div>
                  {isSelOutcomeMulticategorical && (
                    <React.Fragment>
                      <div className={styles.outcomeReselect}>{"is"}</div>
                      <div className={styles.outcomeReselect}>
                        <Select
                          value={selOutcomeSuccessOptions.find((o) => {
                            const targetSuccess = this.state.outcomeSuccess?.[dataset?.id];
                            if (targetSuccess !== undefined) {
                              return o?.value?.value === targetSuccess?.value?.value;
                            }
                            return o?.value?.value === dataset?.target_value?.[0];
                          })}
                          options={selOutcomeSuccessOptions}
                          onChange={(val) => {
                            this.setState({
                              outcomeSuccess: {
                                ...this.state.outcomeSuccess,
                                [dataset?.id]: val
                              }
                            });
                          }}
                          isDisabled={isRetargeting}
                        />
                      </div>
                    </React.Fragment>
                  )}
                  <Button
                    className={styles.outcomeReselectButton}
                    onClick={() => {
                      let datasetRetargeting = {
                        ...this.state.datasetRetargeting
                      };
                      datasetRetargeting[dataset?.id] = true;
                      this.setState({ datasetRetargeting: datasetRetargeting });

                      const promiseHelper = () => {
                        let datasetRetargeting = {
                          ...this.state.datasetRetargeting
                        };
                        datasetRetargeting[dataset?.id] = false;
                        let datasetOutcomes = { ...this.state.datasetOutcomes };
                        datasetOutcomes[dataset?.id] = undefined;
                        let outcomeSuccess = { ...this.state.outcomeSuccess };
                        outcomeSuccess[dataset?.id] = undefined;
                        this.setState({
                          datasetRetargeting: datasetRetargeting,
                          datasetOutcomes: datasetOutcomes,
                          outcomeSuccess: outcomeSuccess
                        });
                        this.toggleIsOpenTile(dataset?.id, "Outcome");
                      };

                      copyAndChangeDatasetTarget(
                        dataset?.id,
                        this.state.datasetOutcomes?.[dataset?.id],
                        this.state.outcomeSuccess?.[dataset?.id]?.value?.value
                      )
                        .then(promiseHelper)
                        .catch(promiseHelper);
                    }}
                    disabled={
                      (!isSelOutcomeMulticategorical && this.state.datasetOutcomes[dataset?.id] === undefined) ||
                      (isSelOutcomeMulticategorical && this.state.outcomeSuccess[dataset?.id] === undefined) ||
                      isRetargeting
                    }
                  >
                    {isRetargeting ? (
                      <LoadingIndicator
                        color={"#333"}
                        style={{
                          height: "13px",
                          width: "13px",
                          margin: "0px",
                          position: "absolute",
                          transform: "scale(0.4)",
                          top: "0px",
                          left: "8px"
                        }}
                      />
                    ) : (
                      "Create New Data Readiness Analysis"
                    )}
                  </Button>
                  {false && isEnabled("light-gbm-shap-explore") && (
                    <div style={{ marginTop: "5px" }}>
                      <a
                        style={{ marginTop: "5px" }}
                        onClick={() => this.setIsTargetModelOptionsOpen(dataset?.id, !isTargetModelOptionsOpen)}
                      >
                        {isTargetModelOptionsOpen ? "Hide Advanced Options" : "Show Advanced Options"}
                      </a>
                    </div>
                  )}
                  {isTargetModelOptionsOpen && this.renderTargetModelOptions(dataset)}
                </React.Fragment>
              )}
            </React.Fragment>
          )
        ) : (
          <div>
            <div className={styles.senseTitle} style={{ alignItems: "center", lineHeight: "16px" }}>
              <div className={styles.sIcon}>
                <img src={TargetIcon} style={{ height: "16px", width: "16px" }} />
              </div>
              <div className={styles.nFlex}>
                {"Select an outcome to evaluate data readiness."}
                {this.renderAIReadinessTooltip(dataset, true)}
              </div>
            </div>
            <div className={styles.outcomeBodyText}>
              {`This is a KPI you would chart on the vertical axis or an outcome a model would predict`}
            </div>
            <div style={{ width: "90%", marginTop: "5px", fontSize: "13px" }}>
              <Select
                formatOptionLabel={outcomeOptionFormatter}
                options={options}
                onChange={(val) => {
                  let datasetOutcomes = { ...this.state.datasetOutcomes };
                  datasetOutcomes[dataset?.id] = val.value;
                  let outcomeSuccess = { ...this.state.outcomeSuccess };
                  outcomeSuccess[dataset?.id] = undefined;
                  this.setState({
                    datasetOutcomes: datasetOutcomes,
                    outcomeSuccess: outcomeSuccess
                  });
                }}
                value={oFoundvalue}
              />
            </div>
            {columnCount > WIDE_DATASET_COLUMN_COUNT && (
              <div className={styles.outcomeBodyText + " " + styles.isFlex}>
                <Icon type={"warning"} size={18} />
                <span style={{ marginLeft: "6px" }}>
                  {`This dataset is wider than ${WIDE_DATASET_COLUMN_COUNT} columns and may cause performance issues.`}
                </span>
              </div>
            )}
            {isSelOutcomeMulticategorical && (
              <React.Fragment>
                <div style={{ fontSize: "13px", marginTop: "5px" }}>{"is"}</div>
                <div style={{ width: "90%", marginTop: "5px", fontSize: "13px" }}>
                  <Select
                    options={selOutcomeSuccessOptions}
                    onChange={(val) => {
                      this.setState({
                        outcomeSuccess: {
                          ...this.state.outcomeSuccess,
                          [dataset?.id]: val
                        }
                      });
                    }}
                  />
                </div>
              </React.Fragment>
            )}
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <Button
                onClick={() =>
                  setDatasetTarget(
                    dataset?.id,
                    this.state.datasetOutcomes[dataset?.id],
                    isSelOutcomeMulticategorical ? this.state.outcomeSuccess[dataset?.id]?.value?.value : undefined
                  )
                }
                disabled={
                  this.state.datasetOutcomes[dataset?.id] === undefined ||
                  (isSelOutcomeMulticategorical && this.state.outcomeSuccess[dataset?.id] === undefined)
                }
                type="primary"
              >
                {"Evaluate Data Readiness"}
              </Button>
              {false && isEnabled("light-gbm-shap-explore") && (
                <a onClick={() => this.setIsTargetModelOptionsOpen(dataset?.id, !isTargetModelOptionsOpen)}>
                  {isTargetModelOptionsOpen ? "Hide Advanced Options" : "Show Advanced Options"}
                </a>
              )}
            </div>
            <div>{isTargetModelOptionsOpen && this.renderTargetModelOptions(dataset)}</div>
          </div>
        )}
      </div>
    );
  }

  renderTargetModelOptions(dataset) {
    const { updateDatasetOptions } = this.props;

    return (
      <div>
        <div style={{ marginTop: "10px", marginBottom: "5px" }}>
          <input
            type="checkbox"
            style={{ marginTop: "0px", marginRight: "5px" }}
            checked={dataset?.options?.target_steps?.includes("SHAP_EXPLORE")}
            onClick={() => {
              let steps = dataset?.options?.target_steps?.slice() ?? [];

              if (!dataset?.options?.target_steps?.includes("SHAP_EXPLORE")) {
                steps.push("SHAP_EXPLORE");
              } else {
                steps = steps.filter((s) => s != "SHAP_EXPLORE");
              }
              updateDatasetOptions(dataset.id, { ...dataset?.options, target_steps: steps });
            }}
          />
          <span className={styles.shapLabel}>{"Evaluate using LightGBM SHAP"}</span>
        </div>
        {dataset?.options?.target_steps?.includes("SHAP_EXPLORE") && (
          <DatasetOptions
            options={dataset.options}
            labels={dataset.labels}
            onChange={(o) => updateDatasetOptions(dataset.id, o)}
          />
        )}
      </div>
    );
  }

  renderOutcomeSelection(dataset, oLabel, hideBorder = false) {
    const { setDatasetTarget } = this.props;

    const options = dataset?.datasetOutcomeOptions;

    const oValue = this.state.datasetOutcomes?.[dataset?.id];

    return (
      <div className={styles.outcomeSelect} style={hideBorder === true ? { borderBottom: "none" } : {}}>
        <span className={styles.sIcon}>
          <FontAwesomeIcon icon={faBell} style={{ color: "rgb(200, 202, 212)" }} />
        </span>
        <span style={{ fontWeight: "bold" }}>{oLabel ? oLabel : "Select an outcome to evaluate Data Readiness"}</span>
        <div style={{ width: "90%", marginTop: "5px" }}>
          <Select
            options={options}
            onChange={(val) => {
              let datasetOutcomes = { ...this.state.datasetOutcomes };
              datasetOutcomes[dataset?.id] = val.value;
              this.setState({ datasetOutcomes: datasetOutcomes });
            }}
            value={options.find((opt) => opt?.label === oValue)}
          />
        </div>
        <div style={{ marginTop: "20px" }}>
          <Button
            onClick={() => setDatasetTarget(dataset?.id, this.state.datasetOutcomes[dataset?.id])}
            disabled={this.state.datasetOutcomes[dataset?.id] === undefined}
          >
            {"Evaluate Data Readiness"}
          </Button>
        </div>
      </div>
    );
  }

  // TODO: Better way to calc insight number
  calcInsightNumber(dataset) {
    return dataset?.interaction_scores?.length ?? 0;
  }

  renderAIReadiness(dataset) {
    const { copyAndApplyTransformations, copyTransformFromSetup, allTransforms } = this.props;
    const { isShowDerived, expandedDataset, isTransformSaving } = this.state;

    const predictors = [
      ...(dataset?.aiReadyMetrics?.aiReady ?? []),
      ...(dataset?.aiReadyMetrics?.secondOrder?.aiReady ?? [])
    ].sort((a, b) => b.value - a.value);

    const problematicPredictors = dataset?.correlations?.problematicPredictors;

    const aiScore = (dataset?.aiReadyMetrics?.aiReadinessScore ?? 0) * 10;
    const aiStatus = dataset?.aiReadyMetrics?.aiReadinessStatus;

    const insightCount = this.calcInsightNumber(dataset);

    const isLowPredictors = predictors?.length <= AI_READINESS_PREDICTOR_WARNING.count;

    const isGray = aiStatus === "NO_SIGNAL";

    const isOpenAIReadiness = this.getIsOpenTile(dataset?.id, "AI Readiness");
    const isOpenInsights = this.getIsOpenTile(dataset?.id, "Insights");

    const hasInteractionScores = dataset?.interaction_model_metrics !== undefined && isNaN(aiScore) !== true;

    const aiReadinessMessage =
      hasInteractionScores !== true ? "Data Readiness not available" : this.getAiReadinessMessage(dataset);

    const dCount = dataset?.suggested_features_count ?? 0;

    const isWarning = hasInteractionScores !== true || aiStatus === "LOW_SIGNAL" || aiStatus === "SUSPECT_SIGNAL";

    return (
      <div
        id={"dataReadinessSection_" + dataset?.id}
        className={isOpenAIReadiness ? styles.openOverview : styles.overview}
        style={{
          maxHeight: isOpenAIReadiness ? undefined : "190px",
          width: "100%",
          overflow: isOpenAIReadiness ? "auto" : "hidden"
        }}
        onClick={isOpenAIReadiness !== true ? () => this.toggleIsOpenTile(dataset?.id, "AI Readiness") : () => {}}
      >
        <div className={styles.senseTitle}>
          <div className={styles.sTitle}>
            <div
              className={styles.sIcon + " " + (false && isGray ? styles.sIconGray : "")}
              style={isWarning || isGray ? { color: "#F8CD7E" } : {}}
            >
              <FontAwesomeIcon icon={isWarning || isGray ? faExclamationTriangle : faCheckCircle} />
            </div>
            {isOpenAIReadiness ? aiReadinessMessage : aiReadinessMessage?.split(". ")[0]}
          </div>
          {isOpenAIReadiness ? (
            <div
              id={"dataReadinessSectionClose_" + dataset?.id}
              className={styles.closeButton}
              onClick={() => this.toggleIsOpenTile(dataset?.id, "AI Readiness")}
            >
              <Button style={{ padding: "3px" }}>
                <div className={styles.selIcon} title="Close">
                  <FontAwesomeIcon icon={faCompressArrowsAlt} />
                </div>
              </Button>
            </div>
          ) : (
            <div className={styles.selIcon + " " + styles.expandIcon}>
              <FontAwesomeIcon icon={faExpandArrowsAlt} />
            </div>
          )}
        </div>
        <div>
          <div
            className={styles.overviewGroup}
            style={{
              marginTop: "0px",
              alignItems: "flex-start",
              width: "100%"
            }}
          >
            <div className={styles.overviewItem} style={{ width: "130px", marginTop: "20px", minHeight: "125px" }}>
              <div className={styles.overviewTop}>{this.renderAIReadinessTooltip(dataset)}</div>
              {hasInteractionScores === true && (
                <div className={styles.muscleChartSmall} style={{ height: "110px", pointerEvents: "none" }}>
                  <SensePieChart score={aiScore} status={aiStatus} barColor={isGray ? "#F8CD7E" : undefined} isLarge />
                </div>
              )}
              <div className={styles.overviewLargeCenter}>
                {hasInteractionScores !== true ? (
                  <div className={styles.noInteractions}>
                    {"Data Readiness is not available. Please try using a " +
                      "dataset with less columns/rows, or try uploading the dataset to Spark."}
                  </div>
                ) : aiScore.toFixed(1) === "10.0" ? (
                  10
                ) : (
                  aiScore.toFixed(1)
                )}
              </div>
            </div>
            <div
              id={"usefulVariablesSection_" + dataset?.id}
              className={styles.overviewItem}
              style={{ marginTop: "20px", minHeight: "125px" }}
            >
              <div className={styles.overviewTop}>{"USEFUL VARIABLES FOUND"}</div>
              <div className={styles.overviewLarge + " " + styles.hFlex} style={{ minHeight: "105px" }}>
                <div className={styles.muscleChartSmall}>
                  <span style={{ marginRight: isLowPredictors ? "6px" : undefined }}>
                    {predictors ? predictors.length : "..."}
                  </span>
                  {isLowPredictors && (
                    <Tooltip
                      trigger={["hover"]}
                      overlay={
                        <div style={{ maxWidth: "250px" }}>
                          {`There are less than 6 useful variables found for ${
                            dataset?.outcome ?? "the outcome"
                          }. Adding more data may increase this number and improve the quality of the insights and AI models.`}
                        </div>
                      }
                    >
                      <Icon type={"warningYellow"} />
                    </Tooltip>
                  )}
                </div>
                {predictors ? (
                  <div className={styles.predictorChart}>
                    {predictors.map((p, i) => {
                      if (!isOpenAIReadiness && i >= 15) {
                        return <React.Fragment />;
                      }

                      const barHeight = isOpenAIReadiness
                        ? Math.ceil(50 / predictors.length)
                        : Math.max(3, Math.ceil(50 / predictors.length));

                      const isProblematicPredictor = Boolean(
                        problematicPredictors?.find(
                          (prob) =>
                            prob?.label === p?.label || prob?.label === p?.keys?.[0] || prob?.label === p?.keys?.[1]
                        )
                      );

                      return (
                        <div
                          className={styles.predictorBar}
                          style={{
                            width: p.value * 100 + "%",
                            height: barHeight,
                            background: isProblematicPredictor ? "#F8CD7E" : undefined
                          }}
                          title={p.label}
                          key={"bar_" + i}
                        />
                      );
                    })}
                    {!isOpenAIReadiness && predictors.length > 15 && (
                      <div className={styles.predictorOverflowLabel}>{"Show all " + predictors?.length}</div>
                    )}
                  </div>
                ) : (
                  <div />
                )}
              </div>
            </div>
          </div>
        </div>
        {isOpenAIReadiness && this.renderOpenAIReadiness("AI READINESS", dataset)}

        {isOpenAIReadiness && (
          <div className={styles.suggestedFields}>
            <div className={styles.suggestedFieldsHeader}>
              <span className={styles.sIcon}>
                <img src={BellIcon} style={{ height: "20px", width: "20px" }} />
              </span>
              {dCount + " Aible Recommended Derived Fields"}
            </div>
            <div
              style={{ marginTop: "10px", marginBottom: "10px" }}
              className={styles.purpleA}
              onClick={() =>
                this.setState({
                  isShowDerived: {
                    ...isShowDerived,
                    [dataset?.id]: !isShowDerived?.[dataset?.id]
                  }
                })
              }
            >
              {isShowDerived?.[dataset?.id] === true
                ? "Collapse All Recommended Fields"
                : "View All Recommended Fields"}
            </div>
            {isShowDerived?.[dataset?.id] === true && (
              <div className={styles.autoDerivedList}>{this.renderAuto(dataset)}</div>
            )}
          </div>
        )}
        {isOpenAIReadiness ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%"
            }}
          >
            {isTransformSaving === dataset?.id ? (
              <LoadingIndicator style={{ margin: "0px" }} />
            ) : (
              <Button
                type="primary"
                onClick={() => {
                  //copyTransformFromSetup(dataset?.id, `data_${dataset?.id}`);

                  const tQuery = this.getTransformQuery(dataset);

                  copyAndApplyTransformations(
                    dataset?.id,
                    tQuery,
                    this.state.transformDataName[dataset?.id] || "Transformed_" + dataset?.label
                  );

                  this.setState({ isTransformSaving: dataset?.id });
                  setTimeout(() => this.setState({ isTransformSaving: false }), 5000);
                }}
                disabled={
                  dataset?.ignored &&
                  Object.keys(dataset?.ignored).filter((k) => dataset?.ignored[k] === true).length === 0 &&
                  (allTransforms?.[dataset?.id] === undefined || allTransforms?.[dataset?.id].length === 0)
                }
              >
                {"Apply and Refresh Analysis"}
              </Button>
            )}
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }

  getIsTopInsights(datasetId) {
    return this.state?.isTopInsights?.[datasetId] ?? false;
  }

  getIsTargetModelOptionsOpen(datasetId) {
    return this.state?.isTargetModelOptionsOpen?.[datasetId] === true;
  }

  getIsOpenTile(datasetId, tileKey) {
    // BAD HACK
    if (tileKey === "Transformations") {
      return this.state?.isOpenTransform === datasetId;
    }

    return this.state?.isOpenTile?.[datasetId]?.[tileKey];
  }

  getIsTileOpacity(datasetId, tileKey) {
    return this.state?.isTileOpacity?.[datasetId]?.[tileKey];
  }

  setIsTopInsight(datasetId, value) {
    const { isTopInsights } = this.state ?? {};

    this.setState({
      isTopInsights: {
        ...isTopInsights,
        [datasetId]: value
      }
    });
  }

  setIsTargetModelOptionsOpen(datasetId, value) {
    const { isTargetModelOptionsOpen } = this.state ?? {};

    this.setState({
      isTargetModelOptionsOpen: {
        ...isTargetModelOptionsOpen,
        [datasetId]: value
      }
    });
  }

  toggleIsOpenTile(datasetId, tileKey) {
    const { isOpenTile, isTileOpacity, isOpenTransform, joinData } = this.state;

    setTimeout(
      () =>
        this.setState({
          isTileOpacity: {
            ...isTileOpacity,
            [datasetId]: {
              ...isTileOpacity?.[datasetId],
              [tileKey]: false
            }
          }
        }),
      50
    );

    // BAD HACK
    if (tileKey === "Transformations") {
      if (isOpenTransform === datasetId) {
        return this.setState({
          isOpenTransform: undefined,
          isTileOpacity: {
            ...isTileOpacity,
            [datasetId]: {
              ...isTileOpacity?.[datasetId],
              [tileKey]: true
            }
          }
        });
      } else {
        return this.setState({
          isOpenTransform: datasetId,
          isTileOpacity: {
            ...isTileOpacity,
            [datasetId]: {
              ...isTileOpacity?.[datasetId],
              [tileKey]: true
            }
          },
          joinData: {
            ...joinData,
            [datasetId]: {
              ...joinData?.[datasetId],
              ["lookupKeys"]: joinData?.[datasetId]?.lookupKeys || {
                [0]: { left: undefined, right: undefined }
              }
            }
          }
        });
      }
    }

    return this.setState({
      isOpenTile: {
        ...isOpenTile,
        [datasetId]: {
          ...isOpenTile?.[datasetId],
          [tileKey]: !isOpenTile?.[datasetId]?.[tileKey]
        }
      },
      isTileOpacity: {
        ...isTileOpacity,
        [datasetId]: {
          ...isTileOpacity?.[datasetId],
          [tileKey]: true
        }
      }
    });
  }

  renderMiniInsights(dataset) {
    const { openExploration, isTableauMode } = this.props;
    const { isOpenTile, isTileOpacity, isLoadingExplore, outcomeSuccess, expandedDataset } = this.state;
    const insightCount = this.calcInsightNumber(dataset);

    const isTopInsights = this.getIsTopInsights(dataset?.id);
    const isOpenInsights = this.getIsOpenTile(dataset?.id, "Insights");
    const isOpenAIReadiness = this.getIsOpenTile(dataset?.id, "AI Readiness");
    const isTransparent = this.getIsTileOpacity(dataset?.id, "Insights");

    const hasRefreshRate = dataset?.source?.content?.type === "CONNECTION_METADATA";
    const refreshRate = dataset?.datasetRefreshSchedule;

    const outcomeOptions =
      dataset?.fields?.[dataset?.outcome]?.type !== "number" && dataset?.fields?.[dataset?.outcome]?.data
        ? dataset?.fields?.[dataset?.outcome]?.data.map((d) => ({
            value: d,
            label: d.value
          }))
        : undefined;

    const outcomeValue = outcomeSuccess?.[dataset?.id] || outcomeOptions?.[0];

    return (
      <div
        id={"insightsSection_" + dataset?.id}
        className={isOpenInsights ? styles.openOverview : styles.overview}
        style={{
          height: isOpenInsights ? "610px" : "190px",
          width: "100%",
          // marginLeft: isOpenInsights || isOpenAIReadiness ? "10px" : "0px",
          // marginRight: "0px",
          position: "relative"
        }}
        onClick={isOpenInsights !== true ? () => this.toggleIsOpenTile(dataset?.id, "Insights") : () => {}}
      >
        <div className={styles.overviewItem}>
          <div className={styles.senseTitle}>
            <div className={styles.sTitle} style={isOpenInsights !== true ? { width: "100%" } : {}}>
              <span className={styles.sIcon}>
                <img src={CompassIcon} style={{ height: "16px", width: "16px" }} />
              </span>
              <span>
                {isOpenInsights && false
                  ? `${insightCount} Potential Insight${insightCount === 1 ? "" : "s"} Found`
                  : "Insights"}
              </span>
            </div>
            {isOpenInsights ? (
              <div style={{ display: "flex" }}>
                <div
                  id={"insightsSectionClose_" + dataset?.id}
                  className={styles.closeButton}
                  onClick={() => this.toggleIsOpenTile(dataset?.id, "Insights")}
                >
                  <Button style={{ padding: "3px" }}>
                    <div className={styles.selIcon} title="Close">
                      <FontAwesomeIcon icon={faCompressArrowsAlt} />
                    </div>
                  </Button>
                </div>
              </div>
            ) : (
              <div className={styles.expandIcon}>
                <div className={styles.selIcon}>
                  <FontAwesomeIcon icon={faExpandArrowsAlt} />
                </div>
              </div>
            )}
          </div>
          <div className={styles.insightsContent}>
            <div
              className={styles.muscleChartWrapper}
              style={{
                width: isOpenInsights ? "100%" : undefined
              }}
            >
              <div className={styles.insightsTitle} style={isOpenInsights ? { color: "#4B495B" } : undefined}>
                {"Top Factors"}
              </div>
              <div
                className={styles.muscleChartInsights}
                style={{
                  height: isOpenInsights ? "300px" : "140px",
                  overflow: isOpenInsights ? undefined : "hidden",
                  marginTop: isOpenInsights ? "100px" : undefined,
                  marginBottom: isOpenInsights ? "85px" : "0px",
                  fontSize: "12px"
                }}
              >
                <LeakageChartContainer
                  id={"new"}
                  datasetId={dataset?.id}
                  isHoverInsights={isOpenInsights}
                  isMedium
                  isSenseTile
                  isGoogleSense
                  hideChords={isOpenInsights !== true}
                  isTopInsights={isTopInsights}
                />
                {isOpenInsights !== true && (
                  <div
                    className={styles.overviewLargeCenterInsight}
                    style={
                      insightCount < 10
                        ? {
                            top: "55px"
                          }
                        : {
                            top: "55px"
                          }
                    }
                  >
                    {insightCount}
                  </div>
                )}
              </div>
              {isOpenInsights &&
                (isEnabled("aible-optimize") || isEnabled("aible-explore") || Boolean(isTableauMode)) && (
                  <div className={styles.exploreButton}>
                    {isLoadingExplore?.[dataset?.id] === true ? (
                      <LoadingIndicator
                        style={{
                          margin: "0px",
                          marginTop: "-60px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          position: "absolute"
                        }}
                      />
                    ) : (
                      <Button
                        onClick={() => {
                          this.setState({
                            isLoadingExplore: {
                              ...isLoadingExplore,
                              [dataset?.id]: true
                            }
                          });
                          setTimeout(() => openExploration(dataset?.id, outcomeValue), 5);
                        }}
                        className={styles.exploreButtonHover}
                        style={{ width: "100%" }}
                      >
                        {"Explore Insights"}
                      </Button>
                    )}
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderDataValidation(dataset) {
    const { expandedDataset } = this.state;

    const isReady = dataset?.rowCount !== -1;
    const isProcessing = dataset?.status_name !== "DONE";
    const isError = dataset?.dataset_status === "ERROR";

    const isDataValidationReady = dataset?.status_name === "DONE" || dataset?.outcome !== undefined;

    const updatedColumns = (dataset && dataset.warnings) || [];
    const groupedUpdates = parseValidation(updatedColumns);

    const pNumber = isError
      ? 0
      : dataset?.status_name === "DONE" || dataset?.outcome
        ? DATA_CHECKS.length - groupedUpdates.length
        : 0;
    const aNumber = groupedUpdates.length;

    let passedTests = [];
    for (let i = 0; i < DATA_CHECKS.length; i++) {
      passedTests.push(<div className={i < pNumber ? styles.greenCircle : styles.grayCircle} />);
    }

    let correctedTests = [];
    for (let i = 0; i < DATA_CHECKS.length; i++) {
      correctedTests.push(
        <div className={isError ? styles.grayCircle : i < pNumber ? styles.grayCircle : styles.yellowCircle} />
      );
    }

    let failedTests = [];
    for (let i = 0; i < DATA_CHECKS.length; i++) {
      failedTests.push(<div className={styles.grayCircle} />);
    }

    const isOpenDataValidation = this.getIsOpenTile(dataset?.id, "Data Validation");
    const isOpenSettings = this.getIsOpenTile(dataset?.id, "Settings");
    const isOpenLineage = this.getIsOpenTile(dataset?.id, "Lineage");
    return (
      <div
        id={"dataQualityValidationSection_" + dataset?.id}
        className={isOpenDataValidation ? styles.openOverview : styles.overview}
        style={{
          width: "100%",
          maxHeight: isOpenDataValidation ? "500px" : expandedDataset !== undefined ? "190px" : "150px",
          overflow: isOpenDataValidation ? "auto" : "hidden",
          zIndex: 5
        }}
        onClick={isOpenDataValidation !== true ? () => this.toggleIsOpenTile(dataset?.id, "Data Validation") : () => {}}
      >
        <div className={styles.senseTitle} style={{ alignItems: "center", lineHeight: "16px" }}>
          <div className={styles.sTitle}>
            <span
              className={styles.sIcon}
              style={
                isError ? { color: "#F8CD7E" } : isDataValidationReady != true ? { color: "rgb(200, 202, 212)" } : {}
              }
            >
              {isError ? (
                <div />
              ) : isDataValidationReady ? (
                <img src={HeartIcon} style={{ height: "16px", width: "16px" }} />
              ) : isProcessing ? (
                <LoadingIndicator
                  style={{
                    margin: "0px",
                    marginTop: "-5px",
                    height: "0px",
                    width: "50px",
                    transform: "scale(0.5)"
                  }}
                />
              ) : (
                <FontAwesomeIcon icon={faCircle} />
              )}
            </span>
            <span style={{ color: "#868595" }}>{"Data Quality"}</span>
          </div>
          {isOpenDataValidation ? (
            <div
              id={"dataQualityValidationSectionClose_" + dataset?.id}
              className={styles.closeButton}
              onClick={() => this.toggleIsOpenTile(dataset?.id, "Data Validation")}
            >
              <Button style={{ padding: "3px" }}>
                <div className={styles.selIcon} title="Close">
                  <FontAwesomeIcon icon={faCompressArrowsAlt} />
                </div>
              </Button>
            </div>
          ) : (
            <div className={styles.expandIcon}>
              <div className={styles.selIcon}>
                <FontAwesomeIcon icon={faExpandArrowsAlt} />
              </div>
            </div>
          )}
        </div>
        {!isOpenDataValidation ? (
          <div className={styles.tileFlex}>
            <div className={styles.tTop}>
              {isError || isDataValidationReady ? (
                <span className={styles.sIcon}>
                  <FontAwesomeIcon
                    icon={isError ? faExclamationTriangle : isDataValidationReady ? faCheckCircle : faInfo}
                  />
                </span>
              ) : (
                <React.Fragment />
              )}
            </div>
            <div className={styles.tBot}>
              {isError ? "Incomplete" : isDataValidationReady ? "Passed" : isProcessing ? "..." : "Not Started"}
            </div>
          </div>
        ) : (
          <React.Fragment>
            <div className={styles.overviewGroup}>
              <div className={styles.overviewItem}>
                <div className={styles.overviewLarge}>{pNumber}</div>
                <div className={styles.overviewTop + " " + styles.twoLines}>{"QUALITY TESTS PASSED"}</div>
                <div className={styles.overviewBot}>
                  <div className={styles.circleHolder} style={{ marginTop: "5px" }}>
                    {passedTests}
                  </div>
                </div>
              </div>
              <div className={styles.overviewItem}>
                <div className={styles.overviewLarge}>{aNumber}</div>
                <div className={styles.overviewTop + " " + styles.twoLines}>{"ISSUES AUTOCORRECTED"}</div>
                <div className={styles.overviewBot}>
                  <div className={styles.circleHolder} style={{ marginTop: "5px" }}>
                    {correctedTests}
                  </div>
                </div>
              </div>
              <div className={styles.overviewItem}>
                <div className={styles.overviewLarge}>{isError ? 8 : 0}</div>
                <div className={styles.overviewTop + " " + styles.twoLines}>{"TESTS FAILED"}</div>
                <div className={styles.overviewBot}>
                  <div className={styles.circleHolder} style={{ marginTop: "5px" }}>
                    {failedTests}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className={styles.qItem}>
                <ReviewDatasetItem
                  icon={
                    isError ? (
                      <span className={styles.sIcon}>
                        <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#F8CD7E" }} />
                      </span>
                    ) : (
                      <span className={styles.sIcon}>
                        <FontAwesomeIcon icon={faCheckCircle} />
                      </span>
                    )
                  }
                  reviewHeaderStyle={{ margin: "0px" }}
                  text={dataset?.fields ? Object.keys(dataset.fields).length + " columns scanned" : "..."}
                  overlayTitle={"Columns"}
                  overlay={
                    dataset?.fields ? (
                      <div className={styles.datasetReviewPopup}>
                        {Object.keys(dataset.fields).map((w, i) => (
                          <div className={styles.datasetReviewRow} key={i + w}>
                            <span>{w}</span>
                          </div>
                        ))}
                      </div>
                    ) : undefined
                  }
                  overlayIcon={
                    <div className={styles.aireadinessIcon + " " + styles.isInfo}>
                      <FontAwesomeIcon icon={faInfo} />
                    </div>
                  }
                />
              </div>
              <div className={styles.qItem}>
                {isError ? (
                  <span className={styles.sIcon}>
                    <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#F8CD7E" }} />
                  </span>
                ) : (
                  <span className={styles.sIcon}>
                    <FontAwesomeIcon icon={faCheckCircle} />
                  </span>
                )}
                <span>
                  {isError
                    ? "Row scan incomplete"
                    : dataset?.rowCount === -1
                      ? "Row scan completed (select outcome to see total)"
                      : dataset?.rowCount + " rows scanned"}
                </span>
              </div>
              <div className={styles.qItem}>
                <ReviewDatasetItem
                  icon={
                    isError ? (
                      <span className={styles.sIcon}>
                        <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#F8CD7E" }} />
                      </span>
                    ) : (
                      <span className={styles.sIcon}>
                        <FontAwesomeIcon icon={faCheckCircle} />
                      </span>
                    )
                  }
                  reviewHeaderStyle={{ margin: "0px" }}
                  text={
                    getPrettyNumber(isError ? 0 : DATA_CHECKS.length) +
                    "  " +
                    handlePlurals(isError ? 0 : DATA_CHECKS.length, "data check") +
                    " completed"
                  }
                  overlayTitle={"Data Checks"}
                  overlay={
                    <div className={styles.datasetReviewPopup}>
                      {DATA_CHECKS.map((w, i) => (
                        <ReviewDatasetItem
                          text={w}
                          key={i + w}
                          icon={
                            isError ? (
                              <span className={styles.sIcon}>
                                <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#F8CD7E" }} />
                              </span>
                            ) : undefined
                          }
                        />
                      ))}
                    </div>
                  }
                  overlayIcon={
                    <div className={styles.aireadinessIcon + " " + styles.isInfo}>
                      <FontAwesomeIcon icon={faInfo} />
                    </div>
                  }
                />
              </div>
              {groupedUpdates.map((update, i) => {
                const updateText =
                  getPrettyNumber(update.value.length) +
                  " " +
                  (handlePlurals(update.value.length, update.type, update.noPlural) + " " + update.action);
                return (
                  <div className={styles.qItem + " " + styles.indent} key={"review-" + i}>
                    <ReviewDatasetItem
                      key={update.type + i}
                      text={<strong>{updateText}</strong>}
                      overlayTitle={updateText}
                      overlay={
                        <div className={styles.datasetReviewPopup}>
                          {update.value.map((w, i) => (
                            <div className={styles.datasetReviewRow} key={i + w}>
                              <span>{w}</span>
                            </div>
                          ))}
                        </div>
                      }
                      overlayIcon={
                        <div className={styles.aireadinessIcon + " " + styles.isInfo}>
                          <FontAwesomeIcon icon={faInfo} />
                        </div>
                      }
                    />
                  </div>
                );
              })}
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }

  renderDataEvaluated(dataset, showBorder = false) {
    const isReady = dataset?.rowCount !== -1;
    const isProcessing = dataset?.status_name !== "DONE";
    const isError = dataset?.dataset_status === "ERROR";
    const isWideDatasetWarning = dataset?.wideDatasetWarning;
    const dCount = dataset?.suggested_features_count ?? 0;

    const isOpenDataEvaluated = this.getIsOpenTile(dataset?.id, "Data Evaluated");
    const isOpenTransformations = this.getIsOpenTile(dataset?.id, "Transformations");

    const dateFieldOptions =
      dataset?.ranked_fields !== undefined
        ? dataset.ranked_fields
            .filter((f) => f.type === "date")
            .map((f) => ({
              value: f,
              label: f.label
            }))
        : [];

    const isDisabled =
      true ||
      !(isEnabled("dataset-whats-changed") || isEnabled("test-train-split")) ||
      isError ||
      isProcessing ||
      dataset?.rowCount === undefined ||
      dataset?.rowCount === -1 ||
      dateFieldOptions.length === 0;

    return (
      <div
        id={"totalDataEvaluatedSection_" + dataset?.id}
        className={
          (isOpenDataEvaluated ? styles.openOverview : styles.overview) + " " + (isDisabled ? styles.isDisabled : "")
        }
        style={{
          width: "100%",
          maxHeight: isOpenDataEvaluated ? "700px" : "150px",
          overflow: isOpenDataEvaluated ? "auto" : "hidden",
          zIndex: 5
        }}
        onClick={
          isOpenDataEvaluated !== true && !isDisabled
            ? () => this.toggleIsOpenTile(dataset?.id, "Data Evaluated")
            : () => {}
        }
      >
        <div className={styles.senseTitle} style={{ alignItems: "center", lineHeight: "16px" }}>
          <div className={styles.sTitle}>
            {isError ? (
              <span className={styles.sIcon}>
                <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#F8CD7E" }} />
              </span>
            ) : isReady && isProcessing !== true ? (
              <span className={styles.sIcon}>
                <img src={RadarIcon} style={{ height: "16px", width: "16px" }} />
              </span>
            ) : isProcessing === true ? (
              <LoadingIndicator
                style={{
                  margin: "0px",
                  marginTop: "-5px",
                  marginRight: "5px",
                  height: "0px",
                  width: "50px",
                  transform: "scale(0.5)"
                }}
              />
            ) : (
              <span className={styles.sIcon}>
                <FontAwesomeIcon icon={faCircle} style={{ color: "rgb(200, 202, 212)" }} />
              </span>
            )}
            <span style={{ width: "calc(100% - 50px)", color: "#868595" }}>
              {isError ? "Data Evaluation Incomplete" : isProcessing ? "Evaluating Data..." : "Total Data Evaluated"}
            </span>
          </div>
          {isOpenDataEvaluated ? (
            <div
              id={"totalDataEvaluatedSectionClose_" + dataset?.id}
              className={styles.closeButton}
              onClick={() => this.toggleIsOpenTile(dataset?.id, "Data Evaluated")}
            >
              {isDisabled ? (
                <div />
              ) : (
                <Button style={{ padding: "3px" }}>
                  <div className={styles.selIcon} title="Close">
                    <FontAwesomeIcon icon={faCompressArrowsAlt} />
                  </div>
                </Button>
              )}
            </div>
          ) : (
            <div className={styles.expandIcon}>
              {isDisabled ? (
                <div />
              ) : (
                <div className={styles.selIcon}>
                  <FontAwesomeIcon icon={faExpandArrowsAlt} />
                </div>
              )}
            </div>
          )}
        </div>
        <div className={styles.overviewGroup}>
          <div className={styles.overviewItem}>
            <div className={styles.overviewMedium}>
              {dataset?.rowCount !== undefined && dataset?.rowCount !== -1
                ? numeral(dataset?.rowCount).format("0.0a")
                : "..."}
            </div>
            <div className={styles.overviewTop}>{"ROWS"}</div>
          </div>
          <div className={styles.overviewItem}>
            <div className={styles.overviewMedium}>
              {dataset?.fields && Object.keys(dataset.fields).length > 0
                ? isWideDatasetWarning
                  ? dataset?.wideDatasetColumnCount
                  : Object.keys(dataset.fields).length
                : "..."}
            </div>
            <div className={styles.overviewTop}>{"COLUMNS"}</div>
          </div>
          {/* <div className={styles.overviewItem}>
            <div className={styles.overviewMedium}> </div>
            <div className={styles.overviewTop}> </div>
          </div> */}
        </div>
        {isOpenDataEvaluated && this.renderDataCollection(dataset)}
      </div>
    );
  }

  renderDerivedWarning(key, dataset) {
    const dCount = dataset?.suggested_features_count ?? 0;

    return (
      <div className={styles.derivedWarning}>
        <div className={styles.bold}>{dCount + " Derived Columns Recommended"}</div>
        <div style={{ marginTop: "10px" }}>
          {`Aible found ${dCount} derived variables that could increase the AI score. ` +
            "Would you like to add the recommended variables?"}
        </div>
        <div className={styles.circleHolder} style={{ marginTop: "10px" }}>
          <div style={{ marginRight: "10px" }}>
            <a onClick={() => this.setState({ [key]: "REVIEW RECOMMENDATIONS" })}>{"Review Recommendatons"}</a>
          </div>
          <Button style={{ marginLeft: "10px" }}>{"Refresh Evaluation"}</Button>
        </div>
      </div>
    );
  }

  renderMuscleChart(dataset) {
    const insightCount = this.calcInsightNumber(dataset);

    return (
      <div className={styles.muscle}>
        <div className={styles.mHeader} style={{ marginTop: "20px" }}>
          <span className={styles.sIcon}>
            <FontAwesomeIcon
              icon={insightCount === 0 ? faCircle : faCheckCircle}
              style={insightCount === 0 ? { color: "rgb(200, 202, 212)" } : {}}
            />
          </span>
          {insightCount + " Recommended insights found"}
        </div>
        {insightCount > 0 && (
          <div className={styles.muscleChart}>
            <LeakageChartContainer id={"new"} datasetId={dataset?.id} isSense />
          </div>
        )}
      </div>
    );
  }
}
